// noinspection JSUnusedGlobalSymbols
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigDecimal: { input: string; output: string };
  CountryCode: { input: string; output: string };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSON: { input: unknown; output: unknown };
  Long: { input: number; output: number };
  Url: { input: string; output: string };
  Year: { input: string; output: string };
  YearMonth: { input: string; output: string };
};

/** Full detail of an AI assistant configuration (admin only). */
export type AiAssistantConfigurationDetailType = {
  __typename?: 'AIAssistantConfigurationDetailType';
  /** Whether this configuration is currently active. */
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Description of the configuration. */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  model: AiAssistantModel;
  /** The model ID used for generation. */
  modelId: Scalars['String']['output'];
  /** Display name of the configuration. */
  name: Scalars['String']['output'];
  /** System instruction prompt. */
  systemInstruction: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Usage context of the configuration. */
  usage: AiAssistantUsage;
};

/** Summary of an active AI assistant configuration. */
export type AiAssistantConfigurationSummaryType = {
  __typename?: 'AIAssistantConfigurationSummaryType';
  /** Whether this configuration is currently active. */
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Whether this configuration can be deleted (false if used in any chat session). */
  deletable: Scalars['Boolean']['output'];
  /** Description of the configuration. */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  model: AiAssistantModel;
  /** The model ID used for generation. */
  modelId: Scalars['String']['output'];
  /** Display name of the configuration. */
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Usage context of the configuration. */
  usage: AiAssistantUsage;
};

/** Enabled state of the AI assistant for a specific usage context. */
export type AiAssistantEnabled = {
  __typename?: 'AIAssistantEnabled';
  createdAt: Scalars['DateTime']['output'];
  /** Whether the AI assistant is enabled for this usage context. */
  enabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The usage context this flag applies to. */
  usage: AiAssistantUsage;
};

export type AiAssistantModel = {
  __typename?: 'AIAssistantModel';
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  releaseDate: Scalars['Date']['output'];
};

export enum AiAssistantUsage {
  PerformanceReviewMyMission = 'PERFORMANCE_REVIEW_MY_MISSION',
}

/** A streaming chunk from the AI chat response. */
export type AiChatChunk = {
  __typename?: 'AIChatChunk';
  /** The text chunk emitted by the model. */
  chunk: Scalars['String']['output'];
  /** Whether this is the final chunk in the stream. */
  done: Scalars['Boolean']['output'];
  /** The chat session ID. */
  sessionId: Scalars['String']['output'];
};

/** A single message within a restored chat session. */
export type AiChatMessage = {
  __typename?: 'AIChatMessage';
  content: Scalars['String']['output'];
  role: AiChatMessageRole;
};

export enum AiChatMessageRole {
  Model = 'MODEL',
  User = 'USER',
}

/** An unfinished chat session with its full message history. */
export type AiChatSession = {
  __typename?: 'AIChatSession';
  messages: Array<AiChatMessage>;
  /** The session ID to pass on subsequent messages. */
  sessionId: Scalars['String']['output'];
};

/** Summary of a past chat session for the history list. */
export type AiChatSessionSummary = {
  __typename?: 'AIChatSessionSummary';
  /** ISO-8601 timestamp of the first message (or session creation if no messages). */
  firstMessageAt: Scalars['DateTime']['output'];
  /** ISO-8601 timestamp of the last message (or session creation if no messages). */
  lastMessageAt: Scalars['DateTime']['output'];
  lastMessageFirstLine?: Maybe<Scalars['String']['output']>;
  /** The session ID to pass to aiChatSession or streamMissionChat. */
  sessionId: Scalars['String']['output'];
};

export type AbstractListEmployeeAlerts = {
  countByPriority: EmployeeAlertCountByPriority;
  totalCount: Scalars['Int']['output'];
};

/** A single key area's comment for a review check-in. */
export type AddEmployeeIdpKeyAreaReviewCommentInput = {
  comment: Scalars['String']['input'];
  keyAreaId: Scalars['ID']['input'];
};

/** Append review check-in entries across key areas. The review date is set by the backend to today. */
export type AddEmployeeIdpKeyAreaReviewsInput = {
  /** One comment per key area being reviewed. At least one is required. */
  comments: Array<AddEmployeeIdpKeyAreaReviewCommentInput>;
  idpId: Scalars['ID']['input'];
};

export enum AnyMindValueType {
  AchieveTogether = 'ACHIEVE_TOGETHER',
  BeBold = 'BE_BOLD',
  BeOpen = 'BE_OPEN',
  MoveFaster = 'MOVE_FASTER',
  StayUpdated = 'STAY_UPDATED',
}

/** Input for autofilling upcoming Managerial Accounting periods for an employee. */
export type AutofillEmployeeManagerialAccountingInput = {
  backfill: Scalars['Boolean']['input'];
  employeeId: Scalars['ID']['input'];
  force: Scalars['Boolean']['input'];
};

export enum BlankTeamValueVisibility {
  Hide = 'HIDE',
  HidePast = 'HIDE_PAST',
  ShowAll = 'SHOW_ALL',
}

/** Result of a single performance review bulk create operation. */
export type BulkCreatePerformanceReviewResult = {
  __typename?: 'BulkCreatePerformanceReviewResult';
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  performanceReview?: Maybe<PerformanceReview>;
  performanceReviewId?: Maybe<Scalars['ID']['output']>;
  status: BulkCreatePerformanceReviewStatus;
};

export enum BulkCreatePerformanceReviewStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  Skipped = 'SKIPPED',
}

/** Input type for bulk creating performance reviews. */
export type BulkCreatePerformanceReviewsInput = {
  employeeIds: Array<Scalars['ID']['input']>;
  period: PerformanceReviewPeriodInput;
};

/** Output type for bulk creating performance reviews. */
export type BulkCreatePerformanceReviewsOutput = {
  __typename?: 'BulkCreatePerformanceReviewsOutput';
  results: Array<BulkCreatePerformanceReviewResult>;
};

/** Input type to bulk update performance review - Setting - Stage. */
export type BulkUpdatePerformanceReviewStageInput = {
  companyId: Scalars['ID']['input'];
  period: PerformanceReviewPeriodInput;
  stage: PerformanceReviewStage;
};

/** Business unit. */
export type BusinessUnit = ListItem & {
  __typename?: 'BusinessUnit';
  createdAt: Scalars['DateTime']['output'];
  defaultEpmMasterRoleType?: Maybe<EpmMasterRoleType>;
  defaultEpmMasterRoleTypeId?: Maybe<Scalars['ID']['output']>;
  definitions: Array<DefinitionItem>;
  division: Division;
  divisionId: Scalars['ID']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  valueDeliveredDepartment?: Maybe<EpmMasterVdd>;
  vddId?: Maybe<Scalars['ID']['output']>;
};

/** Output type for a business unit. */
export type BusinessUnitOutput = {
  __typename?: 'BusinessUnitOutput';
  businessUnit: BusinessUnit;
  id: Scalars['ID']['output'];
};

/** Company. */
export type Company = ListItem & {
  __typename?: 'Company';
  acquiredDate?: Maybe<Scalars['Date']['output']>;
  activeEmployeeCount: Scalars['Long']['output'];
  /** This Company's registered child Companies. */
  childrenCompanies: Array<Company>;
  country: Country;
  countryId: Scalars['CountryCode']['output'];
  createPerformanceReviewAutomatically: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  googleOrgUnitPath: Scalars['String']['output'];
  hrEmailAddress: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitleCanBeEmpty: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** This Company's registered parent Company, if one exists. */
  parentCompany?: Maybe<Company>;
  preferredLanguage: Scalars['String']['output'];
  probationReviewTerm: CompanyProbationReviewTerm;
  probationReviewTimes: Scalars['Int']['output'];
  /** Slack workspace associated with this company. */
  slackTeam?: Maybe<EmployeeExternalAccountSlackWorkspace>;
  slackTeamId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Result of a company email availability check. */
export type CompanyEmailAvailabilityResult = {
  __typename?: 'CompanyEmailAvailabilityResult';
  available: Scalars['Boolean']['output'];
  /** IDs of INACTIVE employees whose company email will be cleared when this email address is used for a new employee. */
  clearingEmployeeIds: Array<Scalars['ID']['output']>;
  /** INACTIVE employees whose company email will be cleared when this email address is used for a new employee. */
  clearingEmployees: Array<Employee>;
  unavailableReason?: Maybe<CompanyEmailUnavailableReason>;
};

/** Company email domain. */
export type CompanyEmailDomain = ListItem & {
  __typename?: 'CompanyEmailDomain';
  /** Whether this domain currently appears in the live AWS SES recipient-domain restriction. System-computed only, reconciled once per day — not editable via updateCompanyEmailDomain. */
  awsSesPolicyApplied: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  disableExternalAccount: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Output type for a company domain email. */
export type CompanyEmailDomainOutput = {
  __typename?: 'CompanyEmailDomainOutput';
  companyEmailDomain: CompanyEmailDomain;
  id: Scalars['ID']['output'];
};

/** Reason why a company email address is not available. */
export enum CompanyEmailUnavailableReason {
  ApiUnavailable = 'API_UNAVAILABLE',
  InvalidFormat = 'INVALID_FORMAT',
  InUseGoogleWorkspace = 'IN_USE_GOOGLE_WORKSPACE',
  InUseMed = 'IN_USE_MED',
  Unknown = 'UNKNOWN',
}

/** Output type for a company. */
export type CompanyOutput = {
  __typename?: 'CompanyOutput';
  company: Company;
  id: Scalars['ID']['output'];
};

/** Company - probation review term. */
export type CompanyProbationReviewTerm = {
  __typename?: 'CompanyProbationReviewTerm';
  length: Scalars['Int']['output'];
  mode: CompanyProbationReviewTermMode;
};

/** Company - probation review term. */
export type CompanyProbationReviewTermInput = {
  length: Scalars['Int']['input'];
  mode: CompanyProbationReviewTermMode;
};

export enum CompanyProbationReviewTermMode {
  Day = 'DAY',
  Month = 'MONTH',
}

/** Confirm an IDP once its key areas are finalized. Locks the auto-populated snapshot fields and key areas. */
export type ConfirmEmployeeIdpInput = {
  idpId: Scalars['ID']['input'];
};

export enum ContractType {
  Contractor = 'CONTRACTOR',
  FtConsultant = 'FT_CONSULTANT',
  FtFixedTerm = 'FT_FIXED_TERM',
  FtFreelancer = 'FT_FREELANCER',
  FtPermanent = 'FT_PERMANENT',
  Intern = 'INTERN',
  PartTime = 'PART_TIME',
}

/** Contract type. */
export type ContractTypeWithDisplayName = EnumWithDisplayName & {
  __typename?: 'ContractTypeWithDisplayName';
  defaultGoogleWorkspacePlan?: Maybe<GoogleProductAndSkuWithDisplayName>;
  displayName: Scalars['String']['output'];
  greenhouseLinkCanBeEmpty: Scalars['Boolean']['output'];
  jobTitleShouldBeEmpty: Scalars['Boolean']['output'];
  value: ContractType;
};

/** Country. */
export type Country = ListItem & {
  __typename?: 'Country';
  companies: Array<Company>;
  createdAt: Scalars['DateTime']['output'];
  demonym: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** International dialing code in format +[1-3 digits]. */
  isdCode?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CreateAiAssistantConfigurationInput = {
  description: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  systemInstruction: Scalars['String']['input'];
  usage: AiAssistantUsage;
};

export type CreateAiAssistantConfigurationOutput = {
  __typename?: 'CreateAIAssistantConfigurationOutput';
  id: Scalars['ID']['output'];
};

/** Input type to create a business unit. */
export type CreateBusinessUnitInput = {
  defaultEpmMasterRoleTypeId?: InputMaybe<Scalars['ID']['input']>;
  definitions?: InputMaybe<Array<DefinitionInput>>;
  divisionId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  vddId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input type to create a company domain email. */
export type CreateCompanyEmailDomainInput = {
  disableExternalAccount: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

/** Input type to create a company. */
export type CreateCompanyInput = {
  acquiredDate?: InputMaybe<Scalars['Date']['input']>;
  countryId: Scalars['CountryCode']['input'];
  createPerformanceReviewAutomatically: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  googleOrgUnitPath: Scalars['String']['input'];
  hrEmailAddress: Array<Scalars['String']['input']>;
  jobTitleCanBeEmpty: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  parentCompanyId?: InputMaybe<Scalars['ID']['input']>;
  preferredLanguage: Scalars['String']['input'];
  probationReviewTerm: CompanyProbationReviewTermInput;
  probationReviewTimes: Scalars['Int']['input'];
  slackTeamId?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to create a department. */
export type CreateDepartmentInput = {
  definitions?: InputMaybe<Array<DefinitionInput>>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Input type to create a division. */
export type CreateDivisionInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Input type to create an employee contract */
export type CreateEmployeeContractInput = {
  companyId: Scalars['ID']['input'];
  contractType: ContractType;
  effectiveDate: Scalars['Date']['input'];
  effectiveDateUntil?: InputMaybe<Scalars['Date']['input']>;
  employeeCode?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  isMain: Scalars['Boolean']['input'];
  isPreAcquisition: Scalars['Boolean']['input'];
  onSecondment: Scalars['Boolean']['input'];
};

/** Input data type to create an employee - current contract. */
export type CreateEmployeeCurrentContractInput = {
  companyId: Scalars['ID']['input'];
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  contractType: ContractType;
  employeeCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input data type to create an employee - current job history. */
export type CreateEmployeeCurrentJobHistoryInput = {
  businessUnitId: Scalars['ID']['input'];
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  departmentId: Scalars['ID']['input'];
  departmentLead: Scalars['Boolean']['input'];
  jobId: Scalars['ID']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  level: JobHistoryLevel;
  locationId: Scalars['ID']['input'];
  regionalRole: Scalars['Boolean']['input'];
  team?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to create an employee's personal information - dependent. */
export type CreateEmployeeDependentInput = {
  dateOfBirth: Scalars['Date']['input'];
  employeeId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  relation: DependentRelation;
};

/** Input type to create an employee's personal information - emergency contact. */
export type CreateEmployeeEmergencyContactInput = {
  employeeId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phoneNumber: PhoneNumberInput;
  relation: EmergencyContactRelation;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

/** Input data type to create an employee - external account. */
export type CreateEmployeeExternalAccountAutoCreationInput = {
  autoCreationSettings: CreateExternalAccountAutoCreationSettingsInput;
  timingToCreate: ExternalAccountTimingToCreate;
};

/** Input data type to create an employee - general information. */
export type CreateEmployeeGeneralInformationInput = {
  companyEmail?: InputMaybe<EmployeeCompanyEmailInput>;
  dottedLineManagerId?: InputMaybe<Scalars['ID']['input']>;
  greenhouseLink?: InputMaybe<Scalars['Url']['input']>;
  hiredDate: Scalars['Date']['input'];
  hiringSource: EmployeeHiringSource;
  isNewGraduate: Scalars['Boolean']['input'];
  japanesePhoneticName?: InputMaybe<Scalars['String']['input']>;
  legalFullName: Scalars['String']['input'];
  nameInLocalLanguage?: InputMaybe<Scalars['String']['input']>;
  nationalityId: Scalars['CountryCode']['input'];
  needsProbationReview: Scalars['Boolean']['input'];
  preferredFullName: Scalars['String']['input'];
  primaryManagerId: Scalars['ID']['input'];
};

/** Create an IDP / IDP Lite. Snapshot fields are auto-populated by the backend. */
export type CreateEmployeeIdpInput = {
  employeeId: Scalars['ID']['input'];
  /** Whether to hide this IDP from its subject employee's own Dashboard widget and Employee Detail tab. Defaults to not hidden when omitted. */
  hiddenFromEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  hrRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  type: EmployeeIdpType;
};

/** Input type to create an employee. */
export type CreateEmployeeInput = {
  currentContract: CreateEmployeeCurrentContractInput;
  currentJobHistory: CreateEmployeeCurrentJobHistoryInput;
  externalAccount: CreateEmployeeExternalAccountAutoCreationInput;
  generalInformation: CreateEmployeeGeneralInformationInput;
  initialManagerialAccounting?: InputMaybe<CreateEmployeeManagerialAccountingInput>;
  permission: CreateEmployeePermissionInput;
  personalInformation: CreateEmployeePersonalInformationInput;
};

/** Input type to create an employee job history */
export type CreateEmployeeJobHistoryInput = {
  businessUnitId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  departmentLead: Scalars['Boolean']['input'];
  dottedLineManagerId?: InputMaybe<Scalars['ID']['input']>;
  effectiveDate: Scalars['Date']['input'];
  effectiveDateUntil?: InputMaybe<Scalars['Date']['input']>;
  employeeId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  level: JobHistoryLevel;
  locationId: Scalars['ID']['input'];
  /** Note for extended leave. This is ignored when `type` is not for extended leave. */
  note?: InputMaybe<Scalars['String']['input']>;
  primaryManagerId?: InputMaybe<Scalars['ID']['input']>;
  regionalRole: Scalars['Boolean']['input'];
  team?: InputMaybe<Scalars['String']['input']>;
  type: JobHistoryType;
};

/** Input type to create an employee list custom filter. */
export type CreateEmployeeListCustomFilterInput = {
  businessUnitIds: Array<Scalars['ID']['input']>;
  companyIds: Array<Scalars['ID']['input']>;
  contractTypes: Array<ContractType>;
  departmentIds: Array<Scalars['ID']['input']>;
  divisionIds: Array<Scalars['ID']['input']>;
  employmentEndDate?: InputMaybe<LocalDateRangeInput>;
  externalAccountEloomi: Array<EmployeeExternalAccountStatus>;
  externalAccountGithub?: InputMaybe<Array<EmployeeExternalAccountStatus>>;
  externalAccountGoogle: Array<EmployeeExternalAccountStatus>;
  externalAccountGreenhouse: Array<EmployeeExternalAccountStatus>;
  externalAccountHubspot: Array<EmployeeExternalAccountStatus>;
  externalAccountSlack: Array<EmployeeExternalAccountStatus>;
  hiredDate?: InputMaybe<LocalDateRangeInput>;
  isExactMatch: Scalars['Boolean']['input'];
  isLeave?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSecondment?: InputMaybe<Scalars['Boolean']['input']>;
  isOpenFilter: Scalars['Boolean']['input'];
  jobIds: Array<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  lastWorkingDate?: InputMaybe<LocalDateRangeInput>;
  levels: Array<JobHistoryLevel>;
  locationIds: Array<Scalars['ID']['input']>;
  managerIds: Array<Scalars['ID']['input']>;
  managerIncludesAllConnections: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  nationalityIds: Array<Scalars['CountryCode']['input']>;
  rehireRecommendations?: InputMaybe<Array<RehireRecommendation>>;
  replacementValues?: InputMaybe<Array<ReplacementValue>>;
  roles: Array<EmployeeRole>;
  statuses: Array<EmployeeStatus>;
  team?: InputMaybe<Scalars['String']['input']>;
};

/** Input for initial managerial accounting allocations when creating an employee. */
export type CreateEmployeeManagerialAccountingInput = {
  allocationKey: Array<EpmEmployeeAllocationKeyAllocationInput>;
  functionality: Array<EpmEmployeeFunctionalityAllocationInput>;
  roleType: Array<EpmEmployeeRoleTypeAllocationInput>;
  vdd: Array<EpmEmployeeVddAllocationInput>;
  vdp: Array<EpmEmployeeVdpAllocationInput>;
};

/** Input type to create an employee's permission. */
export type CreateEmployeePermissionInput = {
  companyIds: Array<Scalars['ID']['input']>;
  employeeIds: Array<Scalars['ID']['input']>;
  /** Whether this ADMIN_PRIVATE employee has unrestricted IDP visibility scope. Only meaningful when role == ADMIN_PRIVATE; silently ignored (coerced to false) for every other role. */
  idpFullAccess: Scalars['Boolean']['input'];
  role: EmployeeRole;
};

/** Input type to create an employee - personal information - dependent. */
export type CreateEmployeePersonalInformationDependentInput = {
  dateOfBirth: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  relation: DependentRelation;
};

/** Input type to create an employee - personal information - emergency contact. */
export type CreateEmployeePersonalInformationEmergencyContactInput = {
  name: Scalars['String']['input'];
  phoneNumber: PhoneNumberInput;
  relation: EmergencyContactRelation;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to create an employee - personal information. */
export type CreateEmployeePersonalInformationInput = {
  bank?: InputMaybe<EmployeeBankInput>;
  consultingFeeBank?: InputMaybe<EmployeeConsultingFeeBankInput>;
  currentAddress?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dependents: Array<CreateEmployeePersonalInformationDependentInput>;
  emergencyContacts?: InputMaybe<Array<CreateEmployeePersonalInformationEmergencyContactInput>>;
  gender: EmployeeGender;
  idExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  idIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  idIssuedPlace?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<EmployeeIdType>;
  maritalStatus?: InputMaybe<EmployeeMaritalStatus>;
  nhiDependents?: InputMaybe<Scalars['Int']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  passportIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  passportIssuedPlace?: InputMaybe<Scalars['String']['input']>;
  passportName?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPlaceOfBirth?: InputMaybe<Scalars['String']['input']>;
  pensionVoluntaryContributionRate?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<Scalars['String']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  personalPhoneNumber?: InputMaybe<PhoneNumberInput>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  residentialCountryId: Scalars['CountryCode']['input'];
  socialInsuranceNotes?: InputMaybe<Scalars['String']['input']>;
  socialInsuranceNumber?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  taxWithholdingRate?: InputMaybe<Scalars['String']['input']>;
  visas?: InputMaybe<Array<CreateEmployeePersonalInformationVisaInput>>;
};

/** Input type to create an employee - personal information - visa. */
export type CreateEmployeePersonalInformationVisaInput = {
  visaExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  visaIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  visaIssuedPlace?: InputMaybe<Scalars['String']['input']>;
  visaNumber?: InputMaybe<Scalars['String']['input']>;
  visaType?: InputMaybe<Scalars['String']['input']>;
  workPermitExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  workPermitIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  workPermitNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to create an employee's personal information - visa. */
export type CreateEmployeeVisaInput = {
  employeeId: Scalars['ID']['input'];
  visaExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  visaIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  visaIssuedPlace?: InputMaybe<Scalars['String']['input']>;
  visaNumber?: InputMaybe<Scalars['String']['input']>;
  visaType?: InputMaybe<Scalars['String']['input']>;
  workPermitExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  workPermitIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  workPermitNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to create an EpmMasterAllocationKey entry. */
export type CreateEpmMasterAllocationKeyInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Input type to create an EpmMasterFunctionality entry. */
export type CreateEpmMasterFunctionalityInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Input type to create an EpmMasterRoleType entry. */
export type CreateEpmMasterRoleTypeInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Input type to create an EpmMasterVdd entry. */
export type CreateEpmMasterVddInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Input data type for the settings of automatic external account creation. */
export type CreateExternalAccountAutoCreationSettingsInput = {
  enableGoogle: Scalars['Boolean']['input'];
  enableGreenhouse: Scalars['Boolean']['input'];
};

/** Input type to create a job. */
export type CreateJobInput = {
  defaultEpmMasterFunctionalityId?: InputMaybe<Scalars['ID']['input']>;
  definitions: Array<DefinitionInput>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Input type to create a language. */
export type CreateLanguageInput = {
  code: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
};

/** Input type to create a location. */
export type CreateLocationInput = {
  countryId?: InputMaybe<Scalars['CountryCode']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Input type to create a performance review. */
export type CreatePerformanceReviewInput = {
  employeeId: Scalars['ID']['input'];
  period: PerformanceReviewPeriodInput;
};

/** Output type for performance review create. */
export type CreatePerformanceReviewOutput = {
  __typename?: 'CreatePerformanceReviewOutput';
  alreadyExists: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  performanceReview: PerformanceReview;
};

/** Input type to create a performance review target - Target with Multiple Missions. */
export type CreatePerformanceReviewTargetMultipleMissionsInput = {
  description: Scalars['String']['input'];
  myMissionObjective: Scalars['String']['input'];
  performanceReviewId: Scalars['ID']['input'];
  weight: Scalars['Int']['input'];
};

/** Input type to create a performance review target - Numeric (Monthly). */
export type CreatePerformanceReviewTargetNumericMonthlyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  direction: PerformanceReviewTargetDirection;
  myMission: Scalars['String']['input'];
  myMissionObjective?: InputMaybe<Scalars['String']['input']>;
  performanceReviewId: Scalars['ID']['input'];
  targets: Array<CreatePerformanceReviewTargetNumericMonthlyItemInput>;
  unit: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

/** Input type to create a performance review target - Numeric (Monthly) - Item. */
export type CreatePerformanceReviewTargetNumericMonthlyItemInput = {
  target: Scalars['BigDecimal']['input'];
  yearMonth: Scalars['Date']['input'];
};

/** Input type to create a performance review target - Numeric (Sales - Gross Profit / Revenue). */
export type CreatePerformanceReviewTargetNumericSalesInput = {
  items: Array<CreatePerformanceReviewTargetNumericSalesItemInput>;
  performanceReviewId: Scalars['ID']['input'];
  targetType: PerformanceReviewTargetNumericSalesType;
  weightGrossProfit: Scalars['Int']['input'];
  weightRevenue: Scalars['Int']['input'];
};

/** Input type to create a performance review target - Numeric (Sales - Gross Profit / Revenue) - Item. */
export type CreatePerformanceReviewTargetNumericSalesItemInput = {
  currencyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hubspotPipelineId: Scalars['ID']['input'];
  targets: Array<CreatePerformanceReviewTargetNumericSalesItemTargetInput>;
};

/** Input type to create a performance review target - Numeric (Sales - Gross Profit / Revenue) - Item - Target. */
export type CreatePerformanceReviewTargetNumericSalesItemTargetInput = {
  target: PerformanceReviewTargetInput;
  yearMonth: Scalars['Date']['input'];
};

/** Input type to create a performance review target - Numeric (Total). */
export type CreatePerformanceReviewTargetNumericTotalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  direction: PerformanceReviewTargetDirection;
  myMission: Scalars['String']['input'];
  myMissionObjective?: InputMaybe<Scalars['String']['input']>;
  performanceReviewId: Scalars['ID']['input'];
  target: Scalars['BigDecimal']['input'];
  unit: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

/** Input type to create an off boarding - reason for leaving. */
export type CreateReasonForLeavingInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Currency. */
export type Currency = ListItem & {
  __typename?: 'Currency';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  latestCurrencyRateByUSD?: Maybe<Scalars['BigDecimal']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Current (logged-in) employee. */
export type CurrentEmployee = {
  __typename?: 'CurrentEmployee';
  accessFlag: EmployeePermissionAccessFlag;
  employee: Employee;
  id: Scalars['ID']['output'];
  permission?: Maybe<EmployeePermission>;
};

/** Input type for a language definition. */
export type DefinitionInput = {
  content: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
};

/** A language-specific definition for an entity. */
export type DefinitionItem = {
  __typename?: 'DefinitionItem';
  content: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  languageCode: Scalars['ID']['output'];
};

/** Input to delete a Company / Business Unit / Department relation. */
export type DeleteOrgHierarchyRelationInput = {
  id: Scalars['ID']['input'];
};

/** Department. */
export type Department = ListItem & {
  __typename?: 'Department';
  createdAt: Scalars['DateTime']['output'];
  definitions: Array<DefinitionItem>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Output type for a department. */
export type DepartmentOutput = {
  __typename?: 'DepartmentOutput';
  department: Department;
  id: Scalars['ID']['output'];
};

export enum DependentRelation {
  AdoptedChild = 'ADOPTED_CHILD',
  Child = 'CHILD',
  Other = 'OTHER',
  Parent = 'PARENT',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE',
}

/** Input for a single direct report manager change during off-boarding. */
export type DirectReportManagerChangeInput = {
  changeDottedLineManagerId: Scalars['Boolean']['input'];
  changePrimaryManagerId: Scalars['Boolean']['input'];
  directReportEmployeeId: Scalars['ID']['input'];
  newDottedLineManagerId?: InputMaybe<Scalars['ID']['input']>;
  newPrimaryManagerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Division. */
export type Division = ListItem & {
  __typename?: 'Division';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Output type for a division. */
export type DivisionOutput = {
  __typename?: 'DivisionOutput';
  division: Division;
  id: Scalars['ID']['output'];
};

/** Input type to draft a probation review for reviewee. */
export type DraftProbationReviewForRevieweeInput = {
  employeeId: Scalars['ID']['input'];
  expectation?: InputMaybe<Scalars['String']['input']>;
  stages: Array<DraftProbationReviewStageForRevieweeInput>;
};

/** Input type to draft a probation review for reviewer. */
export type DraftProbationReviewForReviewerInput = {
  employeeId: Scalars['ID']['input'];
  expectation?: InputMaybe<Scalars['String']['input']>;
  stages: Array<DraftProbationReviewStageForReviewerInput>;
};

/** Input type to draft a probation review stage for reviewee. */
export type DraftProbationReviewStageForRevieweeInput = {
  selfAssessment?: InputMaybe<Array<UpdateProbationReviewStageAssessmentInput>>;
  selfFeedback?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to draft a probation review stage for reviewer. */
export type DraftProbationReviewStageForReviewerInput = {
  deadline: Scalars['Date']['input'];
  reviewerAssessment?: InputMaybe<Array<UpdateProbationReviewStageAssessmentInput>>;
  reviewerFeedback?: InputMaybe<Scalars['String']['input']>;
  reviewerId?: InputMaybe<Scalars['ID']['input']>;
};

export enum EmergencyContactRelation {
  Brother = 'BROTHER',
  Father = 'FATHER',
  Husband = 'HUSBAND',
  Mother = 'MOTHER',
  Other = 'OTHER',
  Sister = 'SISTER',
  Wife = 'WIFE',
}

/** Employee. */
export type Employee = ListItem & {
  __typename?: 'Employee';
  alerts: Array<ListEmployeeAlertItemByEmployee>;
  contractNote?: Maybe<Scalars['String']['output']>;
  contracts: Array<EmployeeContract>;
  createdAt: Scalars['DateTime']['output'];
  currentMainContract?: Maybe<EmployeeContract>;
  currentManagerialAccounting?: Maybe<EmployeeManagerialAccounting>;
  currentPosition?: Maybe<EmployeeJobHistory>;
  currentSubContracts: Array<EmployeeContract>;
  externalAccounts: Array<EmployeeExternalAccount>;
  generalInformation: EmployeeGeneralInformation;
  googleProductAndSKUForNew?: Maybe<GoogleProductAndSkuWithDisplayName>;
  id: Scalars['ID']['output'];
  /** IDPs of the employee (newest first). Empty for unauthorized viewers. */
  idps: Array<EmployeeIdp>;
  jobHistories: Array<EmployeeJobHistory>;
  jobHistoryNote?: Maybe<Scalars['String']['output']>;
  managers: Array<Employee>;
  offBoarding?: Maybe<EmployeeOffBoarding>;
  pendingManagerChangeReservation?: Maybe<ManagerChangeReservation>;
  performanceReviews: Array<PerformanceReview>;
  permission?: Maybe<EmployeePermission>;
  personalInformation?: Maybe<EmployeePersonalInformation>;
  pictureUrl?: Maybe<Scalars['Url']['output']>;
  probationReview?: Maybe<ProbationReview>;
  status: EmployeeStatus;
  /** Employee Status decided on the Last Working Date (Inactive means the employee has left). `status` is decided on the Employment End Date instead. */
  statusBasedOnLastWorkingDate: EmployeeStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Employee. */
export type EmployeeExternalAccountsArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Employee. */
export type EmployeePerformanceReviewsArgs = {
  isRecentOnly: Scalars['Boolean']['input'];
};

/** Employee Alert - Age is out of range. */
export type EmployeeAlertAgeOutOfRange = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertAgeOutOfRange';
  age: Scalars['Int']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  dateOfBirth: Scalars['Date']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Job histories are not continuous. */
export type EmployeeAlertContractsNotContinuous = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertContractsNotContinuous';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  date1: Scalars['Date']['output'];
  date2: Scalars['Date']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  gapDays: Scalars['Int']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Contracts not found. */
export type EmployeeAlertContractsNotFound = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertContractsNotFound';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

export type EmployeeAlertCountByPriority = {
  __typename?: 'EmployeeAlertCountByPriority';
  high: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
};

/** Employee Alert - Duplicate company across overlapping contract periods. */
export type EmployeeAlertDuplicateCompanyContracts = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertDuplicateCompanyContracts';
  companyName?: Maybe<Scalars['String']['output']>;
  conflictingCompanyNames: Array<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Job histories are duplicated. */
export type EmployeeAlertDuplicateJobHistories = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertDuplicateJobHistories';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Main contracts are duplicated. */
export type EmployeeAlertDuplicateMainContracts = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertDuplicateMainContracts';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Employee is active but has no active contract history. */
export type EmployeeAlertEmployeeNotInactiveButNoActiveContract = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertEmployeeNotInactiveButNoActiveContract';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  lastContractEndDate?: Maybe<Scalars['Date']['output']>;
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Employee is active but has no active job history. */
export type EmployeeAlertEmployeeNotInactiveButNoActiveJobHistory = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertEmployeeNotInactiveButNoActiveJobHistory';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  lastJobHistoryEndDate?: Maybe<Scalars['Date']['output']>;
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Empty date of birth. */
export type EmployeeAlertEmptyDateOfBirth = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertEmptyDateOfBirth';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - First contract start date is not the same as hired date. */
export type EmployeeAlertFirstContractStartDateNotSameAsHiredDate = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertFirstContractStartDateNotSameAsHiredDate';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  firstStartDate: Scalars['Date']['output'];
  hiredDate: Scalars['Date']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - First job history start date is not the same as hired date. */
export type EmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  firstStartDate: Scalars['Date']['output'];
  hiredDate: Scalars['Date']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Hired date is before 2016-04-01. */
export type EmployeeAlertHiredDateBeforeAnyMindStarts = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertHiredDateBeforeAnyMindStarts';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  hiredDate: Scalars['Date']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Managers are/will be inactive. */
export type EmployeeAlertInactiveManager = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertInactiveManager';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  dottedLineManager?: Maybe<Employee>;
  dottedLineManagerId?: Maybe<Scalars['ID']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  primaryManager?: Maybe<Employee>;
  primaryManagerId?: Maybe<Scalars['ID']['output']>;
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Invalid employee code. */
export type EmployeeAlertInvalidEmployeeCode = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertInvalidEmployeeCode';
  companyName?: Maybe<Scalars['String']['output']>;
  contractStartDate: Scalars['Date']['output'];
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  detailMessage?: Maybe<Scalars['String']['output']>;
  employee: Employee;
  employeeCode: Scalars['String']['output'];
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Invalid Japanese phonetic name. */
export type EmployeeAlertInvalidJapanesePhoneticName = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertInvalidJapanesePhoneticName';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  detailMessage?: Maybe<Scalars['String']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  japanesePhoneticName: Scalars['String']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Invalid legal full name. */
export type EmployeeAlertInvalidLegalFullName = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertInvalidLegalFullName';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  detailMessage?: Maybe<Scalars['String']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  legalFullName: Scalars['String']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Invalid preferred full name. */
export type EmployeeAlertInvalidPreferredFullName = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertInvalidPreferredFullName';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  detailMessage?: Maybe<Scalars['String']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  preferredFullName: Scalars['String']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Job histories are not continuous. */
export type EmployeeAlertJobHistoriesNotContinuous = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertJobHistoriesNotContinuous';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  date1: Scalars['Date']['output'];
  date2: Scalars['Date']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  gapDays: Scalars['Int']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Job histories not found. */
export type EmployeeAlertJobHistoriesNotFound = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertJobHistoriesNotFound';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Last contract end date is not the same as last job history end date. */
export type EmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  lastContractEndDate?: Maybe<Scalars['Date']['output']>;
  lastJobHistoryEndDate?: Maybe<Scalars['Date']['output']>;
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Last contract end date is not the same as Employment end date. */
export type EmployeeAlertLastContractEndDateNotSameAsResignationDate = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertLastContractEndDateNotSameAsResignationDate';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  lastEndDate?: Maybe<Scalars['Date']['output']>;
  priority: EmployeeAlertPriority;
  resignationDate?: Maybe<Scalars['Date']['output']>;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Last contract history will end soon. */
export type EmployeeAlertLastContractWillEnd = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertLastContractWillEnd';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  lastEndDate?: Maybe<Scalars['Date']['output']>;
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Last job history end date is not same as Employment end date. */
export type EmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  lastEndDate?: Maybe<Scalars['Date']['output']>;
  priority: EmployeeAlertPriority;
  resignationDate?: Maybe<Scalars['Date']['output']>;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Last job history will end soon. */
export type EmployeeAlertLastJobHistoryWillEnd = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertLastJobHistoryWillEnd';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  lastEndDate?: Maybe<Scalars['Date']['output']>;
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Last working date is before 2016-04-01. */
export type EmployeeAlertLastWorkingDateBeforeAnyMindStarts = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertLastWorkingDateBeforeAnyMindStarts';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  lastWorkingDate: Scalars['Date']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Last working date is before hired date. */
export type EmployeeAlertLastWorkingDateBeforeHiredDate = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertLastWorkingDateBeforeHiredDate';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  hiredDate: Scalars['Date']['output'];
  lastWorkingDate: Scalars['Date']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

export enum EmployeeAlertPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

/** Employee Alert - The probation outcome is Failed but the employment end is not registered. */
export type EmployeeAlertProbationFailedStillEmployed = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertProbationFailedStillEmployed';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Reason. */
export type EmployeeAlertReason = {
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  summary: Scalars['String']['output'];
};

export enum EmployeeAlertReasonType {
  AgeOutOfRange = 'AgeOutOfRange',
  ContractsNotContinuous = 'ContractsNotContinuous',
  ContractsNotFound = 'ContractsNotFound',
  DuplicateCompanyContracts = 'DuplicateCompanyContracts',
  DuplicateJobHistories = 'DuplicateJobHistories',
  DuplicateMainContracts = 'DuplicateMainContracts',
  EmployeeNotInactiveButNoActiveContract = 'EmployeeNotInactiveButNoActiveContract',
  EmployeeNotInactiveButNoActiveJobHistory = 'EmployeeNotInactiveButNoActiveJobHistory',
  EmptyDateOfBirth = 'EmptyDateOfBirth',
  FirstContractStartDateNotSameAsHiredDate = 'FirstContractStartDateNotSameAsHiredDate',
  FirstJobHistoryStartDateNotSameAsHiredDate = 'FirstJobHistoryStartDateNotSameAsHiredDate',
  HiredDateBeforeAnyMindStarts = 'HiredDateBeforeAnyMindStarts',
  InactiveManager = 'InactiveManager',
  InvalidEmployeeCode = 'InvalidEmployeeCode',
  InvalidJapanesePhoneticName = 'InvalidJapanesePhoneticName',
  InvalidLegalFullName = 'InvalidLegalFullName',
  InvalidPreferredFullName = 'InvalidPreferredFullName',
  JobHistoriesNotContinuous = 'JobHistoriesNotContinuous',
  JobHistoriesNotFound = 'JobHistoriesNotFound',
  LastContractEndDateNotSameAsLastJobHistoryEndDate = 'LastContractEndDateNotSameAsLastJobHistoryEndDate',
  LastContractEndDateNotSameAsResignationDate = 'LastContractEndDateNotSameAsResignationDate',
  LastContractWillEnd = 'LastContractWillEnd',
  LastJobHistoryEndDateNotSameAsResignationDate = 'LastJobHistoryEndDateNotSameAsResignationDate',
  LastJobHistoryWillEnd = 'LastJobHistoryWillEnd',
  LastWorkingDateBeforeAnyMindStarts = 'LastWorkingDateBeforeAnyMindStarts',
  LastWorkingDateBeforeHiredDate = 'LastWorkingDateBeforeHiredDate',
  ProbationFailedStillEmployed = 'ProbationFailedStillEmployed',
  ResignationDateBeforeAnyMindStarts = 'ResignationDateBeforeAnyMindStarts',
  ResignationDateBeforeHiredDate = 'ResignationDateBeforeHiredDate',
  ResignationDateBeforeLastWorkingDate = 'ResignationDateBeforeLastWorkingDate',
}

/** Employee alert type. */
export type EmployeeAlertReasonTypeWithDisplayName = EnumWithDisplayName & {
  __typename?: 'EmployeeAlertReasonTypeWithDisplayName';
  displayName: Scalars['String']['output'];
  priority: EmployeeAlertPriority;
  value: EmployeeAlertReasonType;
};

/** Employee Alert - Employment end date is before 2016-04-01. */
export type EmployeeAlertResignationDateBeforeAnyMindStarts = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertResignationDateBeforeAnyMindStarts';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  priority: EmployeeAlertPriority;
  resignationDate?: Maybe<Scalars['Date']['output']>;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Employment end date is before hired date. */
export type EmployeeAlertResignationDateBeforeHiredDate = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertResignationDateBeforeHiredDate';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  hiredDate: Scalars['Date']['output'];
  priority: EmployeeAlertPriority;
  resignationDate?: Maybe<Scalars['Date']['output']>;
  summary: Scalars['String']['output'];
};

/** Employee Alert - Employment end date is before last working date. */
export type EmployeeAlertResignationDateBeforeLastWorkingDate = EmployeeAlertReason & {
  __typename?: 'EmployeeAlertResignationDateBeforeLastWorkingDate';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  lastWorkingDate: Scalars['Date']['output'];
  priority: EmployeeAlertPriority;
  resignationDate?: Maybe<Scalars['Date']['output']>;
  summary: Scalars['String']['output'];
};

/** Employee - bank. */
export type EmployeeBank = EmployeeBankCommon & {
  __typename?: 'EmployeeBank';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Employee - bank (common information). */
export type EmployeeBankCommon = {
  accountHolderName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Input type for an employee - bank. */
export type EmployeeBankInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['CountryCode']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Employee - company email. */
export type EmployeeCompanyEmail = {
  __typename?: 'EmployeeCompanyEmail';
  account?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['ID']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
};

/** Input data type for employee - company email. */
export type EmployeeCompanyEmailInput = {
  account: Scalars['String']['input'];
  domainId: Scalars['ID']['input'];
};

/** Employee - consulting fee bank. */
export type EmployeeConsultingFeeBank = EmployeeBankCommon & {
  __typename?: 'EmployeeConsultingFeeBank';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Input type for an employee - consulting fee bank. */
export type EmployeeConsultingFeeBankInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['CountryCode']['input']>;
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Employee - contract. */
export type EmployeeContract = {
  __typename?: 'EmployeeContract';
  company: Company;
  companyId: Scalars['ID']['output'];
  contractType: ContractType;
  effectiveDate: Scalars['Date']['output'];
  effectiveDateUntil?: Maybe<Scalars['Date']['output']>;
  employeeCode?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isMain: Scalars['Boolean']['output'];
  isPreAcquisition: Scalars['Boolean']['output'];
  onSecondment: Scalars['Boolean']['output'];
};

/** Output type for an employee contract. */
export type EmployeeContractOutput = {
  __typename?: 'EmployeeContractOutput';
  contract?: Maybe<EmployeeContract>;
  id: Scalars['ID']['output'];
};

/** Employee - dependent. */
export type EmployeeDependent = {
  __typename?: 'EmployeeDependent';
  age: Scalars['Int']['output'];
  dateOfBirth: Scalars['Date']['output'];
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relation: DependentRelation;
};

/** Output type for an employee's personal information - dependent. */
export type EmployeeDependentOutput = {
  __typename?: 'EmployeeDependentOutput';
  dependent: EmployeeDependent;
  id: Scalars['ID']['output'];
};

/** Employee - emergency contact. */
export type EmployeeEmergencyContact = {
  __typename?: 'EmployeeEmergencyContact';
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber: PhoneNumber;
  relation: EmergencyContactRelation;
  remarks?: Maybe<Scalars['String']['output']>;
};

/** Output type for an employee's personal information - emergency contact. */
export type EmployeeEmergencyContactOutput = {
  __typename?: 'EmployeeEmergencyContactOutput';
  emergencyContact: EmployeeEmergencyContact;
  id: Scalars['ID']['output'];
};

export enum EmployeeExportFormat {
  CreateTemplate = 'CREATE_TEMPLATE',
  GeneralInformation = 'GENERAL_INFORMATION',
  JobHistoryContract = 'JOB_HISTORY_CONTRACT',
  ManagerialAccountingImportTemplate = 'MANAGERIAL_ACCOUNTING_IMPORT_TEMPLATE',
  OffBoarding = 'OFF_BOARDING',
  PersonalInformation = 'PERSONAL_INFORMATION',
}

export type EmployeeExportHistory = ExportHistory &
  ListItem & {
    __typename?: 'EmployeeExportHistory';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    format: EmployeeExportFormat;
    id: Scalars['ID']['output'];
    resultFileName?: Maybe<Scalars['String']['output']>;
    resultUrl?: Maybe<Scalars['String']['output']>;
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

export type EmployeeExportProgress = ExportImportProgress &
  ListItem & {
    __typename?: 'EmployeeExportProgress';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

/** Employee - external account. */
export type EmployeeExternalAccount = {
  accountType: EmployeeExternalAccountType;
  canInvokeManualCreation: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  status: EmployeeExternalAccountStatus;
  userType?: Maybe<EmployeeExternalAccountUserType>;
};

/** Employee - external account - Eloomi. */
export type EmployeeExternalAccountEloomi = EmployeeExternalAccount &
  ListItem & {
    __typename?: 'EmployeeExternalAccountEloomi';
    accountType: EmployeeExternalAccountType;
    canInvokeManualCreation: Scalars['Boolean']['output'];
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    employee: Employee;
    employeeId: Scalars['ID']['output'];
    id: Scalars['ID']['output'];
    requestedAt?: Maybe<Scalars['DateTime']['output']>;
    status: EmployeeExternalAccountStatus;
    userType?: Maybe<EmployeeExternalAccountUserType>;
  };

/** Employee - external account - GitHub. */
export type EmployeeExternalAccountGitHub = EmployeeExternalAccount &
  ListItem & {
    __typename?: 'EmployeeExternalAccountGitHub';
    accountType: EmployeeExternalAccountType;
    canInvokeManualCreation: Scalars['Boolean']['output'];
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    employee: Employee;
    employeeId: Scalars['ID']['output'];
    githubUsername?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    requestedAt?: Maybe<Scalars['DateTime']['output']>;
    status: EmployeeExternalAccountStatus;
    userType?: Maybe<EmployeeExternalAccountUserType>;
  };

/** Employee - external account - Google. */
export type EmployeeExternalAccountGoogle = EmployeeExternalAccount &
  ListItem & {
    __typename?: 'EmployeeExternalAccountGoogle';
    accountType: EmployeeExternalAccountType;
    aliases: Array<Scalars['String']['output']>;
    canInvokeManualCreation: Scalars['Boolean']['output'];
    changePasswordAtNextLogin: Scalars['Boolean']['output'];
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    employee: Employee;
    employeeId: Scalars['ID']['output'];
    id: Scalars['ID']['output'];
    licenses: Array<GoogleProductAndSkuWithDisplayName>;
    requestedAt?: Maybe<Scalars['DateTime']['output']>;
    status: EmployeeExternalAccountStatus;
    temporaryPassword?: Maybe<Scalars['String']['output']>;
    userType?: Maybe<EmployeeExternalAccountUserType>;
  };

/** Employee - external account - Greenhouse. */
export type EmployeeExternalAccountGreenhouse = EmployeeExternalAccount &
  ListItem & {
    __typename?: 'EmployeeExternalAccountGreenhouse';
    accountType: EmployeeExternalAccountType;
    canInvokeManualCreation: Scalars['Boolean']['output'];
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    employee: Employee;
    employeeId: Scalars['ID']['output'];
    id: Scalars['ID']['output'];
    requestedAt?: Maybe<Scalars['DateTime']['output']>;
    status: EmployeeExternalAccountStatus;
    userType?: Maybe<EmployeeExternalAccountUserType>;
  };

/** Employee - external account - HubSpot. */
export type EmployeeExternalAccountHubSpot = EmployeeExternalAccount &
  ListItem & {
    __typename?: 'EmployeeExternalAccountHubSpot';
    accountType: EmployeeExternalAccountType;
    canInvokeManualCreation: Scalars['Boolean']['output'];
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    employee: Employee;
    employeeId: Scalars['ID']['output'];
    id: Scalars['ID']['output'];
    requestedAt?: Maybe<Scalars['DateTime']['output']>;
    status: EmployeeExternalAccountStatus;
    userType?: Maybe<EmployeeExternalAccountUserType>;
  };

/** Employee - external account - Slack. */
export type EmployeeExternalAccountSlack = EmployeeExternalAccount &
  ListItem & {
    __typename?: 'EmployeeExternalAccountSlack';
    accountType: EmployeeExternalAccountType;
    canInvokeManualCreation: Scalars['Boolean']['output'];
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    employee: Employee;
    employeeId: Scalars['ID']['output'];
    id: Scalars['ID']['output'];
    requestedAt?: Maybe<Scalars['DateTime']['output']>;
    status: EmployeeExternalAccountStatus;
    userType?: Maybe<EmployeeExternalAccountUserType>;
    workspace?: Maybe<EmployeeExternalAccountSlackWorkspace>;
  };

/** Employee - external account - Slack - Workspace. */
export type EmployeeExternalAccountSlackWorkspace = {
  __typename?: 'EmployeeExternalAccountSlackWorkspace';
  teamId: Scalars['ID']['output'];
  teamName: Scalars['String']['output'];
};

export enum EmployeeExternalAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  NotExisting = 'NOT_EXISTING',
  Suspended = 'SUSPENDED',
}

export enum EmployeeExternalAccountType {
  Eloomi = 'ELOOMI',
  Github = 'GITHUB',
  Google = 'GOOGLE',
  Greenhouse = 'GREENHOUSE',
  Hubspot = 'HUBSPOT',
  Slack = 'SLACK',
}

export enum EmployeeExternalAccountUserType {
  EloomiAdmin = 'ELOOMI_ADMIN',
  GithubAdmin = 'GITHUB_ADMIN',
  GoogleDelegatedAdmin = 'GOOGLE_DELEGATED_ADMIN',
  GoogleSuperAdmin = 'GOOGLE_SUPER_ADMIN',
  GreenhouseSiteAdmin = 'GREENHOUSE_SITE_ADMIN',
  HubspotSuperAdmin = 'HUBSPOT_SUPER_ADMIN',
  Member = 'MEMBER',
  SlackAdmin = 'SLACK_ADMIN',
  SlackMultiChannelGuest = 'SLACK_MULTI_CHANNEL_GUEST',
  SlackOwner = 'SLACK_OWNER',
  SlackPrimaryOwner = 'SLACK_PRIMARY_OWNER',
  SlackSingleChannelGuest = 'SLACK_SINGLE_CHANNEL_GUEST',
}

/** A file registered against an employee (e.g. their signature image). */
export type EmployeeFile = {
  mimeType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmployeeGender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
}

/** Employee - general information. */
export type EmployeeGeneralInformation = {
  __typename?: 'EmployeeGeneralInformation';
  companyEmail?: Maybe<EmployeeCompanyEmail>;
  dottedLineManager?: Maybe<Employee>;
  dottedLineManagerId?: Maybe<Scalars['ID']['output']>;
  greenhouseLink?: Maybe<Scalars['Url']['output']>;
  hiredDate: Scalars['Date']['output'];
  hiringSource?: Maybe<EmployeeHiringSource>;
  isNewGraduate: Scalars['Boolean']['output'];
  japanesePhoneticName?: Maybe<Scalars['String']['output']>;
  legalFullName: Scalars['String']['output'];
  nameInLocalLanguage?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Country>;
  nationalityId?: Maybe<Scalars['CountryCode']['output']>;
  needsProbationReview: Scalars['Boolean']['output'];
  preferredFullName: Scalars['String']['output'];
  primaryManager?: Maybe<Employee>;
  primaryManagerId?: Maybe<Scalars['ID']['output']>;
  probationReviewEndDate?: Maybe<Scalars['Date']['output']>;
};

export enum EmployeeHiringSource {
  Agency = 'AGENCY',
  CompanyWebsite = 'COMPANY_WEBSITE',
  JobPosting = 'JOB_POSTING',
  Referral = 'REFERRAL',
  SocialMedia = 'SOCIAL_MEDIA',
  Sourcing = 'SOURCING',
}

export enum EmployeeIdType {
  DriverLicense = 'DRIVER_LICENSE',
  NationalId = 'NATIONAL_ID',
}

/** Result of resolving an employee identifier for performance review bulk create. */
export type EmployeeIdentifierResolutionResult = {
  __typename?: 'EmployeeIdentifierResolutionResult';
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  identifier: Scalars['String']['output'];
  performanceReview?: Maybe<PerformanceReview>;
  performanceReviewId?: Maybe<Scalars['ID']['output']>;
  status: EmployeeResolutionStatus;
};

/** Employee IDP / IDP Lite. */
export type EmployeeIdp = {
  __typename?: 'EmployeeIdp';
  /** UI hint only: whether the viewer could write/edit this record's notes (identical authorization to the notes field). Lets the frontend show a 'write a note' affordance for a record with no note yet without leaking the field's existence to unauthorized viewers. */
  canEditNotes: Scalars['Boolean']['output'];
  /** Whether the viewer is authorized to click 'Generate PDF' (the Line Manager, the HR Representative, or an HR admin). */
  canGeneratePdf: Scalars['Boolean']['output'];
  companyId: Scalars['ID']['output'];
  /** Number of review rounds fully completed so far — the minimum submitted-review count across all key areas (same lockstep semantics as nextReviewDate). 0 when the IDP has zero key areas. */
  completedReviewCount: Scalars['Int']['output'];
  /** Timestamp the IDP was confirmed (transitioned out of DRAFT). Null while still in DRAFT status. */
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  department?: Maybe<Department>;
  /** Snapshot of the employee's department at IDP creation time. */
  departmentId: Scalars['ID']['output'];
  /** 061-idp-pdf-signing FR-004: best-guess document language detected from this IDP's Key Area free-text content, to pre-select the PDF generation dialog. The user's confirmed choice always wins - this is only a default. */
  detectedPdfLanguage: IdpPdfLanguage;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  /** Auto-calculated from the start date and plan type; read-only. */
  endDate: Scalars['Date']['output'];
  /** Whether this IDP has at least one PDF generation of any status - used by the frontend to pick the Generate & Email PDF dialog's default tab. Same viewer set as canGeneratePdf/listActivePdfGenerations. */
  hasPdfGenerations: Scalars['Boolean']['output'];
  /** Whether a PDF generation is currently pending for this IDP. While true, the 'Generate PDF' action should be shown as unavailable. */
  hasPendingPdfGeneration: Scalars['Boolean']['output'];
  /** Whether this IDP is hidden from its subject employee's own Dashboard widget and Employee Detail tab. Visible to any viewer who can already see this record. */
  hiddenFromEmployee: Scalars['Boolean']['output'];
  hrRepresentative?: Maybe<Employee>;
  hrRepresentativeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** True when at least one key area has a blank performanceRecoveryArea, successCriteria, or additionalSupportNeeded field (i.e. has an incomplete key area) — NOT whether the keyAreas list is empty. */
  isKeyAreasEmpty: Scalars['Boolean']['output'];
  /** Snapshot of the employee's job title at IDP creation time. */
  jobTitle: Scalars['String']['output'];
  keyAreas: Array<EmployeeIdpKeyArea>;
  /** Snapshot of the employee's level at IDP creation time. */
  level: JobHistoryLevel;
  lineManager: Employee;
  lineManagerId: Scalars['ID']['output'];
  /** The History tab's default view - up to 2 entries, newest first: the latest SUCCEEDED-and-not-void generation, plus the latest PENDING-or-FAILED generation but only when it is newer than the included SUCCEEDED-and-not-void one (or when none exists). Restricted to the same viewer set as canGeneratePdf. The full, paginated history (every status, including voided) is a separate top-level query, listAllPdfGenerations. */
  listActivePdfGenerations: Array<EmployeeIdpPdfGeneration>;
  location?: Maybe<Location>;
  /** Snapshot of the employee's location at IDP creation time. */
  locationId: Scalars['ID']['output'];
  /** Expected date of the next review slot to submit, computed as startDate + firstIntervalDays + (nextSlotIndex x cadenceDays) where nextSlotIndex is the minimum submitted-review count across all key areas. Null when the IDP has zero key areas, or when every key area's fixed review slots are already submitted. */
  nextReviewDate?: Maybe<Scalars['Date']['output']>;
  /** Restricted field: non-null only for Super Admin and idpFullAccess Admin (Private), and null even for those roles when the viewer is this record's own Target Employee or Line Manager. Null for every other viewer, regardless of role. */
  notes?: Maybe<Scalars['String']['output']>;
  result?: Maybe<EmployeeIdpResult>;
  resultComment?: Maybe<Scalars['String']['output']>;
  resultRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Auto-calculated as endDate + 7 days; the operational due date that drives OVERDUE status. Read-only. */
  reviewDeadlineDate: Scalars['Date']['output'];
  startDate: Scalars['Date']['output'];
  status: EmployeeIdpStatus;
  type: EmployeeIdpType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Key area group within an IDP (3-5 per plan). */
export type EmployeeIdpKeyArea = {
  __typename?: 'EmployeeIdpKeyArea';
  additionalSupportNeeded: Scalars['String']['output'];
  employeeIdpId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  performanceRecoveryArea: Scalars['String']['output'];
  reviews: Array<EmployeeIdpKeyAreaReview>;
  sortOrder: Scalars['Int']['output'];
  successCriteria: Scalars['String']['output'];
};

/** Review check-in entry within a key area. */
export type EmployeeIdpKeyAreaReview = {
  __typename?: 'EmployeeIdpKeyAreaReview';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  createdById?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  keyAreaId: Scalars['ID']['output'];
};

/** Filter for the IDP list page. */
export type EmployeeIdpListFilterInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  startDateFrom?: InputMaybe<Scalars['Date']['input']>;
  startDateTo?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EmployeeIdpStatus>;
  type?: InputMaybe<EmployeeIdpType>;
};

/** Paginated IDP list result. */
export type EmployeeIdpListResult = {
  __typename?: 'EmployeeIdpListResult';
  items: Array<EmployeeIdp>;
  totalCount: Scalars['Int']['output'];
};

/** IDP mutation output. */
export type EmployeeIdpOutput = {
  __typename?: 'EmployeeIdpOutput';
  idp: EmployeeIdp;
};

export enum EmployeeIdpPdfDeliveryOutcome {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  SkippedInactive = 'SKIPPED_INACTIVE',
  SkippedNotApplicable = 'SKIPPED_NOT_APPLICABLE',
}

/** 061-idp-pdf-signing FR-016/FR-017: one request to turn an IDP into a sealed, signed PDF. Rows are never deleted; a mistaken generation is soft-voided instead (isVoid), since the underlying file must remain permanently retained. */
export type EmployeeIdpPdfGeneration = {
  __typename?: 'EmployeeIdpPdfGeneration';
  employeeIdpId: Scalars['ID']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  failureStage?: Maybe<EmployeeIdpPdfGenerationFailureStage>;
  generatedBy: Employee;
  generatedById: Scalars['ID']['output'];
  /** 1-based ordinal among every generation ever produced for this IDP (oldest = 1), regardless of void status - a stable, human-readable label distinct from the opaque id, matching the order generations were actually requested in. */
  generationNumber: Scalars['Int']['output'];
  generatorTimeZone: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The IDP's status at the moment this generation was requested. */
  idpStatusSnapshot: Scalars['String']['output'];
  isVoid: Scalars['Boolean']['output'];
  language: IdpPdfLanguage;
  recipients: Array<EmployeeIdpPdfGenerationRecipient>;
  requestedAt: Scalars['DateTime']['output'];
  status: EmployeeIdpPdfGenerationStatus;
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
  voidedBy?: Maybe<Employee>;
  voidedById?: Maybe<Scalars['ID']['output']>;
};

export enum EmployeeIdpPdfGenerationFailureStage {
  Email = 'EMAIL',
  Render = 'RENDER',
  Sign = 'SIGN',
  Store = 'STORE',
  Timeout = 'TIMEOUT',
}

/** Paginated PDF generation history result. */
export type EmployeeIdpPdfGenerationListResult = {
  __typename?: 'EmployeeIdpPdfGenerationListResult';
  items: Array<EmployeeIdpPdfGeneration>;
  totalCount: Scalars['Int']['output'];
};

/** Per-recipient send-time outcome for one PDF generation. */
export type EmployeeIdpPdfGenerationRecipient = {
  __typename?: 'EmployeeIdpPdfGenerationRecipient';
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  outcome: EmployeeIdpPdfDeliveryOutcome;
  role: EmployeeIdpPdfRecipientRole;
};

export enum EmployeeIdpPdfGenerationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum EmployeeIdpPdfRecipientRole {
  GeneratorCc = 'GENERATOR_CC',
  HrRepresentative = 'HR_REPRESENTATIVE',
  LineManager = 'LINE_MANAGER',
}

export enum EmployeeIdpResult {
  Failure = 'FAILURE',
  SuccessfulCompletion = 'SUCCESSFUL_COMPLETION',
}

export enum EmployeeIdpStatus {
  Cancelled = 'CANCELLED',
  CompletedFailure = 'COMPLETED_FAILURE',
  CompletedSuccess = 'COMPLETED_SUCCESS',
  Draft = 'DRAFT',
  OverdueResult = 'OVERDUE_RESULT',
  OverdueReviewing = 'OVERDUE_REVIEWING',
  Reviewing = 'REVIEWING',
}

export enum EmployeeIdpType {
  Idp = 'IDP',
  IdpLite = 'IDP_LITE',
}

export enum EmployeeImportFormat {
  Create = 'CREATE',
  GeneralInformation = 'GENERAL_INFORMATION',
  IdOnboardingSheet = 'ID_ONBOARDING_SHEET',
  JobHistoryContract = 'JOB_HISTORY_CONTRACT',
  ThOnboardingSheet = 'TH_ONBOARDING_SHEET',
}

/** Import employee history. */
export type EmployeeImportHistory = ImportHistory &
  ListItem & {
    __typename?: 'EmployeeImportHistory';
    affectedEmployeeIds: Array<Scalars['ID']['output']>;
    affectedEmployees: Array<Employee>;
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    errors: Array<EmployeeImportHistoryError>;
    format: EmployeeImportFormat;
    id: Scalars['ID']['output'];
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    url: Scalars['Url']['output'];
  };

/** Import employee history error. */
export type EmployeeImportHistoryError = ImportHistoryError & {
  __typename?: 'EmployeeImportHistoryError';
  columnName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
  sheetName?: Maybe<Scalars['String']['output']>;
};

/** Live progress for an in-flight Employee import job. */
export type EmployeeImportProgress = ExportImportProgress &
  ListItem & {
    __typename?: 'EmployeeImportProgress';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

/** Employee - job history. */
export type EmployeeJobHistory = {
  __typename?: 'EmployeeJobHistory';
  businessUnit: BusinessUnit;
  businessUnitId: Scalars['ID']['output'];
  department: Department;
  departmentId: Scalars['ID']['output'];
  departmentLead: Scalars['Boolean']['output'];
  effectiveDate: Scalars['Date']['output'];
  effectiveDateUntil?: Maybe<Scalars['Date']['output']>;
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  job: Job;
  jobId: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  level: JobHistoryLevel;
  location: Location;
  locationId: Scalars['ID']['output'];
  /** Note for extended leave. This will be always null when `type` is not for extended leave. */
  note?: Maybe<Scalars['String']['output']>;
  regionalRole: Scalars['Boolean']['output'];
  team?: Maybe<Scalars['String']['output']>;
  type: JobHistoryType;
};

/** Output type for an employee job history. */
export type EmployeeJobHistoryOutput = {
  __typename?: 'EmployeeJobHistoryOutput';
  id: Scalars['ID']['output'];
  jobHistory: EmployeeJobHistory;
};

/** Employee list custom filter. */
export type EmployeeListCustomFilter = ListItem & {
  __typename?: 'EmployeeListCustomFilter';
  businessUnitIds: Array<Scalars['ID']['output']>;
  businessUnits: Array<BusinessUnit>;
  companies: Array<Company>;
  companyIds: Array<Scalars['ID']['output']>;
  contractTypes: Array<ContractType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  createdById?: Maybe<Scalars['ID']['output']>;
  departmentIds: Array<Scalars['ID']['output']>;
  departments: Array<Department>;
  divisionIds: Array<Scalars['ID']['output']>;
  divisions: Array<Division>;
  employmentEndDate: LocalDateRange;
  externalAccountEloomi: Array<EmployeeExternalAccountStatus>;
  externalAccountGithub: Array<EmployeeExternalAccountStatus>;
  externalAccountGoogle: Array<EmployeeExternalAccountStatus>;
  externalAccountGreenhouse: Array<EmployeeExternalAccountStatus>;
  externalAccountHubspot: Array<EmployeeExternalAccountStatus>;
  externalAccountSlack: Array<EmployeeExternalAccountStatus>;
  hiredDate: LocalDateRange;
  id: Scalars['ID']['output'];
  isExactMatch: Scalars['Boolean']['output'];
  isLeave?: Maybe<Scalars['Boolean']['output']>;
  isOnSecondment?: Maybe<Scalars['Boolean']['output']>;
  isOpenFilter: Scalars['Boolean']['output'];
  jobIds: Array<Scalars['ID']['output']>;
  jobs: Array<Job>;
  keyword?: Maybe<Scalars['String']['output']>;
  lastWorkingDate: LocalDateRange;
  levels: Array<JobHistoryLevel>;
  locationIds: Array<Scalars['ID']['output']>;
  locations: Array<Location>;
  managerIds: Array<Scalars['ID']['output']>;
  managerIncludesAllConnections: Scalars['Boolean']['output'];
  managers: Array<Employee>;
  name: Scalars['String']['output'];
  nationalities: Array<Country>;
  nationalityIds: Array<Scalars['CountryCode']['output']>;
  rehireRecommendations: Array<RehireRecommendation>;
  replacementValues: Array<ReplacementValue>;
  roles: Array<EmployeeRole>;
  statuses: Array<EmployeeStatus>;
  team?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Employee>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

/** Output type for an employee list custom filter. */
export type EmployeeListCustomFilterOutput = {
  __typename?: 'EmployeeListCustomFilterOutput';
  employeeListCustomFilter: EmployeeListCustomFilter;
  id: Scalars['ID']['output'];
};

export enum EmployeeListSortField {
  BusinessUnit = 'BUSINESS_UNIT',
  Company = 'COMPANY',
  Country = 'COUNTRY',
  DateOfBirth = 'DATE_OF_BIRTH',
  Department = 'DEPARTMENT',
  EmploymentEndDate = 'EMPLOYMENT_END_DATE',
  HiredDate = 'HIRED_DATE',
  Id = 'ID',
  LastWorkingDate = 'LAST_WORKING_DATE',
  Level = 'LEVEL',
  Location = 'LOCATION',
  PreferredFullName = 'PREFERRED_FULL_NAME',
  Status = 'STATUS',
}

/** VDP and VDD allocations for one employee for one half-year period. */
export type EmployeeManagerialAccounting = {
  __typename?: 'EmployeeManagerialAccounting';
  allocationKey: Array<EpmEmployeeAllocationAllocationKey>;
  employeeId: Scalars['ID']['output'];
  functionality: Array<EpmEmployeeAllocationFunctionality>;
  numberOfDays: EmployeeManagerialAccountingContract;
  percentageNumberOfDays: EmployeeManagerialAccountingContract;
  period: ManagerialAccountingPeriod;
  roleType: Array<EpmEmployeeAllocationRoleType>;
  vdd: Array<EpmEmployeeAllocationVdd>;
  vdp: Array<EpmEmployeeAllocationVdp>;
};

export type EmployeeManagerialAccountingContract = {
  __typename?: 'EmployeeManagerialAccountingContract';
  fullTime: Scalars['Int']['output'];
  nonFullTime: Scalars['Int']['output'];
};

/** Result wrapper for the listEmployeeManagerialAccountings list query. */
export type EmployeeManagerialAccountingList = {
  __typename?: 'EmployeeManagerialAccountingList';
  /** All quarterly allocation entries in the requested range. */
  items: Array<EmployeeManagerialAccounting>;
  /** The largest quarter across all items; null when items is empty. */
  maxQuarter?: Maybe<ManagerialAccountingPeriod>;
};

/** Suggested VDP/VDD/Functionality/RoleType allocations for a half-year period, computed from contract and job history. */
export type EmployeeManagerialAccountingSuggestion = {
  __typename?: 'EmployeeManagerialAccountingSuggestion';
  functionality: Array<ManagerialAccountingFunctionalityAllocationSuggestion>;
  period?: Maybe<ManagerialAccountingPeriod>;
  roleType: Array<ManagerialAccountingRoleTypeAllocationSuggestion>;
  vdd: Array<ManagerialAccountingVddAllocationSuggestion>;
  vdp: Array<ManagerialAccountingVdpAllocationSuggestion>;
};

export enum EmployeeMaritalStatus {
  Married = 'MARRIED',
  Single = 'SINGLE',
}

/** Employee - off boarding. */
export type EmployeeOffBoarding = {
  __typename?: 'EmployeeOffBoarding';
  detailReasonForLeaving?: Maybe<Scalars['String']['output']>;
  doNotDeactivate: EmployeeOffBoardingDoNotDeactivate;
  employeeId: Scalars['ID']['output'];
  employmentEndDate?: Maybe<Scalars['Date']['output']>;
  lastWorkingDate?: Maybe<Scalars['Date']['output']>;
  /** Performance Review period from which the employee is left out of tracking. Null when not excluded. */
  performanceReviewExclusionStart?: Maybe<PerformanceReviewPeriod>;
  reasonForLeaving?: Maybe<ReasonForLeaving>;
  reasonForLeavingId?: Maybe<Scalars['ID']['output']>;
  rehireConditionNote?: Maybe<Scalars['String']['output']>;
  rehireConditions: Array<RehireConditionTag>;
  rehireRecommendation?: Maybe<RehireRecommendation>;
  replacementValue?: Maybe<ReplacementValue>;
  replacementValueBasis: Array<ReplacementValueBasisTag>;
};

/** Employee - off boarding - do not deactivate. */
export type EmployeeOffBoardingDoNotDeactivate = {
  __typename?: 'EmployeeOffBoardingDoNotDeactivate';
  eloomi: Scalars['Boolean']['output'];
  google: Scalars['Boolean']['output'];
  greenhouse: Scalars['Boolean']['output'];
};

/** Output type for an employee. */
export type EmployeeOutput = {
  __typename?: 'EmployeeOutput';
  employee: Employee;
  id: Scalars['ID']['output'];
};

/** Employee permission. */
export type EmployeePermission = {
  __typename?: 'EmployeePermission';
  accessSpecificEmployees: Scalars['Boolean']['output'];
  companies: Array<Company>;
  companyIds: Array<Scalars['ID']['output']>;
  employeeIds: Array<Scalars['ID']['output']>;
  employees: Array<Employee>;
  id: Scalars['ID']['output'];
  /** Whether an ADMIN_PRIVATE employee has unrestricted IDP visibility scope (vs. Line-Manager-only). Only meaningful when role == ADMIN_PRIVATE. */
  idpFullAccess: Scalars['Boolean']['output'];
  role: EmployeeRole;
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlag = {
  __typename?: 'EmployeePermissionAccessFlag';
  employeeAdd: Scalars['Boolean']['output'];
  employeeAlertListView: Scalars['Boolean']['output'];
  employeeDelete: Scalars['Boolean']['output'];
  employeeExternalAccountListView: Scalars['Boolean']['output'];
  employeeExternalAccountModify: Scalars['Boolean']['output'];
  employeeExternalAccountView: Scalars['Boolean']['output'];
  employeeGeneralInformationEdit: Scalars['Boolean']['output'];
  employeeJobContractHistoryDelete: Scalars['Boolean']['output'];
  employeeJobContractHistoryEdit: Scalars['Boolean']['output'];
  employeeJobContractHistoryView: Scalars['Boolean']['output'];
  employeeManagerialAccountingEdit: Scalars['Boolean']['output'];
  employeeManagerialAccountingView: Scalars['Boolean']['output'];
  employeeOffBoardingEdit: Scalars['Boolean']['output'];
  employeeOffBoardingView: Scalars['Boolean']['output'];
  employeePendingChangesListView: Scalars['Boolean']['output'];
  employeePermissionEdit: Scalars['Boolean']['output'];
  employeePermissionView: Scalars['Boolean']['output'];
  employeePersonalInformationDelete: Scalars['Boolean']['output'];
  employeePersonalInformationEdit: Scalars['Boolean']['output'];
  employeePersonalInformationView: Scalars['Boolean']['output'];
  employeePersonalInformationViewInEmployeeList: Scalars['Boolean']['output'];
  isAdminPrivate: Scalars['Boolean']['output'];
  isAdminStandard: Scalars['Boolean']['output'];
  isDirectReport: Scalars['Boolean']['output'];
  isMyOwnData: Scalars['Boolean']['output'];
  isSuperAdmin: Scalars['Boolean']['output'];
  performanceReviewDelete: Array<PerformanceReviewDelete>;
  performanceReviewModify: Scalars['Boolean']['output'];
  performanceReviewModifyDepartmentLead: Scalars['Boolean']['output'];
  performanceReviewModifySetting: Scalars['Boolean']['output'];
  performanceReviewResultsList: Scalars['Boolean']['output'];
  performanceReviewStage: Scalars['Boolean']['output'];
  performanceReviewView: Scalars['Boolean']['output'];
  probationReviewManage: Scalars['Boolean']['output'];
  probationReviewModify: Scalars['Boolean']['output'];
  probationReviewView: Scalars['Boolean']['output'];
  reportView: Scalars['Boolean']['output'];
  settingNotificationEdit: Scalars['Boolean']['output'];
  settingNotificationView: Scalars['Boolean']['output'];
  settingView: Scalars['Boolean']['output'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeeDeleteArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeeExternalAccountModifyArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeeGeneralInformationEditArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeeJobContractHistoryDeleteArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeeJobContractHistoryEditArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeeJobContractHistoryViewArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeeManagerialAccountingEditArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeeManagerialAccountingViewArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeeOffBoardingEditArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeePermissionEditArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeePersonalInformationDeleteArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeePersonalInformationEditArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagEmployeePersonalInformationViewArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagIsDirectReportArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagIsMyOwnDataArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagPerformanceReviewDeleteArgs = {
  employeeId: Scalars['ID']['input'];
  periods: Array<PerformanceReviewPeriodInput>;
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagPerformanceReviewModifyArgs = {
  employeeId: Scalars['ID']['input'];
  period: PerformanceReviewPeriodInput;
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagPerformanceReviewModifyDepartmentLeadArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagPerformanceReviewModifySettingArgs = {
  employeeId: Scalars['ID']['input'];
  period: PerformanceReviewPeriodInput;
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagPerformanceReviewViewArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagProbationReviewModifyArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagProbationReviewViewArgs = {
  employeeId: Scalars['ID']['input'];
};

/** Employee permission - Access flag. */
export type EmployeePermissionAccessFlagSettingNotificationEditArgs = {
  companyId: Scalars['ID']['input'];
};

/** Employee - personal information. */
export type EmployeePersonalInformation = {
  __typename?: 'EmployeePersonalInformation';
  age?: Maybe<Scalars['Int']['output']>;
  bank?: Maybe<EmployeeBank>;
  consultingFeeBank?: Maybe<EmployeeConsultingFeeBank>;
  currentAddress?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  dependencies: Array<EmployeeDependent>;
  emergencyContacts: Array<EmployeeEmergencyContact>;
  employeeId: Scalars['ID']['output'];
  gender: EmployeeGender;
  idExpiryDate?: Maybe<Scalars['Date']['output']>;
  idIssuedDate?: Maybe<Scalars['Date']['output']>;
  idIssuedPlace?: Maybe<Scalars['String']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  idType?: Maybe<EmployeeIdType>;
  maritalStatus?: Maybe<EmployeeMaritalStatus>;
  nhiDependents?: Maybe<Scalars['Int']['output']>;
  passportExpiryDate?: Maybe<Scalars['Date']['output']>;
  passportIssuedDate?: Maybe<Scalars['Date']['output']>;
  passportIssuedPlace?: Maybe<Scalars['String']['output']>;
  passportName?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  pensionVoluntaryContributionRate?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<Scalars['String']['output']>;
  personalEmail?: Maybe<Scalars['String']['output']>;
  personalPhoneNumber?: Maybe<PhoneNumber>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  residentialCountryId: Scalars['CountryCode']['output'];
  socialInsuranceNotes?: Maybe<Scalars['String']['output']>;
  socialInsuranceNumber?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  taxWithholdingRate?: Maybe<Scalars['String']['output']>;
  visas: Array<EmployeeVisa>;
};

export enum EmployeeResolutionStatus {
  OutOfScope = 'OUT_OF_SCOPE',
  Resolved = 'RESOLVED',
  Unresolvable = 'UNRESOLVABLE',
}

export enum EmployeeRole {
  AdminPrivate = 'ADMIN_PRIVATE',
  AdminStandard = 'ADMIN_STANDARD',
  Advanced = 'ADVANCED',
  Basic = 'BASIC',
  SuperAdmin = 'SUPER_ADMIN',
}

/** An employee's currently registered signature image. Only the owning employee's own query ever returns a non-null value; this field is never resolvable for another employee. */
export type EmployeeSignature = EmployeeFile & {
  __typename?: 'EmployeeSignature';
  /** Base64 data URL, e.g. data:image/png;base64,...; capped at 1MB source image. */
  imageDataUrl: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  source: EmployeeSignatureSource;
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmployeeSignatureSource {
  Drawn = 'DRAWN',
  Uploaded = 'UPLOADED',
}

export enum EmployeeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  PreOnboarding = 'PRE_ONBOARDING',
}

/** Employee - visa. */
export type EmployeeVisa = {
  __typename?: 'EmployeeVisa';
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  visaExpiryDate?: Maybe<Scalars['Date']['output']>;
  visaIssuedDate?: Maybe<Scalars['Date']['output']>;
  visaIssuedPlace?: Maybe<Scalars['String']['output']>;
  visaNumber?: Maybe<Scalars['String']['output']>;
  visaType?: Maybe<Scalars['String']['output']>;
  workPermitExpiryDate?: Maybe<Scalars['Date']['output']>;
  workPermitIssuedDate?: Maybe<Scalars['Date']['output']>;
  workPermitNumber?: Maybe<Scalars['String']['output']>;
};

/** Output type for an employee's personal information - visa. */
export type EmployeeVisaOutput = {
  __typename?: 'EmployeeVisaOutput';
  id: Scalars['ID']['output'];
  visa: EmployeeVisa;
};

export type EnumWithDisplayName = {
  displayName: Scalars['String']['output'];
};

export type EpmEmployeeAllocation = {
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
};

/** An AllocationKey allocation entry for one employee half-year. */
export type EpmEmployeeAllocationAllocationKey = EpmEmployeeAllocation & {
  __typename?: 'EpmEmployeeAllocationAllocationKey';
  epmMasterAllocationKey: EpmMasterAllocationKey;
  epmMasterAllocationKeyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
};

/** A Functionality allocation entry for one employee half-year. */
export type EpmEmployeeAllocationFunctionality = EpmEmployeeAllocation & {
  __typename?: 'EpmEmployeeAllocationFunctionality';
  epmMasterFunctionality: EpmMasterFunctionality;
  epmMasterFunctionalityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
};

/** Input for a single AllocationKey allocation entry. */
export type EpmEmployeeAllocationKeyAllocationInput = {
  epmMasterAllocationKeyId: Scalars['ID']['input'];
  percentage: Scalars['Int']['input'];
};

/** A RoleType allocation entry for one employee half-year. */
export type EpmEmployeeAllocationRoleType = EpmEmployeeAllocation & {
  __typename?: 'EpmEmployeeAllocationRoleType';
  epmMasterRoleType: EpmMasterRoleType;
  epmMasterRoleTypeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
};

/** A VDD (Value Delivered Department) allocation entry for one employee half-year. */
export type EpmEmployeeAllocationVdd = EpmEmployeeAllocation & {
  __typename?: 'EpmEmployeeAllocationVdd';
  epmMasterVdd: EpmMasterVdd;
  epmMasterVddId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
};

/** A VDP (Value Delivered Place) allocation entry for one employee half-year. */
export type EpmEmployeeAllocationVdp = EpmEmployeeAllocation & {
  __typename?: 'EpmEmployeeAllocationVdp';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
  sourceType: EpmVdpSourceType;
};

/** Input for a single Functionality allocation entry. */
export type EpmEmployeeFunctionalityAllocationInput = {
  epmMasterFunctionalityId: Scalars['ID']['input'];
  percentage: Scalars['Int']['input'];
};

/** Input for a single RoleType allocation entry. */
export type EpmEmployeeRoleTypeAllocationInput = {
  epmMasterRoleTypeId: Scalars['ID']['input'];
  percentage: Scalars['Int']['input'];
};

/** Input for a single VDD allocation entry. */
export type EpmEmployeeVddAllocationInput = {
  epmMasterVddId: Scalars['ID']['input'];
  percentage: Scalars['Int']['input'];
};

/** Input for a single VDP allocation entry. */
export type EpmEmployeeVdpAllocationInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  percentage: Scalars['Int']['input'];
  sourceType: EpmVdpSourceType;
};

/** EpmMasterAllocationKey entry. */
export type EpmMasterAllocationKey = ListItem & {
  __typename?: 'EpmMasterAllocationKey';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageStats: EpmMasterSimpleUsageStats;
};

/** Output type for an EpmMasterAllocationKey entry. */
export type EpmMasterAllocationKeyOutput = {
  __typename?: 'EpmMasterAllocationKeyOutput';
  epmMasterAllocationKey: EpmMasterAllocationKey;
  id: Scalars['ID']['output'];
};

/** EpmMasterFunctionality entry. */
export type EpmMasterFunctionality = ListItem & {
  __typename?: 'EpmMasterFunctionality';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageStats: EpmMasterSimpleUsageStats;
};

/** Output type for an EpmMasterFunctionality entry. */
export type EpmMasterFunctionalityOutput = {
  __typename?: 'EpmMasterFunctionalityOutput';
  epmMasterFunctionality: EpmMasterFunctionality;
  id: Scalars['ID']['output'];
};

/** EpmMasterRoleType entry. */
export type EpmMasterRoleType = ListItem & {
  __typename?: 'EpmMasterRoleType';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageStats: EpmMasterSimpleUsageStats;
};

/** Output type for an EpmMasterRoleType entry. */
export type EpmMasterRoleTypeOutput = {
  __typename?: 'EpmMasterRoleTypeOutput';
  epmMasterRoleType: EpmMasterRoleType;
  id: Scalars['ID']['output'];
};

/** Usage statistics for an EpmMaster entry. */
export type EpmMasterSimpleUsageStats = {
  __typename?: 'EpmMasterSimpleUsageStats';
  employeeAllocationCount: Scalars['Int']['output'];
};

/** EpmMasterVdd entry. */
export type EpmMasterVdd = ListItem & {
  __typename?: 'EpmMasterVdd';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageStats: EpmMasterVddUsageStats;
};

/** Output type for an EpmMasterVdd entry. */
export type EpmMasterVddOutput = {
  __typename?: 'EpmMasterVddOutput';
  epmMasterVdd: EpmMasterVdd;
  id: Scalars['ID']['output'];
};

/** Usage statistics for an EpmMasterVdd entry. */
export type EpmMasterVddUsageStats = {
  __typename?: 'EpmMasterVddUsageStats';
  businessUnitCount: Scalars['Int']['output'];
  employeeAllocationCount: Scalars['Int']['output'];
};

export enum EpmVdpSourceType {
  Company = 'COMPANY',
  Regional = 'REGIONAL',
}

export enum EvaluatorType {
  Reviewer = 'REVIEWER',
  Self = 'SELF',
}

export type ExportHistory = {
  completedRequestCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  createdById?: Maybe<Scalars['ID']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  resultFileName?: Maybe<Scalars['String']['output']>;
  resultUrl?: Maybe<Scalars['String']['output']>;
  status: ExportImportStatus;
  totalRequestCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ExportImportProgress = {
  completedRequestCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  createdById?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  status: ExportImportStatus;
  totalRequestCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ExportImportStatus {
  Accepted = 'ACCEPTED',
  Done = 'DONE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
}

/** Filter for number-of-employee export. */
export type ExportReportNumberOfEmployeeFilterInput = {
  addSubtotal: Scalars['Boolean']['input'];
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  endYearMonth: Scalars['YearMonth']['input'];
  exportTypes: Array<NumberOfEmployeeExportType>;
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reasonForLeavingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startYearMonth: Scalars['YearMonth']['input'];
};

/** Input type for an HRBP to extend the probation. */
export type ExtendProbationInput = {
  employeeId: Scalars['ID']['input'];
  /** Must be later than the current Probation End Date; the added review is due on it. */
  newEndDate: Scalars['Date']['input'];
  reason: Scalars['String']['input'];
};

/** Per-account-type count of Active external accounts. */
export type ExternalAccountActiveCount = {
  __typename?: 'ExternalAccountActiveCount';
  accountType: EmployeeExternalAccountType;
  count: Scalars['Int']['output'];
};

export type ExternalAccountExportHistory = ExportHistory &
  ListItem & {
    __typename?: 'ExternalAccountExportHistory';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    resultFileName?: Maybe<Scalars['String']['output']>;
    resultUrl?: Maybe<Scalars['String']['output']>;
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

export type ExternalAccountExportProgress = ExportImportProgress &
  ListItem & {
    __typename?: 'ExternalAccountExportProgress';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

export enum ExternalAccountTimingToCreate {
  Immediately = 'IMMEDIATELY',
  None = 'NONE',
  SevenDaysBefore = 'SEVEN_DAYS_BEFORE',
}

/** External account type. */
export type ExternalAccountType = {
  __typename?: 'ExternalAccountType';
  supportCreateAccount: Scalars['Boolean']['output'];
  supportDisableAccount: Scalars['Boolean']['output'];
  supportUpdateAccount: Scalars['Boolean']['output'];
  type: EmployeeExternalAccountType;
};

/** 061-idp-pdf-signing: request a sealed, signed PDF of an IDP. Accepted immediately; the PDF is emailed once the asynchronous render/sign/store pipeline completes. */
export type GenerateEmployeeIdpPdfInput = {
  /** The generator's own browser IANA time zone (e.g. "Asia/Tokyo"), used in the PDF footer. */
  generatorTimeZone: Scalars['String']['input'];
  idpId: Scalars['ID']['input'];
  /** The user's confirmed document language, pre-selected from detectedPdfLanguage. */
  language: IdpPdfLanguage;
};

export enum GoogleProductAndSku {
  AppsheetCore = 'APPSHEET_CORE',
  AppsheetEnterprisePlus = 'APPSHEET_ENTERPRISE_PLUS',
  AppsheetEnterpriseStandard = 'APPSHEET_ENTERPRISE_STANDARD',
  CloudIdentityPremium = 'CLOUD_IDENTITY_PREMIUM',
  GoogleVault = 'GOOGLE_VAULT',
  GoogleVaultFormerEmployee = 'GOOGLE_VAULT_FORMER_EMPLOYEE',
  GoogleWorkspaceAiUltraForBusiness = 'GOOGLE_WORKSPACE_AI_ULTRA_FOR_BUSINESS',
  GoogleWorkspaceBusinessPlus = 'GOOGLE_WORKSPACE_BUSINESS_PLUS',
  GoogleWorkspaceBusinessPlusArchivedUser = 'GOOGLE_WORKSPACE_BUSINESS_PLUS_ARCHIVED_USER',
  GoogleWorkspaceBusinessStandard = 'GOOGLE_WORKSPACE_BUSINESS_STANDARD',
  GoogleWorkspaceBusinessStandardArchivedUser = 'GOOGLE_WORKSPACE_BUSINESS_STANDARD_ARCHIVED_USER',
  GoogleWorkspaceBusinessStarter = 'GOOGLE_WORKSPACE_BUSINESS_STARTER',
  GoogleWorkspaceBusinessStarterArchivedUser = 'GOOGLE_WORKSPACE_BUSINESS_STARTER_ARCHIVED_USER',
  GoogleWorkspaceEnterpriseEssentials = 'GOOGLE_WORKSPACE_ENTERPRISE_ESSENTIALS',
  GoogleWorkspaceEnterpriseEssentialsPlus = 'GOOGLE_WORKSPACE_ENTERPRISE_ESSENTIALS_PLUS',
  GoogleWorkspaceEnterprisePlus = 'GOOGLE_WORKSPACE_ENTERPRISE_PLUS',
  GoogleWorkspaceEnterprisePlusArchivedUser = 'GOOGLE_WORKSPACE_ENTERPRISE_PLUS_ARCHIVED_USER',
  GoogleWorkspaceEnterpriseStandard = 'GOOGLE_WORKSPACE_ENTERPRISE_STANDARD',
  GoogleWorkspaceEnterpriseStandardArchivedUser = 'GOOGLE_WORKSPACE_ENTERPRISE_STANDARD_ARCHIVED_USER',
  GoogleWorkspaceEnterpriseStarter = 'GOOGLE_WORKSPACE_ENTERPRISE_STARTER',
  GoogleWorkspaceEssentials = 'GOOGLE_WORKSPACE_ESSENTIALS',
  GoogleWorkspaceFrontlinePlus = 'GOOGLE_WORKSPACE_FRONTLINE_PLUS',
  GoogleWorkspaceFrontlineStandard = 'GOOGLE_WORKSPACE_FRONTLINE_STANDARD',
  GoogleWorkspaceFrontlineStarter = 'GOOGLE_WORKSPACE_FRONTLINE_STARTER',
}

/** External account - Google Product and SKU. */
export type GoogleProductAndSkuWithDisplayName = EnumWithDisplayName & {
  __typename?: 'GoogleProductAndSKUWithDisplayName';
  displayName: Scalars['String']['output'];
  value: GoogleProductAndSku;
};

export enum HalfYear {
  H1 = 'H1',
  H2 = 'H2',
}

export enum HiredDateLimitKind {
  Absolute = 'ABSOLUTE',
  None = 'NONE',
  Relative = 'RELATIVE',
}

/** HubSpot pipeline. */
export type HubspotPipeline = ListItem & {
  __typename?: 'HubspotPipeline';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useBIResultByDefault: Scalars['Boolean']['output'];
};

export enum IdpPdfLanguage {
  En = 'EN',
  Ja = 'JA',
  Km = 'KM',
  Ko = 'KO',
  Th = 'TH',
  Vi = 'VI',
  ZhHans = 'ZH_HANS',
  ZhHant = 'ZH_HANT',
}

/** Outcome of uploading a PDF to check whether it is an unaltered, organization-signed IDP PDF (FR-014a). */
export enum IdpPdfVerificationOutcome {
  /** Signature is broken, or an intact-looking signature's file fingerprint matches no known generation. */
  Altered = 'ALTERED',
  /** No signature recognizable as this organization's was found, or the file is not a valid PDF at all. */
  NotGeneratedByThisSystem = 'NOT_GENERATED_BY_THIS_SYSTEM',
  /** Signature intact and its file fingerprint matches a known generation; metadata fields below are populated. */
  Valid = 'VALID',
}

/** Result of verifying an uploaded PDF (FR-014/FR-014a). Deliberately excludes the target employee's name and any IDP content - only metadata identifying the generation itself, never the IDP's substance. */
export type IdpPdfVerificationResult = {
  __typename?: 'IdpPdfVerificationResult';
  /** Populated only when outcome is VALID. */
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Populated only when outcome is VALID. The generator's own legal full name. */
  generatedByLegalFullName?: Maybe<Scalars['String']['output']>;
  /** Populated only when outcome is VALID, e.g. "IDP" or "IDP Lite". */
  idpTypeLabel?: Maybe<Scalars['String']['output']>;
  /** Populated only when outcome is VALID. */
  language?: Maybe<IdpPdfLanguage>;
  outcome: IdpPdfVerificationOutcome;
};

export type ImportHistory = {
  affectedEmployeeIds: Array<Scalars['ID']['output']>;
  completedRequestCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Employee>;
  createdById?: Maybe<Scalars['ID']['output']>;
  errors: Array<ImportHistoryError>;
  id: Scalars['ID']['output'];
  status: ExportImportStatus;
  totalRequestCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['Url']['output'];
};

export type ImportHistoryError = {
  message: Scalars['String']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
};

/** Job. */
export type Job = ListItem & {
  __typename?: 'Job';
  createdAt: Scalars['DateTime']['output'];
  defaultEpmMasterFunctionality?: Maybe<EpmMasterFunctionality>;
  defaultEpmMasterFunctionalityId?: Maybe<Scalars['ID']['output']>;
  definitions: Array<DefinitionItem>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum JobHistoryLevel {
  CClass = 'C_CLASS',
  Ic3 = 'IC3',
  Ic4 = 'IC4',
  Ic5 = 'IC5',
  Ic6 = 'IC6',
  Ic7 = 'IC7',
  L0 = 'L0',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  L4 = 'L4',
  L5 = 'L5',
  L6 = 'L6',
  L7 = 'L7',
}

export enum JobHistoryStatus {
  Current = 'CURRENT',
  Future = 'FUTURE',
  Past = 'PAST',
}

export enum JobHistoryType {
  ChangeWithoutPromotionDemotion = 'CHANGE_WITHOUT_PROMOTION_DEMOTION',
  ExtendedLeave = 'EXTENDED_LEAVE',
  Join = 'JOIN',
  NewContract = 'NEW_CONTRACT',
  ParentalLeave = 'PARENTAL_LEAVE',
  PromotionDemotion = 'PROMOTION_DEMOTION',
  Transfer = 'TRANSFER',
}

/** Output type for a job. */
export type JobOutput = {
  __typename?: 'JobOutput';
  id: Scalars['ID']['output'];
  job: Job;
};

/** Language. */
export type Language = {
  __typename?: 'Language';
  code: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
};

/** List of business units. */
export type ListBusinessUnits = {
  __typename?: 'ListBusinessUnits';
  items: Array<BusinessUnit>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Business unit. */
export type ListBusinessUnitsFilterInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of companies. */
export type ListCompanies = {
  __typename?: 'ListCompanies';
  items: Array<Company>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Companies. */
export type ListCompaniesFilterInput = {
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterOnlyAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentCompany?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  onlyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of company email domains. */
export type ListCompanyEmailDomains = {
  __typename?: 'ListCompanyEmailDomains';
  items: Array<CompanyEmailDomain>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Company email domains. */
export type ListCompanyEmailDomainsFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of countries. */
export type ListCountries = {
  __typename?: 'ListCountries';
  items: Array<Country>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Countries. */
export type ListCountriesFilterInput = {
  hasActiveCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  hasIsdCode?: InputMaybe<Scalars['Boolean']['input']>;
  hasNationalities?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of currencies. */
export type ListCurrencies = {
  __typename?: 'ListCurrencies';
  items: Array<Currency>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Currencies. */
export type ListCurrenciesFilterInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of departments. */
export type ListDepartments = {
  __typename?: 'ListDepartments';
  items: Array<Department>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Departments. */
export type ListDepartmentsFilterInput = {
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of direct reports. */
export type ListDirectReports = {
  __typename?: 'ListDirectReports';
  allCandidates: ListDirectReportsAllCandidates;
  items: Array<Employee>;
  nonFilteredTotalCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** List of direct reports - all filter candidates. */
export type ListDirectReportsAllCandidates = {
  __typename?: 'ListDirectReportsAllCandidates';
  companyIds: Array<Scalars['ID']['output']>;
  contractTypes: Array<ContractType>;
  jobIds: Array<Scalars['ID']['output']>;
  levels: Array<JobHistoryLevel>;
  locationIds: Array<Scalars['ID']['output']>;
};

/** Filter for listing direct reports. */
export type ListDirectReportsFilterInput = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Array<JobHistoryLevel>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<EmployeeStatus>>;
  team?: InputMaybe<Scalars['String']['input']>;
};

/** List of divisions. */
export type ListDivisions = {
  __typename?: 'ListDivisions';
  items: Array<Division>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Divisions. */
export type ListDivisionsFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Filter for listing Employee alerts. */
export type ListEmployeeAlertFilterInput = {
  contractTypes?: InputMaybe<Array<ContractType>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  /** When specified `employeeIds`, other filters are ignored. */
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  priorities?: InputMaybe<Array<EmployeeAlertPriority>>;
  reasons?: InputMaybe<Array<EmployeeAlertReasonType>>;
  statuses?: InputMaybe<Array<EmployeeStatus>>;
};

export type ListEmployeeAlertItemByCountry = ListItem & {
  __typename?: 'ListEmployeeAlertItemByCountry';
  country?: Maybe<Country>;
  /** Country ID. */
  id: Scalars['ID']['output'];
  reasons: Array<EmployeeAlertReason>;
};

export type ListEmployeeAlertItemByEmployee = ListItem & {
  __typename?: 'ListEmployeeAlertItemByEmployee';
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  employee: Employee;
  /** Employee ID. */
  id: Scalars['ID']['output'];
  reasons: Array<EmployeeAlertReason>;
};

export type ListEmployeeAlertsByCountry = AbstractListEmployeeAlerts & {
  __typename?: 'ListEmployeeAlertsByCountry';
  countByPriority: EmployeeAlertCountByPriority;
  items: Array<ListEmployeeAlertItemByCountry>;
  totalCount: Scalars['Int']['output'];
};

export type ListEmployeeAlertsByEmployee = AbstractListEmployeeAlerts & {
  __typename?: 'ListEmployeeAlertsByEmployee';
  countByPriority: EmployeeAlertCountByPriority;
  items: Array<ListEmployeeAlertItemByEmployee>;
  totalCount: Scalars['Int']['output'];
};

/** List of employee list custom filters. */
export type ListEmployeeListCustomFilters = {
  __typename?: 'ListEmployeeListCustomFilters';
  items: Array<EmployeeListCustomFilter>;
  totalCount: Scalars['Int']['output'];
};

/** List of employees. */
export type ListEmployees = {
  __typename?: 'ListEmployees';
  items: Array<Employee>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing employees - External account. */
export type ListEmployeesFilterExternalAccountInput = {
  eloomi?: InputMaybe<Array<EmployeeExternalAccountStatus>>;
  github?: InputMaybe<Array<EmployeeExternalAccountStatus>>;
  google?: InputMaybe<Array<EmployeeExternalAccountStatus>>;
  greenhouse?: InputMaybe<Array<EmployeeExternalAccountStatus>>;
  hubspot?: InputMaybe<Array<EmployeeExternalAccountStatus>>;
  slack?: InputMaybe<Array<EmployeeExternalAccountStatus>>;
};

/** Filter for listing employees. */
export type ListEmployeesFilterInput = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  divisionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentEndDate?: InputMaybe<LocalDateRangeInput>;
  excludeAuthUser?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  externalAccount?: InputMaybe<ListEmployeesFilterExternalAccountInput>;
  hasAnyActiveExternalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, keeps only the employees whose probation review audit log has an entry the caller may read; a caller who may not read the audit log gets no employee. Used to offer only employees with a history. */
  hasProbationReviewAuditLog?: InputMaybe<Scalars['Boolean']['input']>;
  hiredDate?: InputMaybe<LocalDateRangeInput>;
  includeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, `team` is matched exactly - an empty `team` matches employees whose Team is blank/unset, not "no filter". When false (default), `team` keeps its existing partial/substring, case-insensitive match, where an empty value means no filter is applied. Applies only to `team`. */
  isExactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  isLeave?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSecondment?: InputMaybe<Scalars['Boolean']['input']>;
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  lastWorkingDate?: InputMaybe<LocalDateRangeInput>;
  levels?: InputMaybe<Array<JobHistoryLevel>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managerIncludesAllConnections?: InputMaybe<Scalars['Boolean']['input']>;
  nationalityIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  rehireRecommendations?: InputMaybe<Array<RehireRecommendation>>;
  replacementValues?: InputMaybe<Array<ReplacementValue>>;
  /** Restricts results to employees the caller may create an IDP for (SUPER_ADMIN: all; ADMIN_PRIVATE: scoped to permitted companies/employees; other roles: none). Used only by the Create IDP Employee field - omit/false leaves every other consumer unrestricted. */
  restrictToIdpCreationPermission?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<EmployeeRole>>;
  statuses?: InputMaybe<Array<EmployeeStatus>>;
  team?: InputMaybe<Scalars['String']['input']>;
};

/** Sort for listing employees. */
export type ListEmployeesSortInput = {
  desc: Scalars['Boolean']['input'];
  field: EmployeeListSortField;
};

/** Filter for listing EpmMasterAllocationKeys. */
export type ListEpmMasterAllocationKeyFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of EpmMasterAllocationKeys. */
export type ListEpmMasterAllocationKeys = {
  __typename?: 'ListEpmMasterAllocationKeys';
  items: Array<EpmMasterAllocationKey>;
  totalCount: Scalars['Int']['output'];
};

/** List of EpmMasterFunctionalities. */
export type ListEpmMasterFunctionalities = {
  __typename?: 'ListEpmMasterFunctionalities';
  items: Array<EpmMasterFunctionality>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing EpmMasterFunctionalities. */
export type ListEpmMasterFunctionalityFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Filter for listing EpmMasterRoleTypes. */
export type ListEpmMasterRoleTypeFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of EpmMasterRoleTypes. */
export type ListEpmMasterRoleTypes = {
  __typename?: 'ListEpmMasterRoleTypes';
  items: Array<EpmMasterRoleType>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing EpmMasterVdds. */
export type ListEpmMasterVddFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of EpmMasterVdds. */
export type ListEpmMasterVdds = {
  __typename?: 'ListEpmMasterVdds';
  items: Array<EpmMasterVdd>;
  totalCount: Scalars['Int']['output'];
};

/** Filter input for listExternalAccountsActiveSummary / exportExternalAccountList. */
export type ListExternalAccountsFilterInput = {
  /** Single account type. Null ⇒ all. */
  accountType?: InputMaybe<EmployeeExternalAccountType>;
  /** Business Unit IDs. Empty list ⇒ all within scope. */
  businessUnitIds: Array<Scalars['ID']['input']>;
  /** Company IDs. Empty list ⇒ all within scope. */
  companyIds: Array<Scalars['ID']['input']>;
  /** ISO 3166-1 alpha-2 country IDs. Empty list ⇒ all within scope. */
  countryIds: Array<Scalars['CountryCode']['input']>;
  /** Employee statuses to filter by. Empty list ⇒ all employee statuses. */
  employeeStatuses: Array<EmployeeStatus>;
};

/** List of HubSpot pipelines. */
export type ListHubspotPipelines = {
  __typename?: 'ListHubspotPipelines';
  items: Array<HubspotPipeline>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing HubSpot pipelines. */
export type ListHubspotPipelinesFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ListItem = {
  id: Scalars['ID']['output'];
};

/** List of jobs. */
export type ListJobs = {
  __typename?: 'ListJobs';
  items: Array<Job>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Jobs. */
export type ListJobsFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  onlyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of languages. */
export type ListLanguages = {
  __typename?: 'ListLanguages';
  items: Array<Language>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Languages. */
export type ListLanguagesFilterInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of locations. */
export type ListLocations = {
  __typename?: 'ListLocations';
  items: Array<Location>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing Locations. */
export type ListLocationsFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  onlyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** List of manager change reservations. */
export type ListManagerChangeReservations = {
  __typename?: 'ListManagerChangeReservations';
  items: Array<ManagerChangeReservation>;
  totalCount: Scalars['Int']['output'];
};

export type ListMcpConnections = {
  __typename?: 'ListMcpConnections';
  items: Array<McpConnection>;
  totalCount: Scalars['Int']['output'];
};

/** Narrows the connections an administrator lists. */
export type ListMcpConnectionsFilterInput = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Defaults to active connections only. */
  statuses?: InputMaybe<Array<McpConnectionStatus>>;
};

/** Filter for listing performance review. */
export type ListPerformanceReviewFilterInput = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employeeStatuses?: InputMaybe<Array<EmployeeStatus>>;
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Array<JobHistoryLevel>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  performanceReviewStages?: InputMaybe<Array<PerformanceReviewStage>>;
  period: PerformanceReviewPeriodInput;
  showDirectReportsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  showInvalidTargetSetting?: InputMaybe<Scalars['Boolean']['input']>;
};

/** List of performance review result. */
export type ListPerformanceReviewResults = {
  __typename?: 'ListPerformanceReviewResults';
  items: Array<PerformanceReviewResult>;
  period: PerformanceReviewPeriod;
  totalCount: Scalars['Int']['output'];
};

/** List of performance review. */
export type ListPerformanceReviews = {
  __typename?: 'ListPerformanceReviews';
  items: Array<PerformanceReview>;
  period: PerformanceReviewPeriod;
  totalCount: Scalars['Int']['output'];
};

/** Sort for listing performance reviews. */
export type ListPerformanceReviewsSortInput = {
  desc: Scalars['Boolean']['input'];
  field: PerformanceReviewListSortField;
};

/** Filter for listing probation reviews. */
export type ListProbationReviewFilterInput = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Employee Status of the rows, by the Last Working Date. Default: ACTIVE. */
  employeeStatuses?: InputMaybe<Array<EmployeeStatus>>;
  /** A single flag. */
  flag?: InputMaybe<ProbationReviewFlag>;
  /** ID, name or email address. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  probationEndDateFrom?: InputMaybe<Scalars['Date']['input']>;
  probationEndDateTo?: InputMaybe<Scalars['Date']['input']>;
  probationStatuses?: InputMaybe<Array<ProbationStatus>>;
  /** Month whose due dates the list shows. Default: the current month on the server. */
  reviewDueMonth?: InputMaybe<Scalars['YearMonth']['input']>;
  /** Applies to the review shown in the row for the selected month. */
  reviewStatuses?: InputMaybe<Array<ProbationReviewReviewStatus>>;
  /** Saved view. Default: NEEDS_ACTION. Ignored (My Employees is used) for roles that are not HRBP. */
  view?: InputMaybe<ProbationReviewView>;
};

/** List of probation review. */
export type ListProbationReviews = {
  __typename?: 'ListProbationReviews';
  items: Array<ProbationReview>;
  totalCount: Scalars['Int']['output'];
};

/** List of off boarding - reason for leaving. */
export type ListReasonForLeavings = {
  __typename?: 'ListReasonForLeavings';
  items: Array<ReasonForLeaving>;
  totalCount: Scalars['Int']['output'];
};

/** Filter for listing off boarding - reason for leaving. */
export type ListReasonForLeavingsFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Range of local date (yyyy-MM-dd). */
export type LocalDateRange = {
  __typename?: 'LocalDateRange';
  end?: Maybe<Scalars['Date']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
};

/** Range of local date (yyyy-MM-dd). */
export type LocalDateRangeInput = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

/** Location. */
export type Location = ListItem & {
  __typename?: 'Location';
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Output type for a location. */
export type LocationOutput = {
  __typename?: 'LocationOutput';
  id: Scalars['ID']['output'];
  location: Location;
};

/** A scheduled manager change reservation for an employee. */
export type ManagerChangeReservation = ListItem & {
  __typename?: 'ManagerChangeReservation';
  dottedLineManager?: Maybe<Employee>;
  dottedLineManagerId?: Maybe<Scalars['ID']['output']>;
  effectiveDate: Scalars['Date']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  errorReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  primaryManager?: Maybe<Employee>;
  primaryManagerId?: Maybe<Scalars['ID']['output']>;
  status: ManagerChangeReservationStatus;
};

export enum ManagerChangeReservationStatus {
  Applied = 'APPLIED',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

/** Filter for manager change reservations list. */
export type ManagerChangeReservationsFilterInput = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  statuses?: InputMaybe<Array<ManagerChangeReservationStatus>>;
};

/** Suggested Functionality allocation entry derived from job history. */
export type ManagerialAccountingFunctionalityAllocationSuggestion = {
  __typename?: 'ManagerialAccountingFunctionalityAllocationSuggestion';
  /** Overlap days for this entry within the half-year period. */
  days: Scalars['Int']['output'];
  epmMasterFunctionality: EpmMasterFunctionality;
  epmMasterFunctionalityId: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
  /** Name of the source job that has this functionality mapped. */
  suggestionSourceNames: Array<Scalars['String']['output']>;
};

export enum ManagerialAccountingImportCategory {
  AllocationKey = 'ALLOCATION_KEY',
  Functionality = 'FUNCTIONALITY',
  RoleType = 'ROLE_TYPE',
  Vdd = 'VDD',
  Vdp = 'VDP',
}

/** Managerial Accounting import history. */
export type ManagerialAccountingImportHistory = ImportHistory &
  ListItem & {
    __typename?: 'ManagerialAccountingImportHistory';
    affectedEmployeeIds: Array<Scalars['ID']['output']>;
    affectedEmployees: Array<Employee>;
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    errors: Array<ManagerialAccountingImportHistoryError>;
    id: Scalars['ID']['output'];
    skippedEmployeeIds: Array<Scalars['ID']['output']>;
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    url: Scalars['Url']['output'];
  };

/** Managerial Accounting import history error. */
export type ManagerialAccountingImportHistoryError = ImportHistoryError & {
  __typename?: 'ManagerialAccountingImportHistoryError';
  category?: Maybe<ManagerialAccountingImportCategory>;
  createdAt: Scalars['DateTime']['output'];
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  quarter?: Maybe<ManagerialAccountingQuarter>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** Live progress for an in-flight Managerial Accounting import job. */
export type ManagerialAccountingImportProgress = ExportImportProgress &
  ListItem & {
    __typename?: 'ManagerialAccountingImportProgress';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

/** A quarterly period (year + Q1-Q4) used for managerial accounting queries and mutations. */
export type ManagerialAccountingPeriod = {
  __typename?: 'ManagerialAccountingPeriod';
  isCurrent: Scalars['Boolean']['output'];
  quarter: ManagerialAccountingQuarter;
  year: Scalars['Year']['output'];
};

/** A quarterly period (year + Q1-Q4) used for managerial accounting queries and mutations. */
export type ManagerialAccountingPeriodInput = {
  quarter: ManagerialAccountingQuarter;
  year: Scalars['Year']['input'];
};

export enum ManagerialAccountingQuarter {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
}

/** Suggested Role Type allocation entry derived from job history. */
export type ManagerialAccountingRoleTypeAllocationSuggestion = {
  __typename?: 'ManagerialAccountingRoleTypeAllocationSuggestion';
  /** Overlap days for this entry within the half-year period. */
  days: Scalars['Int']['output'];
  epmMasterRoleType: EpmMasterRoleType;
  epmMasterRoleTypeId: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
  /** Name of the source business unit that has this role type mapped. */
  suggestionSourceNames: Array<Scalars['String']['output']>;
};

/** Suggested VDD allocation entry derived from job history. */
export type ManagerialAccountingVddAllocationSuggestion = {
  __typename?: 'ManagerialAccountingVddAllocationSuggestion';
  /** Overlap days for this entry within the half-year period. */
  days: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  /** Name of the source business unit that has this VDD mapped. */
  suggestionSourceNames: Array<Scalars['String']['output']>;
  valueDeliveredDepartment: EpmMasterVdd;
  valueDeliveredDepartmentId: Scalars['ID']['output'];
};

/** Suggested VDP allocation entry derived from contract history. */
export type ManagerialAccountingVdpAllocationSuggestion = {
  __typename?: 'ManagerialAccountingVdpAllocationSuggestion';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['ID']['output']>;
  /** Overlap days for this entry within the half-year period. */
  days: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  sourceType: EpmVdpSourceType;
  /** Name of the source entity (company name or 'Regional'). */
  suggestionSourceNames: Array<Scalars['String']['output']>;
};

/** Input type for an HRBP to mark the Draft reviews of the selected employees as complete. */
export type MarkProbationReviewsAsCompleteInput = {
  /** Only COMPLETED_OFFLINE and LEGACY_RECORD are accepted. */
  completionMethod: ProbationReviewCompletionMethod;
  employeeIds: Array<Scalars['ID']['input']>;
};

export enum McpClientRegistrationType {
  Cimd = 'CIMD',
  Dcr = 'DCR',
}

/** An AI application an employee has connected to MED through MCP sign-in. */
export type McpConnection = ListItem & {
  __typename?: 'McpConnection';
  /** Host of the application's identifier, or null for self-registered applications. */
  clientHost?: Maybe<Scalars['String']['output']>;
  /** Name the application gave when it registered. */
  clientName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  employee: Employee;
  id: Scalars['ID']['output'];
  lastUsedAt: Scalars['DateTime']['output'];
  /** Whether the application was identified by a hosted metadata document or registered itself. */
  registrationType?: Maybe<McpClientRegistrationType>;
  revocationReason?: Maybe<McpConnectionRevocationReason>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<Employee>;
  status: McpConnectionStatus;
};

/** Why a connection was revoked. */
export enum McpConnectionRevocationReason {
  /** An administrator revoked it. */
  Admin = 'ADMIN',
  /** The employee is no longer allowed to sign in. */
  EmployeeIneligible = 'EMPLOYEE_INELIGIBLE',
  /** A refresh credential was used twice, which suggests it was copied. */
  TokenReuse = 'TOKEN_REUSE',
  /** The employee revoked it. */
  User = 'USER',
}

export enum McpConnectionStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
}

export type MergeTeamValuesInput = {
  /** employee_job_history's own row IDs to merge - exactly the rows the administrator checked on the Team job history screen. Merge updates EXACTLY these rows and no others, even another row sharing the same pre-merge Team value. */
  jobHistoryIds: Array<Scalars['ID']['input']>;
  /** The Team value every selected row is set to. Must be one of the Team values currently carried by jobHistoryIds (validated server-side against a fresh read) - a merge cannot introduce a spelling absent from the selection; use renameTeamValue for that. */
  survivor: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Activate or deactivate an AI assistant configuration. Permitted roles: SUPER_ADMIN. When activate=true: deactivates the previously active configuration in the same transaction. When activate=false: deactivates the target configuration only. */
  activateAIAssistantConfiguration: UpdateAiAssistantConfigurationOutput;
  /** Append review check-in entries across key areas, sharing one review date. */
  addEmployeeIdpKeyAreaReviews: EmployeeIdpOutput;
  /** Autofill upcoming Managerial Accounting periods for an employee using computed suggestions. Periods that already have data are skipped. backfill=true fills from the employee's hired half-year. force=true deletes existing allocations for each period before inserting; force=false uses ON CONFLICT DO NOTHING. */
  autofillEmployeeManagerialAccounting: Array<EmployeeManagerialAccounting>;
  /** Bulk create performance reviews. Allowed roles: ADMIN_STANDARD, ADMIN_PRIVATE, SUPER_ADMIN. */
  bulkCreatePerformanceReviews: BulkCreatePerformanceReviewsOutput;
  /**
   * Bulk update performance review - Setting - Stage.
   * Returns `false` if no performance review stage was updated, otherwise `true`.
   */
  bulkUpdatePerformanceReviewStage: Scalars['Int']['output'];
  /** Upsert multiple Company / Business Unit / Department relations in a single request. */
  bulkUpsertOrgHierarchyRelations: Array<OrgHierarchyRelationOutput>;
  /** Cancels a PENDING manager change reservation. Returns true on success. */
  cancelManagerChangeReservation: Scalars['Boolean']['output'];
  /** Confirm an IDP once its key areas are finalized. Locks the auto-populated snapshot fields and key areas. */
  confirmEmployeeIdp: EmployeeIdpOutput;
  /** Create a new AI assistant configuration. Permitted roles: SUPER_ADMIN. */
  createAIAssistantConfiguration: CreateAiAssistantConfigurationOutput;
  /** Create a business unit. */
  createBusinessUnit: BusinessUnitOutput;
  /** Create a company. */
  createCompany: CompanyOutput;
  /** Create a company email domain. */
  createCompanyEmailDomain: CompanyEmailDomainOutput;
  /** Create a department. */
  createDepartment: DepartmentOutput;
  /** Create a division. */
  createDivision: DivisionOutput;
  /** Create an employee. */
  createEmployee: EmployeeOutput;
  /** Create an employee's contract. */
  createEmployeeContract: EmployeeContractOutput;
  /** Create an employee's personal information - dependent. */
  createEmployeeDependent: EmployeeDependentOutput;
  /** Create an employee's personal information - emergency contact. */
  createEmployeeEmergencyContact: EmployeeEmergencyContactOutput;
  /** Create an IDP / IDP Lite for an employee. */
  createEmployeeIdp: EmployeeIdpOutput;
  /** Create an employee job history. */
  createEmployeeJobHistory: EmployeeJobHistoryOutput;
  /** Create an employee list custom filter. */
  createEmployeeListCustomFilter: EmployeeListCustomFilterOutput;
  /** Create an employee's personal information - visa. */
  createEmployeeVisa: EmployeeVisaOutput;
  /** Create an EpmMasterAllocationKey entry. */
  createEpmMasterAllocationKey: EpmMasterAllocationKeyOutput;
  /** Create an EpmMasterFunctionality entry. */
  createEpmMasterFunctionality: EpmMasterFunctionalityOutput;
  /** Create an EpmMasterRoleType entry. */
  createEpmMasterRoleType: EpmMasterRoleTypeOutput;
  /** Create an EpmMasterVdd entry. */
  createEpmMasterVdd: EpmMasterVddOutput;
  /** Create a job. */
  createJob: JobOutput;
  /** Create a language. */
  createLanguage: Scalars['Boolean']['output'];
  /** Create a location. */
  createLocation: LocationOutput;
  /** Create a performance review. */
  createPerformanceReview: CreatePerformanceReviewOutput;
  /** Create a performance review target - Target with Multiple Missions. */
  createPerformanceReviewTargetMultipleMissions: PerformanceReviewTargetOutput;
  /** Create a performance review target - Numeric (Monthly). */
  createPerformanceReviewTargetNumericMonthly: PerformanceReviewTargetOutput;
  /** Create a performance review target - Numeric (Sales - Gross Profit / Revenue). */
  createPerformanceReviewTargetNumericSales: PerformanceReviewTargetOutput;
  /** Create a performance review target - Numeric (Total). */
  createPerformanceReviewTargetNumericTotal: PerformanceReviewTargetOutput;
  /** Create an off boarding - reason for leaving. */
  createReasonForLeaving: ReasonForLeavingOutput;
  /** Delete an inactive AI assistant configuration. Permitted roles: SUPER_ADMIN. */
  deleteAIAssistantConfiguration: Scalars['Boolean']['output'];
  /** Delete a business unit. */
  deleteBusinessUnit: Scalars['Boolean']['output'];
  /** Delete a company. */
  deleteCompany: Scalars['Boolean']['output'];
  /** Delete a company email domain. */
  deleteCompanyEmailDomain: Scalars['Boolean']['output'];
  /** Delete a department. */
  deleteDepartment: Scalars['Boolean']['output'];
  /** Delete a division. */
  deleteDivision: Scalars['Boolean']['output'];
  /** Delete an employee. */
  deleteEmployee: Scalars['Boolean']['output'];
  /** Delete an employee's contract. */
  deleteEmployeeContract: Scalars['Boolean']['output'];
  /** Delete an employee's personal information - dependent. */
  deleteEmployeeDependent: Scalars['Boolean']['output'];
  /** Delete an employee's personal information - emergency contact. */
  deleteEmployeeEmergencyContact: Scalars['Boolean']['output'];
  /** Permanently delete an IDP while it is unconfirmed. */
  deleteEmployeeIdp: Scalars['Boolean']['output'];
  /** Delete an employee's job history. */
  deleteEmployeeJobHistory: Scalars['Boolean']['output'];
  /** Delete an employee list custom filter. */
  deleteEmployeeListCustomFilter: Scalars['Boolean']['output'];
  /** Delete an employee's personal information - visa. */
  deleteEmployeeVisa: Scalars['Boolean']['output'];
  /** Delete an EpmMasterAllocationKey entry. */
  deleteEpmMasterAllocationKey: Scalars['Boolean']['output'];
  /** Delete an EpmMasterFunctionality entry. */
  deleteEpmMasterFunctionality: Scalars['Boolean']['output'];
  /** Delete an EpmMasterRoleType entry. */
  deleteEpmMasterRoleType: Scalars['Boolean']['output'];
  /** Delete an EpmMasterVdd entry. */
  deleteEpmMasterVdd: Scalars['Boolean']['output'];
  /** Delete a job. */
  deleteJob: Scalars['Boolean']['output'];
  /** Delete a language. Fails if any definition references it. */
  deleteLanguage: Scalars['Boolean']['output'];
  /** Delete a location. */
  deleteLocation: Scalars['Boolean']['output'];
  /** Delete a Company / Business Unit / Department relation. */
  deleteOrgHierarchyRelation: Scalars['Boolean']['output'];
  /** Delete a performance review. */
  deletePerformanceReview: Scalars['Boolean']['output'];
  /** Delete a performance review target. */
  deletePerformanceReviewTarget: Scalars['Boolean']['output'];
  /** Delete an off boarding - reason for leaving. */
  deleteReasonForLeaving: Scalars['Boolean']['output'];
  /** Draft a probation review for reviewee. */
  draftProbationReviewForReviewee: ProbationReviewOutput;
  /** Draft a probation review for reviewer. */
  draftProbationReviewForReviewer: ProbationReviewOutput;
  /** Extend the probation (HRBP only): adds one review due on the new end date. */
  extendProbation: ProbationReviewOutput;
  /** Request a sealed, signed PDF of this IDP. Accepted immediately; the PDF is emailed to the Line Manager and HR Representative (generator CC'd) once the asynchronous pipeline completes. */
  generateEmployeeIdpPdf: EmployeeIdpOutput;
  /** Import employees. */
  importEmployees: Scalars['Boolean']['output'];
  /** Bulk-import Managerial Accounting allocations from a Google Sheets URL. */
  importManagerialAccounting: Scalars['Boolean']['output'];
  /** Mark the Draft reviews of the selected employees as complete (HRBP only). Each employee is decided on its own; the ones that cannot be completed are returned with the reason. */
  markProbationReviewsAsComplete: ProbationReviewBulkResultOutput;
  /** Merge specific employee job history records (jobHistoryIds - exactly the rows checked on the Team job history screen) into one survivor Team value - only those rows are updated, even another row sharing the same pre-merge value. Fails with TEAM_INVALID_MERGE_REQUEST if the selected rows represent fewer than two distinct Team values or the survivor is not one of them, or TEAM_MERGE_STALE_JOB_HISTORY_IDS if any selected row no longer exists at the moment the merge executes. */
  mergeTeamValues: TeamWriteOutput;
  /** Record the final IDP result. Locks the record permanently. */
  recordEmployeeIdpResult: EmployeeIdpOutput;
  /** Record the outcome of the probation (HRBP only): only while it is in progress, never over an existing outcome. A failed notification does not undo the outcome; it is reported as notificationFailed. */
  recordProbationReviewOutcome: RecordProbationReviewOutcomeOutput;
  /** Rename a single existing Team value to a new one, choosing whether historical job history records are included, scoped to countryId - a same-spelled value in a different Country is left untouched. Fails with TEAM_INVALID_MERGE_REQUEST if oldValue is blank, or TEAM_RENAME_STALE_VALUE if oldValue no longer has any matching record within countryId at the moment the rename executes. */
  renameTeamValue: TeamWriteOutput;
  /** Request external account create. */
  requestExternalAccountCreate: Scalars['Boolean']['output'];
  /** Start a refresh of the Performance Review tabulation snapshot that the Report page reads. Returns true once the refresh is queued; poll performanceReviewReportRefreshStatus for its end. Permitted roles: SUPER_ADMIN. */
  requestPerformanceReviewTabulationRefresh: Scalars['Boolean']['output'];
  /** Revokes one connection. The application loses access within its current one-hour credential. */
  revokeMcpConnection: Scalars['Boolean']['output'];
  /** Replace a period's Performance Review tabulation settings for the countries listed on the screen and return the stored state. Permitted roles: SUPER_ADMIN. */
  savePerformanceReviewTabulationSetting: PerformanceReviewTabulationSetting;
  /** Send invitation emails */
  sendInvitationEmails: Scalars['Boolean']['output'];
  /** Enable or disable the AI assistant for a specific usage context. Permitted roles: ADMIN_PRIVATE, SUPER_ADMIN. */
  setAIAssistantEnabled: Scalars['Boolean']['output'];
  /** Enqueue an Employee list export job. Returns immediately at status ACCEPTED. */
  startExportEmployees: EmployeeExportHistory;
  /** Enqueue an External Account list export job. Returns immediately at status ACCEPTED. Permitted roles: SUPER_ADMIN, ADMIN_STANDARD, ADMIN_PRIVATE. */
  startExportExternalAccountList: ExternalAccountExportHistory;
  /** Enqueue a Performance Review detail export job. Returns immediately at status ACCEPTED. */
  startExportPerformanceReviewDetails: PerformanceReviewExportHistory;
  /** Enqueue a Performance Review list export job. Returns immediately at status ACCEPTED. */
  startExportPerformanceReviewList: PerformanceReviewExportHistory;
  /** Enqueue a Performance Review results export job. Returns immediately at status ACCEPTED. */
  startExportPerformanceReviewResults: PerformanceReviewExportHistory;
  /** Enqueue a Probation Review export job (HRBP only). Returns immediately at status ACCEPTED. The export holds the rows of the list the filter gives; a non-empty employeeIds keeps only those employees. One row per review of an employee. */
  startExportProbationReviews: ProbationReviewExportHistory;
  /** Enqueue a Number-of-Employee report export job. Returns immediately at status ACCEPTED. */
  startExportReportNumberOfEmployee: NumberOfEmployeeExportHistory;
  /** Submit one review of a probation review as the reviewer. It sets no outcome. */
  submitProbationReviewStage: ProbationReviewOutput;
  /** Update an AI assistant configuration. Permitted roles: SUPER_ADMIN. */
  updateAIAssistantConfiguration: UpdateAiAssistantConfigurationOutput;
  /** Update a business unit. */
  updateBusinessUnit: BusinessUnitOutput;
  /** Update a company. */
  updateCompany: CompanyOutput;
  /** Update a company email domain. */
  updateCompanyEmailDomain: CompanyEmailDomainOutput;
  /** Update a department. */
  updateDepartment: DepartmentOutput;
  /** Update a division. */
  updateDivision: DivisionOutput;
  /** Update an employee's contract. */
  updateEmployeeContract: EmployeeContractOutput;
  /** Update an employee's contract note. */
  updateEmployeeContractNote: EmployeeOutput;
  /** Update an employee's current job position. */
  updateEmployeeCurrentJobPosition: EmployeeJobHistoryOutput;
  /** Update an employee's personal information - dependent. */
  updateEmployeeDependent: EmployeeDependentOutput;
  /** Update an employee's personal information - emergency contact. */
  updateEmployeeEmergencyContact: EmployeeEmergencyContactOutput;
  /** Update an employee's general information. */
  updateEmployeeGeneralInformation: EmployeeOutput;
  /** Update the Line Manager, HR Representative, and Notes together. */
  updateEmployeeIdp: EmployeeIdpOutput;
  /** Update auto-populated snapshot fields while the IDP is in DRAFT status. */
  updateEmployeeIdpDraftFields: EmployeeIdpOutput;
  /** Hide or unhide an IDP from its subject employee's own Dashboard widget and Employee Detail tab. */
  updateEmployeeIdpHiddenFromEmployee: EmployeeIdpOutput;
  /** Update key area text fields. Blocked once the IDP is confirmed. */
  updateEmployeeIdpKeyAreas: EmployeeIdpOutput;
  /** Change an IDP's start date while it is unconfirmed. Recalculates end date and review deadline. */
  updateEmployeeIdpStartDate: EmployeeIdpOutput;
  /** Update an employee's job history. */
  updateEmployeeJobHistory: EmployeeJobHistoryOutput;
  /** Update an employee's job history note. */
  updateEmployeeJobHistoryNote: EmployeeOutput;
  /** Update an employee list custom filter. */
  updateEmployeeListCustomFilter: EmployeeListCustomFilterOutput;
  /** Update an employee's off boarding. */
  updateEmployeeOffBoarding: EmployeeOutput;
  /** Update an employee's permission. */
  updateEmployeePermission: EmployeeOutput;
  /** Update an employee's personal information. */
  updateEmployeePersonalInformation: EmployeeOutput;
  /** Update an employee's personal information - visa. */
  updateEmployeeVisa: EmployeeVisaOutput;
  /** Update an EpmMasterAllocationKey entry. */
  updateEpmMasterAllocationKey: EpmMasterAllocationKeyOutput;
  /** Update an EpmMasterFunctionality entry. */
  updateEpmMasterFunctionality: EpmMasterFunctionalityOutput;
  /** Update an EpmMasterRoleType entry. */
  updateEpmMasterRoleType: EpmMasterRoleTypeOutput;
  /** Update an EpmMasterVdd entry. */
  updateEpmMasterVdd: EpmMasterVddOutput;
  /** Update a job. */
  updateJob: JobOutput;
  /** Update a language's display name. */
  updateLanguage: Scalars['Boolean']['output'];
  /** Update a location. */
  updateLocation: LocationOutput;
  /** Update a notification setting. */
  updateNotificationSetting: NotificationSettingOutput;
  /**
   * Update performance review notification setting.
   * Always returns `true`.
   */
  updatePerformanceReviewCompanyNotification: Scalars['Boolean']['output'];
  /** Update a performance review - My Development Plan V1 for Target Evaluation. */
  updatePerformanceReviewMyDevelopmentPlanV1ForTargetEvaluation: PerformanceReviewOutput;
  /** Update a performance review - My Development Plan V1 for Target Setting. */
  updatePerformanceReviewMyDevelopmentPlanV1ForTargetSetting: PerformanceReviewOutput;
  /** Update a performance review - My Development Plan v2 for Target Evaluation. */
  updatePerformanceReviewMyDevelopmentPlanV2ForTargetEvaluation: PerformanceReviewOutput;
  /** Update a performance review - My Development Plan v2 for Target Setting. */
  updatePerformanceReviewMyDevelopmentPlanV2ForTargetSetting: PerformanceReviewOutput;
  /** Update a performance review - My Mission - Approve edit actual amount request. */
  updatePerformanceReviewMyMissionApproveEditActualAmountRequest: Scalars['Int']['output'];
  /** Update a performance review - My Mission - Numeric sales type request. */
  updatePerformanceReviewMyMissionNumericSalesTypeRequest: PerformanceReviewOutput;
  /** Update a performance review - My Mission - Primary Manager General Feedback. */
  updatePerformanceReviewMyMissionPrimaryManagerGeneralFeedback: PerformanceReviewOutput;
  /** Update a performance review - Setting. */
  updatePerformanceReviewSetting: PerformanceReviewOutput;
  /** Update a performance review target (Target Evaluation) - Target with Multiple Missions. */
  updatePerformanceReviewTargetForTargetEvaluationMultipleMissions: PerformanceReviewTargetOutput;
  /** Update a performance review target (Target Evaluation) - Numeric (Monthly). */
  updatePerformanceReviewTargetForTargetEvaluationNumericMonthly: PerformanceReviewTargetOutput;
  /** Update a performance review target (Target Evaluation) - Numeric (Sales - Gross Profit / Revenue). */
  updatePerformanceReviewTargetForTargetEvaluationNumericSales: PerformanceReviewTargetOutput;
  /** Update a performance review target (Target Evaluation) - Numeric (Total). */
  updatePerformanceReviewTargetForTargetEvaluationNumericTotal: PerformanceReviewTargetOutput;
  /** Update a performance review target (Target Setting) - Target with Multiple Missions. */
  updatePerformanceReviewTargetForTargetSettingMultipleMissions: PerformanceReviewTargetOutput;
  /** Update a performance review target (Target Setting) - Numeric (Monthly). */
  updatePerformanceReviewTargetForTargetSettingNumericMonthly: PerformanceReviewTargetOutput;
  /** Update a performance review target (Target Setting) - Numeric (Sales - Gross Profit / Revenue). */
  updatePerformanceReviewTargetForTargetSettingNumericSales: PerformanceReviewTargetOutput;
  /** Update a performance review target (Target Setting) - Numeric (Total). */
  updatePerformanceReviewTargetForTargetSettingNumericTotal: PerformanceReviewTargetOutput;
  /** Update a performance review - Value. */
  updatePerformanceReviewValues: PerformanceReviewOutput;
  /** Update an off boarding - reason for leaving. */
  updateReasonForLeaving: ReasonForLeavingOutput;
  /** Upsert VDP/VDD allocations for an employee for a given half-year. All existing allocations for that period are replaced. Non-empty sets must total exactly 100%. */
  upsertEmployeeManagerialAccounting: EmployeeManagerialAccounting;
  /** Registers, replaces, or (with imageDataUrl: null) removes the caller's own signature. */
  upsertMyEmployeeSignature?: Maybe<EmployeeSignature>;
  /** Upsert a Company / Business Unit / Department relation. */
  upsertOrgHierarchyRelation: OrgHierarchyRelationOutput;
  /** FR-018: hide a PDF generation from the default history view. HR-admin-only; does not delete or modify the stored file. */
  voidEmployeeIdpPdfGeneration: Scalars['Boolean']['output'];
};

export type MutationActivateAiAssistantConfigurationArgs = {
  activate: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationAddEmployeeIdpKeyAreaReviewsArgs = {
  input: AddEmployeeIdpKeyAreaReviewsInput;
};

export type MutationAutofillEmployeeManagerialAccountingArgs = {
  input: AutofillEmployeeManagerialAccountingInput;
};

export type MutationBulkCreatePerformanceReviewsArgs = {
  input: BulkCreatePerformanceReviewsInput;
};

export type MutationBulkUpdatePerformanceReviewStageArgs = {
  input: BulkUpdatePerformanceReviewStageInput;
};

export type MutationBulkUpsertOrgHierarchyRelationsArgs = {
  inputs: Array<UpsertOrgHierarchyRelationInput>;
};

export type MutationCancelManagerChangeReservationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationConfirmEmployeeIdpArgs = {
  input: ConfirmEmployeeIdpInput;
};

export type MutationCreateAiAssistantConfigurationArgs = {
  input: CreateAiAssistantConfigurationInput;
};

export type MutationCreateBusinessUnitArgs = {
  input: CreateBusinessUnitInput;
};

export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};

export type MutationCreateCompanyEmailDomainArgs = {
  input: CreateCompanyEmailDomainInput;
};

export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};

export type MutationCreateDivisionArgs = {
  input: CreateDivisionInput;
};

export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};

export type MutationCreateEmployeeContractArgs = {
  input: CreateEmployeeContractInput;
};

export type MutationCreateEmployeeDependentArgs = {
  input: CreateEmployeeDependentInput;
};

export type MutationCreateEmployeeEmergencyContactArgs = {
  input: CreateEmployeeEmergencyContactInput;
};

export type MutationCreateEmployeeIdpArgs = {
  input: CreateEmployeeIdpInput;
};

export type MutationCreateEmployeeJobHistoryArgs = {
  input: CreateEmployeeJobHistoryInput;
};

export type MutationCreateEmployeeListCustomFilterArgs = {
  input: CreateEmployeeListCustomFilterInput;
};

export type MutationCreateEmployeeVisaArgs = {
  input: CreateEmployeeVisaInput;
};

export type MutationCreateEpmMasterAllocationKeyArgs = {
  input: CreateEpmMasterAllocationKeyInput;
};

export type MutationCreateEpmMasterFunctionalityArgs = {
  input: CreateEpmMasterFunctionalityInput;
};

export type MutationCreateEpmMasterRoleTypeArgs = {
  input: CreateEpmMasterRoleTypeInput;
};

export type MutationCreateEpmMasterVddArgs = {
  input: CreateEpmMasterVddInput;
};

export type MutationCreateJobArgs = {
  input: CreateJobInput;
};

export type MutationCreateLanguageArgs = {
  input: CreateLanguageInput;
};

export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};

export type MutationCreatePerformanceReviewArgs = {
  input: CreatePerformanceReviewInput;
};

export type MutationCreatePerformanceReviewTargetMultipleMissionsArgs = {
  input: CreatePerformanceReviewTargetMultipleMissionsInput;
};

export type MutationCreatePerformanceReviewTargetNumericMonthlyArgs = {
  input: CreatePerformanceReviewTargetNumericMonthlyInput;
};

export type MutationCreatePerformanceReviewTargetNumericSalesArgs = {
  input: CreatePerformanceReviewTargetNumericSalesInput;
};

export type MutationCreatePerformanceReviewTargetNumericTotalArgs = {
  input: CreatePerformanceReviewTargetNumericTotalInput;
};

export type MutationCreateReasonForLeavingArgs = {
  input: CreateReasonForLeavingInput;
};

export type MutationDeleteAiAssistantConfigurationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteBusinessUnitArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCompanyEmailDomainArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteDepartmentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteDivisionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeContractArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeDependentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeEmergencyContactArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeIdpArgs = {
  idpId: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeJobHistoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeListCustomFilterArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeVisaArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEpmMasterAllocationKeyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEpmMasterFunctionalityArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEpmMasterRoleTypeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEpmMasterVddArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteJobArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLanguageArgs = {
  code: Scalars['String']['input'];
};

export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOrgHierarchyRelationArgs = {
  input: DeleteOrgHierarchyRelationInput;
};

export type MutationDeletePerformanceReviewArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePerformanceReviewTargetArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteReasonForLeavingArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDraftProbationReviewForRevieweeArgs = {
  input: DraftProbationReviewForRevieweeInput;
};

export type MutationDraftProbationReviewForReviewerArgs = {
  input: DraftProbationReviewForReviewerInput;
};

export type MutationExtendProbationArgs = {
  input: ExtendProbationInput;
};

export type MutationGenerateEmployeeIdpPdfArgs = {
  input: GenerateEmployeeIdpPdfInput;
};

export type MutationImportEmployeesArgs = {
  format: EmployeeImportFormat;
  timezoneOffset: Scalars['Long']['input'];
  url: Scalars['Url']['input'];
};

export type MutationImportManagerialAccountingArgs = {
  timezoneOffset: Scalars['Long']['input'];
  url: Scalars['Url']['input'];
};

export type MutationMarkProbationReviewsAsCompleteArgs = {
  input: MarkProbationReviewsAsCompleteInput;
};

export type MutationMergeTeamValuesArgs = {
  input: MergeTeamValuesInput;
};

export type MutationRecordEmployeeIdpResultArgs = {
  input: RecordEmployeeIdpResultInput;
};

export type MutationRecordProbationReviewOutcomeArgs = {
  input: RecordProbationReviewOutcomeInput;
};

export type MutationRenameTeamValueArgs = {
  input: RenameTeamValueInput;
};

export type MutationRequestExternalAccountCreateArgs = {
  employeeId: Scalars['ID']['input'];
  types: Array<EmployeeExternalAccountType>;
};

export type MutationRevokeMcpConnectionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSavePerformanceReviewTabulationSettingArgs = {
  input: SavePerformanceReviewTabulationSettingInput;
};

export type MutationSendInvitationEmailsArgs = {
  input: SendInvitationEmailsInput;
};

export type MutationSetAiAssistantEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  usage: AiAssistantUsage;
};

export type MutationStartExportEmployeesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<ListEmployeesFilterInput>;
  format: EmployeeExportFormat;
  sort?: InputMaybe<ListEmployeesSortInput>;
  timezoneOffset: Scalars['Long']['input'];
};

export type MutationStartExportExternalAccountListArgs = {
  filter: ListExternalAccountsFilterInput;
};

export type MutationStartExportPerformanceReviewDetailsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<ListPerformanceReviewFilterInput>;
  period: PerformanceReviewPeriodInput;
};

export type MutationStartExportPerformanceReviewListArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<ListPerformanceReviewFilterInput>;
  period: PerformanceReviewPeriodInput;
  sort?: InputMaybe<ListPerformanceReviewsSortInput>;
};

export type MutationStartExportPerformanceReviewResultsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<PerformanceReviewResultFilterInput>;
  period: PerformanceReviewPeriodInput;
  sort?: InputMaybe<ListPerformanceReviewsSortInput>;
};

export type MutationStartExportProbationReviewsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<ListProbationReviewFilterInput>;
};

export type MutationStartExportReportNumberOfEmployeeArgs = {
  filter: ExportReportNumberOfEmployeeFilterInput;
};

export type MutationSubmitProbationReviewStageArgs = {
  input: SubmitProbationReviewStageInput;
};

export type MutationUpdateAiAssistantConfigurationArgs = {
  input: UpdateAiAssistantConfigurationInput;
};

export type MutationUpdateBusinessUnitArgs = {
  input: UpdateBusinessUnitInput;
};

export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};

export type MutationUpdateCompanyEmailDomainArgs = {
  input: UpdateCompanyEmailDomainInput;
};

export type MutationUpdateDepartmentArgs = {
  input: UpdateDepartmentInput;
};

export type MutationUpdateDivisionArgs = {
  input: UpdateDivisionInput;
};

export type MutationUpdateEmployeeContractArgs = {
  input: UpdateEmployeeContractInput;
};

export type MutationUpdateEmployeeContractNoteArgs = {
  input: UpdateEmployeeContractNoteInput;
};

export type MutationUpdateEmployeeCurrentJobPositionArgs = {
  input: UpdateEmployeeCurrentJobPositionInput;
};

export type MutationUpdateEmployeeDependentArgs = {
  input: UpdateEmployeeDependentInput;
};

export type MutationUpdateEmployeeEmergencyContactArgs = {
  input: UpdateEmployeeEmergencyContactInput;
};

export type MutationUpdateEmployeeGeneralInformationArgs = {
  input: UpdateEmployeeGeneralInformationInput;
};

export type MutationUpdateEmployeeIdpArgs = {
  input: UpdateEmployeeIdpInput;
};

export type MutationUpdateEmployeeIdpDraftFieldsArgs = {
  input: UpdateEmployeeIdpDraftFieldsInput;
};

export type MutationUpdateEmployeeIdpHiddenFromEmployeeArgs = {
  input: UpdateEmployeeIdpHiddenFromEmployeeInput;
};

export type MutationUpdateEmployeeIdpKeyAreasArgs = {
  input: UpdateEmployeeIdpKeyAreasInput;
};

export type MutationUpdateEmployeeIdpStartDateArgs = {
  input: UpdateEmployeeIdpStartDateInput;
};

export type MutationUpdateEmployeeJobHistoryArgs = {
  input: UpdateEmployeeJobHistoryInput;
};

export type MutationUpdateEmployeeJobHistoryNoteArgs = {
  input: UpdateEmployeeJobHistoryNoteInput;
};

export type MutationUpdateEmployeeListCustomFilterArgs = {
  input: UpdateEmployeeListCustomFilterInput;
};

export type MutationUpdateEmployeeOffBoardingArgs = {
  input: UpdateEmployeeOffBoardingInput;
};

export type MutationUpdateEmployeePermissionArgs = {
  input: UpdateEmployeePermissionInput;
};

export type MutationUpdateEmployeePersonalInformationArgs = {
  input: UpdateEmployeePersonalInformationInput;
};

export type MutationUpdateEmployeeVisaArgs = {
  input: UpdateEmployeeVisaInput;
};

export type MutationUpdateEpmMasterAllocationKeyArgs = {
  input: UpdateEpmMasterAllocationKeyInput;
};

export type MutationUpdateEpmMasterFunctionalityArgs = {
  input: UpdateEpmMasterFunctionalityInput;
};

export type MutationUpdateEpmMasterRoleTypeArgs = {
  input: UpdateEpmMasterRoleTypeInput;
};

export type MutationUpdateEpmMasterVddArgs = {
  input: UpdateEpmMasterVddInput;
};

export type MutationUpdateJobArgs = {
  input: UpdateJobInput;
};

export type MutationUpdateLanguageArgs = {
  input: UpdateLanguageInput;
};

export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};

export type MutationUpdateNotificationSettingArgs = {
  input: UpdateNotificationSettingInput;
};

export type MutationUpdatePerformanceReviewCompanyNotificationArgs = {
  input: UpdatePerformanceReviewCompanyNotificationInput;
};

export type MutationUpdatePerformanceReviewMyDevelopmentPlanV1ForTargetEvaluationArgs = {
  input: UpdatePerformanceReviewMyDevelopmentPlanV1ForTargetEvaluationInput;
};

export type MutationUpdatePerformanceReviewMyDevelopmentPlanV1ForTargetSettingArgs = {
  input: UpdatePerformanceReviewMyDevelopmentPlanV1ForTargetSettingInput;
};

export type MutationUpdatePerformanceReviewMyDevelopmentPlanV2ForTargetEvaluationArgs = {
  input: UpdatePerformanceReviewMyDevelopmentPlanV2ForTargetEvaluationInput;
};

export type MutationUpdatePerformanceReviewMyDevelopmentPlanV2ForTargetSettingArgs = {
  input: UpdatePerformanceReviewMyDevelopmentPlanV2ForTargetSettingInput;
};

export type MutationUpdatePerformanceReviewMyMissionApproveEditActualAmountRequestArgs = {
  input: UpdatePerformanceReviewMyMissionApproveEditActualAmountRequestInput;
};

export type MutationUpdatePerformanceReviewMyMissionNumericSalesTypeRequestArgs = {
  input: UpdatePerformanceReviewMyMissionNumericSalesTypeRequestInput;
};

export type MutationUpdatePerformanceReviewMyMissionPrimaryManagerGeneralFeedbackArgs = {
  input: UpdatePerformanceReviewMyMissionPrimaryManagerGeneralFeedbackInput;
};

export type MutationUpdatePerformanceReviewSettingArgs = {
  input: UpdatePerformanceReviewSettingInput;
};

export type MutationUpdatePerformanceReviewTargetForTargetEvaluationMultipleMissionsArgs = {
  input: UpdatePerformanceReviewTargetForTargetEvaluationMultipleMissionsInput;
};

export type MutationUpdatePerformanceReviewTargetForTargetEvaluationNumericMonthlyArgs = {
  input: UpdatePerformanceReviewTargetForTargetEvaluationNumericMonthlyInput;
};

export type MutationUpdatePerformanceReviewTargetForTargetEvaluationNumericSalesArgs = {
  input: UpdatePerformanceReviewTargetForTargetEvaluationNumericSalesInput;
};

export type MutationUpdatePerformanceReviewTargetForTargetEvaluationNumericTotalArgs = {
  input: UpdatePerformanceReviewTargetForTargetEvaluationNumericTotalInput;
};

export type MutationUpdatePerformanceReviewTargetForTargetSettingMultipleMissionsArgs = {
  input: UpdatePerformanceReviewTargetForTargetSettingMultipleMissionsInput;
};

export type MutationUpdatePerformanceReviewTargetForTargetSettingNumericMonthlyArgs = {
  input: UpdatePerformanceReviewTargetForTargetSettingNumericMonthlyInput;
};

export type MutationUpdatePerformanceReviewTargetForTargetSettingNumericSalesArgs = {
  input: UpdatePerformanceReviewTargetForTargetSettingNumericSalesInput;
};

export type MutationUpdatePerformanceReviewTargetForTargetSettingNumericTotalArgs = {
  input: UpdatePerformanceReviewTargetForTargetSettingNumericTotalInput;
};

export type MutationUpdatePerformanceReviewValuesArgs = {
  input: UpdatePerformanceReviewValuesInput;
};

export type MutationUpdateReasonForLeavingArgs = {
  input: UpdateReasonForLeavingInput;
};

export type MutationUpsertEmployeeManagerialAccountingArgs = {
  input: UpsertEmployeeManagerialAccountingInput;
};

export type MutationUpsertMyEmployeeSignatureArgs = {
  input: UpsertMyEmployeeSignatureInput;
};

export type MutationUpsertOrgHierarchyRelationArgs = {
  input: UpsertOrgHierarchyRelationInput;
};

export type MutationVoidEmployeeIdpPdfGenerationArgs = {
  generationId: Scalars['ID']['input'];
};

/** Performance review - My Development Plan. */
export type MyDevelopmentPlan = {
  feedback: PerformanceReviewEvaluationFeedback;
};

export enum NotificationDate {
  Before_6Months = 'BEFORE_6_MONTHS',
  Before_14Days = 'BEFORE_14_DAYS',
  Before_30Days = 'BEFORE_30_DAYS',
  Before_45Days = 'BEFORE_45_DAYS',
  Before_90Days = 'BEFORE_90_DAYS',
  OnTheDay = 'ON_THE_DAY',
}

/** Notification option. */
export type NotificationOption = {
  enabled: Scalars['Boolean']['output'];
  notifiedUsers: Array<NotificationUser>;
};

/** Notification option (custom dates). */
export type NotificationOptionCustomDates = NotificationOption & {
  __typename?: 'NotificationOptionCustomDates';
  enabled: Scalars['Boolean']['output'];
  notifiedDates: Array<NotificationDate>;
  notifiedUsers: Array<NotificationUser>;
};

/** Notification option (static dates). */
export type NotificationOptionStaticDates = NotificationOption & {
  __typename?: 'NotificationOptionStaticDates';
  enabled: Scalars['Boolean']['output'];
  notifiedUsers: Array<NotificationUser>;
};

/** Notification setting. */
export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  company: Company;
  companyId: Scalars['ID']['output'];
  contractEndDate: NotificationOptionCustomDates;
  country: Country;
  countryId: Scalars['CountryCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  employmentEndDate: NotificationOptionCustomDates;
  idExpiryDate: NotificationOptionCustomDates;
  lastWorkingDate: NotificationOptionCustomDates;
  passportExpiryDate: NotificationOptionCustomDates;
  probationReviewDeadlineForEach: NotificationOptionCustomDates;
  probationReviewResult: NotificationOptionStaticDates;
  probationReviewScheduledEndDate: NotificationOptionStaticDates;
  returnFromExtendedLeave: NotificationOptionCustomDates;
  sixMonthServiceCompletion?: Maybe<NotificationOptionStaticDates>;
  updatedAt: Scalars['DateTime']['output'];
  visaExpiryDate: NotificationOptionCustomDates;
  workPermitExpiryDate: NotificationOptionCustomDates;
};

/** Output type for notification setting. */
export type NotificationSettingOutput = {
  __typename?: 'NotificationSettingOutput';
  company: Company;
  id: Scalars['ID']['output'];
};

export enum NotificationUser {
  AdminPrivate = 'ADMIN_PRIVATE',
  AdminStandard = 'ADMIN_STANDARD',
  PrimaryManager = 'PRIMARY_MANAGER',
  SuperAdmin = 'SUPER_ADMIN',
  TheEmployee = 'THE_EMPLOYEE',
}

/** Allocation Key FTE report: rows keyed by allocation key, each with a list of per-period FTE values. */
export type NumberOfEmployeeByAllocationKey = ReportNumberOfEmployeeByYearHalf & {
  __typename?: 'NumberOfEmployeeByAllocationKey';
  fteTotal: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
  items: Array<NumberOfEmployeeByAllocationKeyItem>;
  periodList: Array<ManagerialAccountingPeriod>;
};

/** An allocation key dimension with per-period FTE values. */
export type NumberOfEmployeeByAllocationKeyItem = ReportNumberOfEmployeeItemByYearHalf & {
  __typename?: 'NumberOfEmployeeByAllocationKeyItem';
  dimension: ReportNumberOfEmployeeDimensionAllocationKey;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
};

/** Functionality FTE report: rows keyed by functionality, each with a list of per-period FTE values. */
export type NumberOfEmployeeByFunctionality = ReportNumberOfEmployeeByYearHalf & {
  __typename?: 'NumberOfEmployeeByFunctionality';
  fteTotal: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
  items: Array<NumberOfEmployeeByFunctionalityItem>;
  periodList: Array<ManagerialAccountingPeriod>;
};

/** A functionality dimension with per-period FTE values. */
export type NumberOfEmployeeByFunctionalityItem = ReportNumberOfEmployeeItemByYearHalf & {
  __typename?: 'NumberOfEmployeeByFunctionalityItem';
  dimension: ReportNumberOfEmployeeDimensionFunctionality;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
};

/** Role Type FTE report: rows keyed by role type, each with a list of per-period FTE values. */
export type NumberOfEmployeeByRoleType = ReportNumberOfEmployeeByYearHalf & {
  __typename?: 'NumberOfEmployeeByRoleType';
  fteTotal: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
  items: Array<NumberOfEmployeeByRoleTypeItem>;
  periodList: Array<ManagerialAccountingPeriod>;
};

/** A role type dimension with per-period FTE values. */
export type NumberOfEmployeeByRoleTypeItem = ReportNumberOfEmployeeItemByYearHalf & {
  __typename?: 'NumberOfEmployeeByRoleTypeItem';
  dimension: ReportNumberOfEmployeeDimensionRoleType;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
};

/** VDD FTE report: rows keyed by VDD department, each with a list of per-period FTE values. */
export type NumberOfEmployeeByVdd = ReportNumberOfEmployeeByYearHalf & {
  __typename?: 'NumberOfEmployeeByVdd';
  fteTotal: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
  items: Array<NumberOfEmployeeByVddItem>;
  periodList: Array<ManagerialAccountingPeriod>;
};

/** A VDD department dimension with per-period FTE values. */
export type NumberOfEmployeeByVddItem = ReportNumberOfEmployeeItemByYearHalf & {
  __typename?: 'NumberOfEmployeeByVddItem';
  dimension: ReportNumberOfEmployeeDimensionVdd;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
};

/** VDP FTE report: rows keyed by VDP source, each with a list of per-period FTE values. */
export type NumberOfEmployeeByVdp = ReportNumberOfEmployeeByYearHalf & {
  __typename?: 'NumberOfEmployeeByVdp';
  fteTotal: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
  items: Array<NumberOfEmployeeByVdpItem>;
  periodList: Array<ManagerialAccountingPeriod>;
};

/** A VDP source dimension with per-period FTE values. */
export type NumberOfEmployeeByVdpItem = ReportNumberOfEmployeeItemByYearHalf & {
  __typename?: 'NumberOfEmployeeByVdpItem';
  dimension: ReportNumberOfEmployeeDimensionVdp;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
};

/** VDP→VDD composite FTE report: VDP sources each containing VDD department children. */
export type NumberOfEmployeeByVdpVddComposite = ReportNumberOfEmployeeByYearHalf & {
  __typename?: 'NumberOfEmployeeByVdpVddComposite';
  fteTotal: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
  items: Array<NumberOfEmployeeByVdpVddCompositeItemVdp>;
  periodList: Array<ManagerialAccountingPeriod>;
};

/** A VDD department child row within a VDP source row. */
export type NumberOfEmployeeByVdpVddCompositeItemVdd = ReportNumberOfEmployeeItemByYearHalf & {
  __typename?: 'NumberOfEmployeeByVdpVddCompositeItemVdd';
  dimension: ReportNumberOfEmployeeDimensionVdd;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
};

/** A VDP source row with per-period FTE values and VDD department children. */
export type NumberOfEmployeeByVdpVddCompositeItemVdp = ReportNumberOfEmployeeItemByYearHalf & {
  __typename?: 'NumberOfEmployeeByVdpVddCompositeItemVdp';
  children: Array<NumberOfEmployeeByVdpVddCompositeItemVdd>;
  dimension: ReportNumberOfEmployeeDimensionVdp;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
};

export type NumberOfEmployeeExportHistory = ExportHistory &
  ListItem & {
    __typename?: 'NumberOfEmployeeExportHistory';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    resultFileName?: Maybe<Scalars['String']['output']>;
    resultUrl?: Maybe<Scalars['String']['output']>;
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

export type NumberOfEmployeeExportProgress = ExportImportProgress &
  ListItem & {
    __typename?: 'NumberOfEmployeeExportProgress';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

export enum NumberOfEmployeeExportType {
  ActiveEmployee = 'ACTIVE_EMPLOYEE',
  AllocationKey = 'ALLOCATION_KEY',
  BusinessUnit = 'BUSINESS_UNIT',
  Company = 'COMPANY',
  CompanyBusinessUnitDepartment = 'COMPANY__BUSINESS_UNIT__DEPARTMENT',
  CompanyBusinessUnitJob = 'COMPANY__BUSINESS_UNIT__JOB',
  Functionality = 'FUNCTIONALITY',
  Job = 'JOB',
  Location = 'LOCATION',
  Nationality = 'NATIONALITY',
  RoleType = 'ROLE_TYPE',
  Summary = 'SUMMARY',
  Turnover = 'TURNOVER',
  Vdd = 'VDD',
  Vdp = 'VDP',
  VdpVddComposite = 'VDP_VDD_COMPOSITE',
}

/** Employee node for org chart display. */
export type OrgChartEmployee = {
  __typename?: 'OrgChartEmployee';
  currentMainContract?: Maybe<EmployeeContract>;
  currentPosition?: Maybe<EmployeeJobHistory>;
  employee: Employee;
  id: Scalars['ID']['output'];
};

/** Filter for org chart query. */
export type OrgChartFilterInput = {
  includeInactive: Scalars['Boolean']['input'];
};

/** Company / Business Unit / Department relation. */
export type OrgHierarchyRelation = {
  __typename?: 'OrgHierarchyRelation';
  businessUnit?: Maybe<BusinessUnit>;
  businessUnitId?: Maybe<Scalars['ID']['output']>;
  company: Company;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** List of org hierarchy relations. */
export type OrgHierarchyRelationList = {
  __typename?: 'OrgHierarchyRelationList';
  items: Array<OrgHierarchyRelation>;
  totalCount: Scalars['Int']['output'];
};

/** Output type for a org hierarchy relation. */
export type OrgHierarchyRelationOutput = {
  __typename?: 'OrgHierarchyRelationOutput';
  businessUnit?: Maybe<BusinessUnit>;
  businessUnitId?: Maybe<Scalars['ID']['output']>;
  company: Company;
  companyId: Scalars['ID']['output'];
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['ID']['output']>;
};

/** Performance review. */
export type PerformanceReview = ListItem & {
  __typename?: 'PerformanceReview';
  companyStage?: Maybe<PerformanceReviewStage>;
  contract?: Maybe<EmployeeContract>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isMine: Scalars['Boolean']['output'];
  jobHistory?: Maybe<EmployeeJobHistory>;
  myDevelopmentPlan: MyDevelopmentPlan;
  myMission: PerformanceReviewMyMission;
  period: PerformanceReviewPeriod;
  result: PerformanceReviewResult;
  setting: PerformanceReviewSetting;
  validation: Array<PerformanceReviewValidation>;
  values: Array<PerformanceReviewValue>;
};

/** Performance review. */
export type PerformanceReviewValidationArgs = {
  isOnlyNextStage: Scalars['Boolean']['input'];
};

export type PerformanceReviewCompanyNotification = {
  __typename?: 'PerformanceReviewCompanyNotification';
  company: Company;
  companyId: Scalars['ID']['output'];
  isSlackNotificationEnabled: Scalars['Boolean']['output'];
};

export type PerformanceReviewCompanyStage = {
  __typename?: 'PerformanceReviewCompanyStage';
  company: Company;
  companyId: Scalars['ID']['output'];
  period: PerformanceReviewPeriod;
  stage: PerformanceReviewStage;
};

export type PerformanceReviewDelete = {
  __typename?: 'PerformanceReviewDelete';
  isDeletable: Scalars['Boolean']['output'];
  period: PerformanceReviewPeriod;
};

/** Performance review - Evaluation - Assessment. */
export type PerformanceReviewEvaluationAssessment = {
  __typename?: 'PerformanceReviewEvaluationAssessment';
  reviewer?: Maybe<Scalars['Int']['output']>;
  reviewerUpdatedBy?: Maybe<Employee>;
  reviewerUpdatedById?: Maybe<Scalars['ID']['output']>;
  self?: Maybe<Scalars['Int']['output']>;
};

/** Performance review - Evaluation - Feedback. */
export type PerformanceReviewEvaluationFeedback = {
  __typename?: 'PerformanceReviewEvaluationFeedback';
  reviewer?: Maybe<Scalars['String']['output']>;
  reviewerUpdatedBy?: Maybe<Employee>;
  reviewerUpdatedById?: Maybe<Scalars['ID']['output']>;
  self?: Maybe<Scalars['String']['output']>;
};

/** A period HR may pick as the start of the exclusion, with the stage of the employee's review of that period. */
export type PerformanceReviewExclusionChoice = {
  __typename?: 'PerformanceReviewExclusionChoice';
  /** The employee's Performance Review of the period. Null when the employee has no review of it. */
  performanceReviewId?: Maybe<Scalars['ID']['output']>;
  period: PerformanceReviewPeriod;
  /** The current stage of the employee's Performance Review of the period. Null when the employee has no review of it (only the period already stored is then listed). */
  stage?: Maybe<PerformanceReviewStage>;
};

/** Choice of the Performance Review period from which an off-boarded employee is left out of tracking. A null period means not excluded. */
export type PerformanceReviewExclusionChoiceInput = {
  period?: InputMaybe<PerformanceReviewPeriodInput>;
};

/** The periods offered for the Performance Review exclusion, and the one that applies now. */
export type PerformanceReviewExclusionChoices = {
  __typename?: 'PerformanceReviewExclusionChoices';
  /** Empty when no Last working date is given; otherwise the period before the one containing the date and that period, limited to periods in which the employee has a Performance Review. The stored period is always listed. */
  choices: Array<PerformanceReviewExclusionChoice>;
  /** The stored period moved to follow the given date, with its stage and review; null when nothing applies. */
  selected?: Maybe<PerformanceReviewExclusionChoice>;
};

export type PerformanceReviewExportHistory = ExportHistory &
  ListItem & {
    __typename?: 'PerformanceReviewExportHistory';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    exportType: PerformanceReviewExportType;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    resultFileName?: Maybe<Scalars['String']['output']>;
    resultUrl?: Maybe<Scalars['String']['output']>;
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

export type PerformanceReviewExportProgress = ExportImportProgress &
  ListItem & {
    __typename?: 'PerformanceReviewExportProgress';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

export enum PerformanceReviewExportType {
  Details = 'DETAILS',
  List = 'LIST',
  Results = 'RESULTS',
}

export enum PerformanceReviewListSortField {
  EmployeeId = 'EMPLOYEE_ID',
  TotalTargetWeight = 'TOTAL_TARGET_WEIGHT',
  YearQuarter = 'YEAR_QUARTER',
}

/** Performance review - My Development Plan v1. */
export type PerformanceReviewMyDevelopmentPlanV1 = MyDevelopmentPlan & {
  __typename?: 'PerformanceReviewMyDevelopmentPlanV1';
  assessment: PerformanceReviewEvaluationAssessment;
  developmentPlan?: Maybe<Scalars['String']['output']>;
  feedback: PerformanceReviewEvaluationFeedback;
};

/** Performance review - My Development Plan v2. */
export type PerformanceReviewMyDevelopmentPlanV2 = MyDevelopmentPlan & {
  __typename?: 'PerformanceReviewMyDevelopmentPlanV2';
  behavioralPractices?: Maybe<Scalars['String']['output']>;
  capabilityToDevelop?: Maybe<Scalars['String']['output']>;
  feedback: PerformanceReviewEvaluationFeedback;
  howMyDevelopmentSuccessLooks?: Maybe<Scalars['String']['output']>;
  managerOrganizationalSupportNeeded?: Maybe<Scalars['String']['output']>;
};

/** Performance review - My Mission. */
export type PerformanceReviewMyMission = {
  __typename?: 'PerformanceReviewMyMission';
  actualFromBIWithoutTarget: Array<PerformanceReviewTargetNumericSalesActualFromBiWithoutTarget>;
  primaryManagerGeneralFeedback?: Maybe<Scalars['String']['output']>;
  targetNumericSalesTypeRequest: PerformanceReviewMyMissionNumericSalesTypeRequest;
  targets: Array<PerformanceReviewTarget>;
  totalTargetWeight: Scalars['Int']['output'];
};

export enum PerformanceReviewMyMissionNumericSalesTypeRequest {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING',
  Unset = 'UNSET',
}

/** Output type for performance review. */
export type PerformanceReviewOutput = {
  __typename?: 'PerformanceReviewOutput';
  id: Scalars['ID']['output'];
  performanceReview: PerformanceReview;
};

/** Performance review - Period. */
export type PerformanceReviewPeriod = {
  __typename?: 'PerformanceReviewPeriod';
  effectivePeriod: PerformanceReviewPeriodRange;
  isCurrent: Scalars['Boolean']['output'];
  quarter: PerformanceReviewQuarter;
  version: PerformanceReviewVersion;
  year: Scalars['Int']['output'];
};

/** Input type for Performance review - Period. */
export type PerformanceReviewPeriodInput = {
  quarter: PerformanceReviewQuarter;
  year: Scalars['Int']['input'];
};

/** Performance review - Period range. */
export type PerformanceReviewPeriodRange = {
  __typename?: 'PerformanceReviewPeriodRange';
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
};

export enum PerformanceReviewQuarter {
  Q1Q2 = 'Q1_Q2',
  Q3Q4 = 'Q3_Q4',
}

/** The Performance Review tabulation of a period per country and company. Figures come from an hourly snapshot; see refreshedAt. */
export type PerformanceReviewReport = {
  __typename?: 'PerformanceReviewReport';
  /** Countries that have rows in the period, regardless of the filter. */
  availableCountries: Array<Country>;
  period: PerformanceReviewPeriod;
  /** Completion time of the last successful snapshot refresh. Null when unknown. */
  refreshedAt?: Maybe<Scalars['DateTime']['output']>;
  rows: Array<PerformanceReviewReportRow>;
};

/** Narrows the Performance Review report. */
export type PerformanceReviewReportFilterInput = {
  /** Only these countries. Null or empty means all countries. */
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Where the Performance Review tabulation snapshot stands, for the Refresh button of the Report page. */
export type PerformanceReviewReportRefreshStatus = {
  __typename?: 'PerformanceReviewReportRefreshStatus';
  /** A manual refresh was requested after the last refresh and the request is less than 5 minutes old. Decided by the database clock, so every user sees the same state. */
  isRefreshing: Scalars['Boolean']['output'];
  /** Start of the last refresh. Null when it has never run. */
  refreshedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The Performance Review tabulation of one company in one period. */
export type PerformanceReviewReportRow = {
  __typename?: 'PerformanceReviewReportRow';
  company: Company;
  /** The company's stage for the period. Null when none is recorded. */
  companyStage?: Maybe<PerformanceReviewStage>;
  country: Country;
  developmentPlanApplicableCount: Scalars['Int']['output'];
  developmentPlanFilledCount: Scalars['Int']['output'];
  /** developmentPlanFilledCount / developmentPlanApplicableCount. Null when no employee is subject to the development plan, as in periods before it applied. */
  developmentPlanFilledRate?: Maybe<Scalars['Float']['output']>;
  /** Target employees per stage of their own review; every stage is present. */
  stageCounts: Array<PerformanceReviewStageCount>;
  targetEmployeeCount: Scalars['Int']['output'];
  weight100Count: Scalars['Int']['output'];
  /** weight100Count / targetEmployeeCount, from 0 to 1. */
  weight100Rate: Scalars['Float']['output'];
};

/** Performance review result. */
export type PerformanceReviewResult = ListItem & {
  __typename?: 'PerformanceReviewResult';
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  growthTarget: Scalars['BigDecimal']['output'];
  /** Same as `employeeId` */
  id: Scalars['ID']['output'];
  performanceReview: PerformanceReview;
  performanceReviewId: Scalars['ID']['output'];
  performanceTarget: PerformanceReviewResultPerformanceTarget;
  value: PerformanceReviewResultResult;
};

/** Filter for performance review result. */
export type PerformanceReviewResultFilterInput = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employeeStatuses?: InputMaybe<Array<EmployeeStatus>>;
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Array<JobHistoryLevel>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  period: PerformanceReviewPeriodInput;
};

export enum PerformanceReviewResultOverrideRequest {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Unset = 'UNSET',
}

/** Performance review result - Performance Target. */
export type PerformanceReviewResultPerformanceTarget = {
  __typename?: 'PerformanceReviewResultPerformanceTarget';
  /** All. */
  all: PerformanceReviewResultResult;
  /** Numeric (Sales - Gross Profit / Revenue). */
  numericSales: PerformanceReviewResultPerformanceTargetNumericSales;
  /** Others. */
  others: PerformanceReviewResultPerformanceTargetOthers;
};

/** Performance review result - Performance Target - Numeric (Sales - Gross Profit / Revenue). */
export type PerformanceReviewResultPerformanceTargetNumericSales = {
  __typename?: 'PerformanceReviewResultPerformanceTargetNumericSales';
  grossProfit: PerformanceReviewResultResult;
  revenue: PerformanceReviewResultResult;
  total: PerformanceReviewResultResult;
};

/** Performance review result - Performance Target - Others. */
export type PerformanceReviewResultPerformanceTargetOthers = {
  __typename?: 'PerformanceReviewResultPerformanceTargetOthers';
  all: PerformanceReviewResultResult;
  /** Target with Multiple Missions. */
  multipleMissions: PerformanceReviewResultResult;
  /** Numeric (Monthly). */
  numericMonthly: PerformanceReviewResultResult;
  /** Numeric (Total). */
  numericTotal: PerformanceReviewResultResult;
};

export type PerformanceReviewResultResult = {
  __typename?: 'PerformanceReviewResultResult';
  score: Scalars['BigDecimal']['output'];
  weight: Scalars['Int']['output'];
};

/** Performance review - Setting. */
export type PerformanceReviewSetting = {
  __typename?: 'PerformanceReviewSetting';
  stage: PerformanceReviewStage;
  useMarkdown: Scalars['Boolean']['output'];
};

export enum PerformanceReviewStage {
  Closed = 'CLOSED',
  TargetEvaluation = 'TARGET_EVALUATION',
  TargetSetting = 'TARGET_SETTING',
}

/** The number of target employees whose own review is at one stage. */
export type PerformanceReviewStageCount = {
  __typename?: 'PerformanceReviewStageCount';
  employeeCount: Scalars['Int']['output'];
  stage: PerformanceReviewStage;
};

/** Performance Review tabulation settings of one period. */
export type PerformanceReviewTabulationSetting = {
  __typename?: 'PerformanceReviewTabulationSetting';
  countries: Array<TabulationCountrySection>;
  /** True when the period start is today or earlier in Japan Standard Time. */
  isStarted: Scalars['Boolean']['output'];
  period: PerformanceReviewPeriod;
  /** First day of the period: January 1 for Q1_Q2, July 1 for Q3_Q4. */
  periodStartDate: Scalars['Date']['output'];
  staleAbsoluteDates: Array<TabulationStaleAbsoluteDate>;
};

/** Performance review - Target. */
export type PerformanceReviewTarget = {
  feedback: PerformanceReviewEvaluationFeedback;
  id: Scalars['ID']['output'];
  performanceReview?: Maybe<PerformanceReview>;
  performanceReviewId: Scalars['ID']['output'];
};

/** Performance review - Target - Actual from BI. */
export type PerformanceReviewTargetActualFromBi = {
  __typename?: 'PerformanceReviewTargetActualFromBI';
  /** @deprecated Use `updatedAt` instead., replace with updatedAt */
  createdAt: Scalars['DateTime']['output'];
  employees: Array<Employee>;
  grossProfit?: Maybe<PerformanceReviewTargetPriceWithTwoCurrencies>;
  originalCurrency: Currency;
  originalCurrencyId: Scalars['ID']['output'];
  originalToTargetCurrencyRate?: Maybe<Scalars['BigDecimal']['output']>;
  revenue?: Maybe<PerformanceReviewTargetPriceWithTwoCurrencies>;
  targetCurrencyId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PerformanceReviewTargetActualOverride = {
  __typename?: 'PerformanceReviewTargetActualOverride';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Employee>;
  approvedById?: Maybe<Scalars['ID']['output']>;
  evidence?: Maybe<Scalars['String']['output']>;
  pendingAt?: Maybe<Scalars['DateTime']['output']>;
  request: PerformanceReviewResultOverrideRequest;
};

/** Performance review - Target - Actual value. */
export type PerformanceReviewTargetActualValue = {
  __typename?: 'PerformanceReviewTargetActualValue';
  grossProfit?: Maybe<Scalars['BigDecimal']['output']>;
  revenue?: Maybe<Scalars['BigDecimal']['output']>;
};

export enum PerformanceReviewTargetDirection {
  Downward = 'DOWNWARD',
  Upward = 'UPWARD',
}

export type PerformanceReviewTargetInput = {
  grossProfit: Scalars['BigDecimal']['input'];
  revenue: Scalars['BigDecimal']['input'];
};

/** Performance review - Target - Target with Multiple Missions. */
export type PerformanceReviewTargetMultipleMissions = PerformanceReviewTarget & {
  __typename?: 'PerformanceReviewTargetMultipleMissions';
  assessment: PerformanceReviewEvaluationAssessment;
  description?: Maybe<Scalars['String']['output']>;
  feedback: PerformanceReviewEvaluationFeedback;
  id: Scalars['ID']['output'];
  myMissionObjective?: Maybe<Scalars['String']['output']>;
  performanceReview?: Maybe<PerformanceReview>;
  performanceReviewId: Scalars['ID']['output'];
  weight: Scalars['Int']['output'];
};

/** Performance review - Target - Numeric (Monthly). */
export type PerformanceReviewTargetNumericMonthly = PerformanceReviewTarget & {
  __typename?: 'PerformanceReviewTargetNumericMonthly';
  description?: Maybe<Scalars['String']['output']>;
  direction: PerformanceReviewTargetDirection;
  feedback: PerformanceReviewEvaluationFeedback;
  id: Scalars['ID']['output'];
  myMission: Scalars['String']['output'];
  myMissionObjective?: Maybe<Scalars['String']['output']>;
  performanceReview?: Maybe<PerformanceReview>;
  performanceReviewId: Scalars['ID']['output'];
  targets: Array<PerformanceReviewTargetNumericMonthlyTarget>;
  totalActual: Scalars['BigDecimal']['output'];
  totalResult?: Maybe<Scalars['BigDecimal']['output']>;
  totalTarget: Scalars['BigDecimal']['output'];
  unit: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

/** Performance review - Target - Numeric (Monthly) - Target. */
export type PerformanceReviewTargetNumericMonthlyTarget = PerformanceReviewTargetNumericTarget & {
  __typename?: 'PerformanceReviewTargetNumericMonthlyTarget';
  actual?: Maybe<Scalars['BigDecimal']['output']>;
  result?: Maybe<Scalars['BigDecimal']['output']>;
  target: Scalars['BigDecimal']['output'];
  yearMonth: Scalars['Date']['output'];
};

/** Performance review - Target - Numeric (Sales - Gross Profit / Revenue). */
export type PerformanceReviewTargetNumericSales = PerformanceReviewTarget & {
  __typename?: 'PerformanceReviewTargetNumericSales';
  feedback: PerformanceReviewEvaluationFeedback;
  id: Scalars['ID']['output'];
  items: Array<PerformanceReviewTargetNumericSalesItem>;
  performanceReview?: Maybe<PerformanceReview>;
  performanceReviewId: Scalars['ID']['output'];
  targetType: PerformanceReviewTargetNumericSalesType;
  team?: Maybe<Scalars['String']['output']>;
  weightGrossProfit: Scalars['Int']['output'];
  weightRevenue: Scalars['Int']['output'];
};

/** Performance review - Target - Numeric (Sales - Gross Profit / Revenue) - Actual from BI without target. */
export type PerformanceReviewTargetNumericSalesActualFromBiWithoutTarget = {
  __typename?: 'PerformanceReviewTargetNumericSalesActualFromBIWithoutTarget';
  employees: Array<Employee>;
  hubspotPipeline: HubspotPipeline;
  hubspotPipelineId: Scalars['ID']['output'];
  items: Array<PerformanceReviewTargetNumericSalesItemWithoutTargetActualFromBi>;
};

/** Performance review - Target - Numeric (Sales - Gross Profit / Revenue) - Item. */
export type PerformanceReviewTargetNumericSalesItem = {
  __typename?: 'PerformanceReviewTargetNumericSalesItem';
  actualOverride: PerformanceReviewTargetActualOverride;
  currency: Currency;
  currencyId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hubspotPipeline: HubspotPipeline;
  hubspotPipelineId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  targets: Array<PerformanceReviewTargetNumericSalesItemTarget>;
  totalActualFromBI?: Maybe<PerformanceReviewTargetActualValue>;
  totalActualRevised?: Maybe<PerformanceReviewTargetActualValue>;
  totalRebate: Scalars['BigDecimal']['output'];
  totalResult?: Maybe<PerformanceReviewTargetResult>;
  totalTarget: PerformanceReviewTargetTargetValue;
};

/** Performance review - Target - Numeric (Sales - Gross Profit / Revenue) - Item - Target. */
export type PerformanceReviewTargetNumericSalesItemTarget = PerformanceReviewTargetNumericTarget & {
  __typename?: 'PerformanceReviewTargetNumericSalesItemTarget';
  actual?: Maybe<PerformanceReviewTargetNumericSalesItemTargetActual>;
  rebate?: Maybe<Scalars['BigDecimal']['output']>;
  result?: Maybe<PerformanceReviewTargetResult>;
  target: PerformanceReviewTargetTargetValue;
  yearMonth: Scalars['Date']['output'];
};

export type PerformanceReviewTargetNumericSalesItemTargetActual = {
  __typename?: 'PerformanceReviewTargetNumericSalesItemTargetActual';
  applied?: Maybe<PerformanceReviewTargetActualValue>;
  fromBI: Array<PerformanceReviewTargetActualFromBi>;
  revised?: Maybe<PerformanceReviewTargetActualValue>;
};

/** Performance review - Target - Numeric (Sales - Gross Profit / Revenue) - Item without target - Actual from BI. */
export type PerformanceReviewTargetNumericSalesItemWithoutTargetActualFromBi = {
  __typename?: 'PerformanceReviewTargetNumericSalesItemWithoutTargetActualFromBI';
  biCurrencyId: Scalars['ID']['output'];
  /** @deprecated Use `updatedAt` instead., replace with updatedAt */
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  grossProfit?: Maybe<Scalars['BigDecimal']['output']>;
  medCurrencyId?: Maybe<Scalars['ID']['output']>;
  revenue?: Maybe<Scalars['BigDecimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  yearMonth: Scalars['Date']['output'];
};

export enum PerformanceReviewTargetNumericSalesType {
  Department = 'DEPARTMENT',
  Individual = 'INDIVIDUAL',
  Team = 'TEAM',
}

export type PerformanceReviewTargetNumericTarget = {
  yearMonth: Scalars['Date']['output'];
};

/** Performance review - Target - Numeric (Total). */
export type PerformanceReviewTargetNumericTotal = PerformanceReviewTarget & {
  __typename?: 'PerformanceReviewTargetNumericTotal';
  actual?: Maybe<Scalars['BigDecimal']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direction: PerformanceReviewTargetDirection;
  feedback: PerformanceReviewEvaluationFeedback;
  id: Scalars['ID']['output'];
  myMission: Scalars['String']['output'];
  myMissionObjective?: Maybe<Scalars['String']['output']>;
  performanceReview?: Maybe<PerformanceReview>;
  performanceReviewId: Scalars['ID']['output'];
  result?: Maybe<Scalars['BigDecimal']['output']>;
  target: Scalars['BigDecimal']['output'];
  unit: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

/** Output type for performance review target. */
export type PerformanceReviewTargetOutput = {
  __typename?: 'PerformanceReviewTargetOutput';
  id: Scalars['ID']['output'];
  performanceReviewTarget?: Maybe<PerformanceReviewTarget>;
};

export type PerformanceReviewTargetPriceWithTwoCurrencies = {
  __typename?: 'PerformanceReviewTargetPriceWithTwoCurrencies';
  originalCurrency?: Maybe<Scalars['BigDecimal']['output']>;
  targetCurrency?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Performance review - Target - Result. */
export type PerformanceReviewTargetResult = {
  __typename?: 'PerformanceReviewTargetResult';
  grossProfit?: Maybe<Scalars['BigDecimal']['output']>;
  revenue?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Performance review - Target - Value. */
export type PerformanceReviewTargetTargetValue = {
  __typename?: 'PerformanceReviewTargetTargetValue';
  grossProfit?: Maybe<Scalars['BigDecimal']['output']>;
  revenue?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Performance review validation. */
export type PerformanceReviewValidation = {
  __typename?: 'PerformanceReviewValidation';
  category: PerformanceReviewValidationCategory;
  errors: Array<PerformanceReviewValidationError>;
  id: Scalars['ID']['output'];
  nextStage: PerformanceReviewStage;
  validatingStage: PerformanceReviewStage;
};

export enum PerformanceReviewValidationCategory {
  GrowthTarget = 'GROWTH_TARGET',
  MyDevelopmentPlan = 'MY_DEVELOPMENT_PLAN',
  MyMission = 'MY_MISSION',
  Others = 'OTHERS',
  Values = 'VALUES',
}

/** Performance review validation error. */
export type PerformanceReviewValidationError = {
  __typename?: 'PerformanceReviewValidationError';
  evaluatorType?: Maybe<EvaluatorType>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Performance review - Value. */
export type PerformanceReviewValue = {
  __typename?: 'PerformanceReviewValue';
  assessment: PerformanceReviewEvaluationAssessment;
  performanceReviewId: Scalars['ID']['output'];
  type: AnyMindValueType;
};

export enum PerformanceReviewVersion {
  Version_1 = 'VERSION_1',
  Version_2 = 'VERSION_2',
}

/** Phone number. */
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  country: Country;
  countryId: Scalars['CountryCode']['output'];
  number: Scalars['String']['output'];
};

/** Phone number. */
export type PhoneNumberInput = {
  countryId: Scalars['CountryCode']['input'];
  number: Scalars['String']['input'];
};

/** Probation review of one employee. */
export type ProbationReview = ListItem & {
  __typename?: 'ProbationReview';
  createdAt: Scalars['DateTime']['output'];
  currentReview?: Maybe<ProbationReviewPosition>;
  daysOverdue?: Maybe<Scalars['Long']['output']>;
  displayedReview?: Maybe<ProbationReviewSummary>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  expectation?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<ProbationReviewExtensionSummary>;
  flags: Array<ProbationReviewFlag>;
  /** Whether the audit log has an entry of this employee that the caller may read, so a link to it leads to something. False for a caller who may not read the audit log. */
  hasAuditLog: Scalars['Boolean']['output'];
  /** same as `employeeId` */
  id: Scalars['ID']['output'];
  nextDueDate?: Maybe<Scalars['Date']['output']>;
  outcome?: Maybe<ProbationReviewOutcome>;
  probationEndDate?: Maybe<Scalars['Date']['output']>;
  probationStatus: ProbationStatus;
  reviewerAbsent: Scalars['Boolean']['output'];
  reviews: Array<ProbationReviewStage>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProbationReviewActionError {
  EmployeeHasLeft = 'EMPLOYEE_HAS_LEFT',
  EmployeeNotFound = 'EMPLOYEE_NOT_FOUND',
  InvalidCompletionMethod = 'INVALID_COMPLETION_METHOD',
  NotPermitted = 'NOT_PERMITTED',
  NoDraftReview = 'NO_DRAFT_REVIEW',
}

export enum ProbationReviewAuditAction {
  ExtendProbation = 'EXTEND_PROBATION',
  MarkAsComplete = 'MARK_AS_COMPLETE',
  ReassignReviewer = 'REASSIGN_REVIEWER',
  RecordOutcome = 'RECORD_OUTCOME',
  SaveDraft = 'SAVE_DRAFT',
  SubmitReview = 'SUBMIT_REVIEW',
}

/** One column of an audit log entry, with its values before and after. */
export type ProbationReviewAuditChange = {
  __typename?: 'ProbationReviewAuditChange';
  column: Scalars['String']['output'];
  /** True when oldValue and newValue are employee IDs (the reviewer columns); oldEmployee and newEmployee then hold the employees. */
  employeeReference: Scalars['Boolean']['output'];
  /** True for a free-text column that may run long (expectation, self and reviewer feedback, outcome comment, extension reason): a screen can show it apart from the table. */
  longText: Scalars['Boolean']['output'];
  /** The employee of newValue. Null when this is not an employee column, or that employee no longer exists. */
  newEmployee?: Maybe<Employee>;
  /** The value after, as a JSON value of the type the column has. Null when it has none. */
  newValue?: Maybe<Scalars['JSON']['output']>;
  /** The employee of oldValue. Null when this is not an employee column, or that employee no longer exists. */
  oldEmployee?: Maybe<Employee>;
  /** The value before, as a JSON value of the type the column has (a string, a number or a boolean). Null when it had none. */
  oldValue?: Maybe<Scalars['JSON']['output']>;
};

/** An entry of the audit log of the probation review tables. */
export type ProbationReviewAuditLog = ListItem & {
  __typename?: 'ProbationReviewAuditLog';
  /** Null for a change made by a background process or a data correction. */
  action?: Maybe<ProbationReviewAuditAction>;
  changedAt: Scalars['DateTime']['output'];
  /** Who made the change. Null for the system, or when that employee no longer exists. */
  changedBy?: Maybe<Employee>;
  /** Column by column; never the raw row. */
  changes: Array<ProbationReviewAuditChange>;
  /** The employee whose probation review changed. Null when that employee no longer exists. */
  employee?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  operation: ProbationReviewAuditOperation;
  /** Zero-based position of the review stage the row belongs to. Null for the table of the probation review itself. */
  stageIndex?: Maybe<Scalars['Int']['output']>;
  tableName: Scalars['String']['output'];
};

/** Filter for the audit log of the probation review tables. */
export type ProbationReviewAuditLogFilterInput = {
  /** Who made the change. */
  actingEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  actions?: InputMaybe<Array<ProbationReviewAuditAction>>;
  changedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  changedTo?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  operations?: InputMaybe<Array<ProbationReviewAuditOperation>>;
  tableNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A page of the audit log. */
export type ProbationReviewAuditLogResult = {
  __typename?: 'ProbationReviewAuditLogResult';
  items: Array<ProbationReviewAuditLog>;
  totalCount: Scalars['Int']['output'];
};

export enum ProbationReviewAuditOperation {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE',
}

/** The result of a bulk action: the employees it was applied to and the ones it was refused for. */
export type ProbationReviewBulkResultOutput = {
  __typename?: 'ProbationReviewBulkResultOutput';
  skipped: Array<ProbationReviewBulkSkipOutput>;
  succeeded: Array<Scalars['ID']['output']>;
};

/** An employee an HRBP action was refused for, with the reason. */
export type ProbationReviewBulkSkipOutput = {
  __typename?: 'ProbationReviewBulkSkipOutput';
  employeeId: Scalars['ID']['output'];
  reason: ProbationReviewActionError;
};

export enum ProbationReviewCompletionMethod {
  CompletedOffline = 'COMPLETED_OFFLINE',
  LegacyRecord = 'LEGACY_RECORD',
  SubmittedInMed = 'SUBMITTED_IN_MED',
}

export type ProbationReviewExportHistory = ExportHistory &
  ListItem & {
    __typename?: 'ProbationReviewExportHistory';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    resultFileName?: Maybe<Scalars['String']['output']>;
    resultUrl?: Maybe<Scalars['String']['output']>;
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

export type ProbationReviewExportProgress = ExportImportProgress &
  ListItem & {
    __typename?: 'ProbationReviewExportProgress';
    completedRequestCount: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    createdBy?: Maybe<Employee>;
    createdById?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    status: ExportImportStatus;
    totalRequestCount?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
  };

/** How the probation was extended: number of extensions, the end date before and after, and the latest reason. */
export type ProbationReviewExtensionSummary = {
  __typename?: 'ProbationReviewExtensionSummary';
  count: Scalars['Int']['output'];
  newEndDate: Scalars['Date']['output'];
  originalEndDate: Scalars['Date']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export enum ProbationReviewFlag {
  DueSoon = 'DUE_SOON',
  Extended = 'EXTENDED',
  Overdue = 'OVERDUE',
}

export enum ProbationReviewOutcome {
  Failed = 'FAILED',
  Passed = 'PASSED',
}

/** Output type for probation review. */
export type ProbationReviewOutput = {
  __typename?: 'ProbationReviewOutput';
  employee: Employee;
  id: Scalars['ID']['output'];
};

/** Position of the current review among all reviews, for example review 2 of 3. `index` is 1-based. */
export type ProbationReviewPosition = {
  __typename?: 'ProbationReviewPosition';
  index: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Review status of one review (stage) of a probation review. */
export enum ProbationReviewReviewStatus {
  Draft = 'DRAFT',
  MarkAsCompleted = 'MARK_AS_COMPLETED',
  Submitted = 'SUBMITTED',
}

/** One review (stage) of a probation review. */
export type ProbationReviewStage = {
  __typename?: 'ProbationReviewStage';
  assessments: Array<ProbationReviewStageAssessment>;
  completionMethod?: Maybe<ProbationReviewCompletionMethod>;
  deadline: Scalars['Date']['output'];
  employeeId: Scalars['ID']['output'];
  extensionReason?: Maybe<Scalars['String']['output']>;
  isExtension: Scalars['Boolean']['output'];
  isReviewerFeedbackFilled: Scalars['Boolean']['output'];
  isSelfFeedbackFilled: Scalars['Boolean']['output'];
  needAssessments: Scalars['Boolean']['output'];
  reviewStatus: ProbationReviewReviewStatus;
  reviewer?: Maybe<Employee>;
  reviewerFeedback?: Maybe<Scalars['String']['output']>;
  reviewerId?: Maybe<Scalars['ID']['output']>;
  selfFeedback?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Probation review - Stage - Assessment. */
export type ProbationReviewStageAssessment = {
  __typename?: 'ProbationReviewStageAssessment';
  assessment: ProbationReviewStageAssessmentValue;
  type: AnyMindValueType;
};

/** Probation review - Stage - Assessment value. */
export type ProbationReviewStageAssessmentValue = {
  __typename?: 'ProbationReviewStageAssessmentValue';
  reviewer?: Maybe<Scalars['Int']['output']>;
  reviewerUpdatedBy?: Maybe<Employee>;
  reviewerUpdatedById?: Maybe<Scalars['ID']['output']>;
  self?: Maybe<Scalars['Int']['output']>;
};

/** The review of an employee that a list row shows for the selected month. */
export type ProbationReviewSummary = {
  __typename?: 'ProbationReviewSummary';
  dueDate: Scalars['Date']['output'];
  reviewStatus: ProbationReviewReviewStatus;
  reviewer?: Maybe<Employee>;
  reviewerId?: Maybe<Scalars['ID']['output']>;
};

export enum ProbationReviewView {
  AllInProgress = 'ALL_IN_PROGRESS',
  Completed = 'COMPLETED',
  EndingIn_30Days = 'ENDING_IN_30_DAYS',
  MyEmployees = 'MY_EMPLOYEES',
  NeedsAction = 'NEEDS_ACTION',
  Overdue = 'OVERDUE',
}

export enum ProbationStatus {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Over = 'OVER',
}

export type Query = {
  __typename?: 'Query';
  /** Get the active AI assistant configuration for the given usage context. */
  activeAIAssistantConfiguration?: Maybe<AiAssistantConfigurationSummaryType>;
  /** Get an AI assistant configuration by ID. Permitted roles: ADMIN_PRIVATE, SUPER_ADMIN. */
  aiAssistantConfiguration?: Maybe<AiAssistantConfigurationDetailType>;
  /** List all AI assistant configurations. Permitted roles: ADMIN_PRIVATE, SUPER_ADMIN. */
  aiAssistantConfigurations: Array<AiAssistantConfigurationSummaryType>;
  /** Get an enabled state of the AI assistant for the specified usage. */
  aiAssistantEnabled: AiAssistantEnabled;
  /** Returns a single chat session with full message history. Returns null if absent or owned by a different employee. */
  aiChatSession?: Maybe<AiChatSession>;
  /** Returns all chat sessions for the authenticated employee filtered by usage, ordered by lastMessageAt DESC. */
  aiChatSessions: Array<AiChatSessionSummary>;
  /** Get a business unit. */
  businessUnit?: Maybe<BusinessUnit>;
  /** Check whether a company email address is available for use. */
  checkCompanyEmailAvailability: CompanyEmailAvailabilityResult;
  /** Get a company. */
  company?: Maybe<Company>;
  /** Get a company email domain. */
  companyEmailDomain?: Maybe<CompanyEmailDomain>;
  /** Get count of HubSpot pipelines. */
  countAllHubspotPipelines: Scalars['Int']['output'];
  /** Get a country. */
  country?: Maybe<Country>;
  /** Get a currency. */
  currency?: Maybe<Currency>;
  /** Get a current employee. */
  currentEmployee: CurrentEmployee;
  /** Get a department. */
  department?: Maybe<Department>;
  /** Get a division. */
  division?: Maybe<Division>;
  /** Get an employee. */
  employee?: Maybe<Employee>;
  /** Get an employee IDP by ID. Returns null when it does not exist or the caller is not authorized. */
  employeeIdp?: Maybe<EmployeeIdp>;
  /** Dashboard widget: non-completed IDPs where the caller is the subject employee, line manager, or HR representative. A DRAFT record is excluded when the caller's only qualifying role is subject employee. */
  employeeIdpDashboardWidget: Array<EmployeeIdp>;
  /** List employee IDPs. Accessible to SUPER_ADMIN and ADMIN_PRIVATE only. */
  employeeIdpList: EmployeeIdpListResult;
  /** Get an employee list custom filter. */
  employeeListCustomFilter?: Maybe<EmployeeListCustomFilter>;
  /** Get VDP/VDD allocations for an employee for a given half-year. Returns null when no entries exist. */
  employeeManagerialAccounting?: Maybe<EmployeeManagerialAccounting>;
  /** Compute suggested VDP/VDD allocations for a given employee and half-year period, derived from contract history (VDP: days overlap per company) and job history (VDD: BU at period midpoint). */
  employeeManagerialAccountingSuggestion: EmployeeManagerialAccountingSuggestion;
  /** Returns computed allocation suggestions for each period in the autofill range. backfill=true includes periods from the employee's hired half-year; backfill=false starts from the next half-year. */
  employeeManagerialAccountingSuggestionList: Array<EmployeeManagerialAccountingSuggestion>;
  /** Get an EpmMasterAllocationKey entry. */
  epmMasterAllocationKey?: Maybe<EpmMasterAllocationKey>;
  /** Get an EpmMasterFunctionality entry. */
  epmMasterFunctionality?: Maybe<EpmMasterFunctionality>;
  /** Get an EpmMasterRoleType entry. */
  epmMasterRoleType?: Maybe<EpmMasterRoleType>;
  /** Get an EpmMasterVdd entry. */
  epmMasterVdd?: Maybe<EpmMasterVdd>;
  /** List Employee list export jobs, most recent first. */
  exportHistoryListEmployee: Array<EmployeeExportHistory>;
  /** List External Account export jobs requested by the calling user, most recent first. */
  exportHistoryListExternalAccount: Array<ExternalAccountExportHistory>;
  /** List Number-of-Employee export jobs requested by the calling user, most recent first. */
  exportHistoryListNumberOfEmployee: Array<NumberOfEmployeeExportHistory>;
  /** List Performance Review export jobs requested by the calling user, most recent first. */
  exportHistoryListPerformanceReview: Array<PerformanceReviewExportHistory>;
  /** List Probation Review export jobs requested by the calling user, most recent first. */
  exportHistoryListProbationReview: Array<ProbationReviewExportHistory>;
  /** Get a Google authorization code request URL to access Google services. */
  generateGoogleOfflineOAuthUrl: Scalars['Url']['output'];
  /** Get a Google authorization code request URL to logging into MED. */
  generateSignInOAuthUrl: Scalars['Url']['output'];
  /** Convert Google's authorization code to the token to access Google services. */
  googleOfflineOAuthCallback: Scalars['Boolean']['output'];
  /** Get a HubSpot pipeline. */
  hubspotPipeline?: Maybe<HubspotPipeline>;
  /** A fresh 10-minute V4 signed GCS URL for downloading one PDF generation, signed at call time rather than pre-signed on the history list - call this only when the user actually clicks Download, so the expiry window starts from an actual use. Restricted to the same viewer set as canGeneratePdf. */
  idpPdfGenerationDownloadUrl: Scalars['String']['output'];
  /** Get a job. */
  job?: Maybe<Job>;
  /** List the enabled state of the AI assistant for all usage contexts. */
  listAIAssistantEnabled: Array<AiAssistantEnabled>;
  listAIAssistantModels: Array<AiAssistantModel>;
  /** The full, paginated PDF generation history for an IDP - every generation regardless of status, including voided, newest first. Restricted to the same viewer set as canGeneratePdf. The History tab's default view is a separate nested field, EmployeeIdp.listActivePdfGenerations. */
  listAllPdfGenerations: EmployeeIdpPdfGenerationListResult;
  /** List business units. */
  listBusinessUnits: ListBusinessUnits;
  /** List companies. */
  listCompanies: ListCompanies;
  /** List company email domains. */
  listCompanyEmailDomains: ListCompanyEmailDomains;
  /** List contract types. */
  listContractTypes: Array<ContractTypeWithDisplayName>;
  /** List countries. */
  listCountries: ListCountries;
  /** List currencies. */
  listCurrencies: ListCurrencies;
  /** List currencies for performance review. */
  listCurrenciesForPerformanceReview: ListCurrencies;
  /** List departments. */
  listDepartments: ListDepartments;
  /** Get a list of direct reports. */
  listDirectReports: ListDirectReports;
  /** List direct reports' performance reviews. */
  listDirectReportsPerformanceReviews: Array<PerformanceReview>;
  /** List the probation reviews of the caller's direct reports that have no outcome and have not left (not started included), with their flags. */
  listDirectReportsProbationReviews: Array<ProbationReview>;
  /** List divisions. */
  listDivisions: ListDivisions;
  /** Get a list of employee alert types. */
  listEmployeeAlertReasonTypes: Array<EmployeeAlertReasonTypeWithDisplayName>;
  /** Get a list of employee alerts grouped by country. */
  listEmployeeAlertsByCountry: ListEmployeeAlertsByCountry;
  /** Get a list of employee alerts grouped by employee. */
  listEmployeeAlertsByEmployee: ListEmployeeAlertsByEmployee;
  /** List employee list custom filters. */
  listEmployeeListCustomFilters: ListEmployeeListCustomFilters;
  /** Get VDP/VDD allocations for an employee across a half-year range. When periodStart is null the employee's hired half-year is used as the lower bound. When periodEnd is null there is no upper bound (capped by employmentEndDate when set). Returns a result object containing the items list and the maximum half-year. */
  listEmployeeManagerialAccountings: EmployeeManagerialAccountingList;
  /** List employees. */
  listEmployees: ListEmployees;
  /** List EpmMasterAllocationKey entries. */
  listEpmMasterAllocationKeys: ListEpmMasterAllocationKeys;
  /** List EpmMasterFunctionality entries. */
  listEpmMasterFunctionalities: ListEpmMasterFunctionalities;
  /** List EpmMasterRoleType entries. */
  listEpmMasterRoleTypes: ListEpmMasterRoleTypes;
  /** List EpmMasterVdd entries. */
  listEpmMasterVdds: ListEpmMasterVdds;
  /** Get a list of external account types. */
  listExternalAccountTypes: Array<ExternalAccountType>;
  /** Per-type count of Active external accounts. Ignores accountStatus filter. Permitted roles: SUPER_ADMIN, ADMIN_STANDARD, ADMIN_PRIVATE. */
  listExternalAccountsActiveSummary: Array<ExternalAccountActiveCount>;
  /** List Google Workspace organization unit paths. */
  listGoogleOrgUnitPaths: Array<Scalars['String']['output']>;
  /** List HubSpot pipelines. */
  listHubspotPipelines: ListHubspotPipelines;
  /** List import jobs (Employee and Managerial Accounting), most recent first. */
  listImportHistories: Array<ImportHistory>;
  /** List jobs. */
  listJobs: ListJobs;
  /** List languages. */
  listLanguages: ListLanguages;
  /** List locations. */
  listLocations: ListLocations;
  /** Connections the signed-in administrator is allowed to manage. */
  listMcpConnections: ListMcpConnections;
  /** Get all employees for org chart display. */
  listOrgChartEmployees: Array<OrgChartEmployee>;
  /** List Company / Business Unit / Department relations. */
  listOrgHierarchyRelations: OrgHierarchyRelationList;
  /** List performance review company notification. */
  listPerformanceReviewCompanyNotification: Array<PerformanceReviewCompanyNotification>;
  /** List performance review company stage. */
  listPerformanceReviewCompanyStage: Array<PerformanceReviewCompanyStage>;
  /** List the periods that have Performance Review tabulation rows, newest first. Permitted roles: every role except BASIC. */
  listPerformanceReviewReportPeriods: Array<PerformanceReviewPeriod>;
  /** List performance review results. */
  listPerformanceReviewResults: ListPerformanceReviewResults;
  /** List the periods that have Performance Review tabulation settings, newest first. Permitted roles: SUPER_ADMIN. */
  listPerformanceReviewTabulationSettingPeriods: Array<PerformanceReviewPeriod>;
  /** List performance reviews. */
  listPerformanceReviews: ListPerformanceReviews;
  /** List probation reviews of a saved view (default Needs action) and month. Only Super Admin and Admin (Private) can use every view; every other role always gets My Employees. */
  listProbationReviews: ListProbationReviews;
  /** List off boarding - reason for leavings. */
  listReasonForLeavings: ListReasonForLeavings;
  /** List Slack workspace installations. */
  listSlackWorkspaceInstallations: Array<EmployeeExternalAccountSlackWorkspace>;
  /** Get a location. */
  location?: Maybe<Location>;
  /** Returns all manager change reservations. */
  managerChangeReservations: ListManagerChangeReservations;
  /** The employees's own registered signature, or null if none is registered. Never accepts an employeeId argument. */
  myEmployeeFile?: Maybe<EmployeeFile>;
  /** Connections of the signed-in employee. Defaults to the active ones. */
  myMcpConnections: Array<McpConnection>;
  /** Get a notification setting. */
  notificationSetting?: Maybe<NotificationSetting>;
  /** Returns the current PENDING manager change reservation for the given employee. Returns null if no pending reservation exists. */
  pendingManagerChangeReservation?: Maybe<ManagerChangeReservation>;
  /** Get a performance review. */
  performanceReview?: Maybe<PerformanceReview>;
  /** The Performance Review periods that may be chosen as the start of an employee's exclusion from tracking for the given Last working date, and the stored period moved to follow that date. Permitted roles: the roles that may edit the employee's Off-boarding. */
  performanceReviewExclusionChoices: PerformanceReviewExclusionChoices;
  /** Aggregate the Performance Review tabulation of a period per country and company. Figures come from an hourly snapshot; see refreshedAt. Permitted roles: every role except BASIC. */
  performanceReviewReport: PerformanceReviewReport;
  /** The refresh time of the Performance Review tabulation snapshot and whether a manual refresh is waiting. A light read for polling while a refresh runs. Permitted roles: every role except BASIC. */
  performanceReviewReportRefreshStatus: PerformanceReviewReportRefreshStatus;
  /** Get the Performance Review tabulation settings of a period. Permitted roles: SUPER_ADMIN. */
  performanceReviewTabulationSetting: PerformanceReviewTabulationSetting;
  /** Get a performance review target. */
  performanceReviewTarget?: Maybe<PerformanceReviewTarget>;
  /** Get a probation review. */
  probationReview?: Maybe<ProbationReview>;
  /** The audit log of the probation review tables, newest first (HRBP only). Super Admin reads every entry; Admin (Private) only those of the employees that user may see. Every changed column comes with its value before and after, free text included. */
  probationReviewAuditLogs: ProbationReviewAuditLogResult;
  /** Search employees, performance reviews, probation reviews, and pages by keyword. */
  quickAccessSearch: Array<QuickAccessSearchResult>;
  /** Get a off boarding - reason for leaving. */
  reasonForLeaving?: Maybe<ReasonForLeaving>;
  /** Get a report - demographic numbers. */
  reportDemographic: ReportDemographic;
  /** Get report - number of employee - all. */
  reportNumberOfEmployeeAll: ReportNumberOfEmployeeAll;
  /** Get report - number of employee - business unit. */
  reportNumberOfEmployeeBusinessUnit: ReportNumberOfEmployeeByBusinessUnit;
  /** Get report - number of employee - company. */
  reportNumberOfEmployeeCompany: ReportNumberOfEmployeeByCompany;
  /** Get report - number of employee - company, business unit and department. */
  reportNumberOfEmployeeCompanyBusinessUnitDepartment: ReportNumberOfEmployeeByCompanyBusinessUnitDepartment;
  /** Get report - number of employee - company, business unit and job. */
  reportNumberOfEmployeeCompanyBusinessUnitJob: ReportNumberOfEmployeeByCompanyBusinessUnitJob;
  /** Get report - number of employee - job. */
  reportNumberOfEmployeeJob: ReportNumberOfEmployeeByJob;
  /** Get report - number of employee - location. */
  reportNumberOfEmployeeLocation: ReportNumberOfEmployeeByLocation;
  /** Get report - number of employee - nationality. */
  reportNumberOfEmployeeNationality: ReportNumberOfEmployeeByNationality;
  /** Get report - number of employee - turnover. */
  reportNumberOfEmployeeTurnover: ReportNumberOfEmployeeTurnover;
  /** Report: VDD FTE headcount per VDD department per half-year period. Cell value = Σ (employee allocation% / 100). */
  reportNumberOfEmployeeVdd: NumberOfEmployeeByVdd;
  /** Report: VDP→VDD cross-allocation FTE per (VDP source, VDD department, period). Cell value = Σ (vdp% / 100 × vdd% / 100). */
  reportNumberOfEmployeeVddVdpComposite: NumberOfEmployeeByVdpVddComposite;
  /** Report: VDP FTE headcount per VDP source per half-year period. Cell value = Σ (employee allocation% / 100). */
  reportNumberOfEmployeeVdp: NumberOfEmployeeByVdp;
  /** Report: Allocation Key FTE headcount per allocation key per half-year period. Cell value = Σ (employee allocation% / 100). */
  reportNumberOfEmployeesByAllocationKey: NumberOfEmployeeByAllocationKey;
  /** Report: Functionality FTE headcount per functionality per half-year period. Cell value = Σ (employee allocation% / 100). */
  reportNumberOfEmployeesByFunctionality: NumberOfEmployeeByFunctionality;
  /** Report: Role Type FTE headcount per role type per half-year period. Cell value = Σ (employee allocation% / 100). */
  reportNumberOfEmployeesByRoleType: NumberOfEmployeeByRoleType;
  /** Resolve employee identifiers for performance review bulk create. Allowed roles: ADMIN_STANDARD, ADMIN_PRIVATE, SUPER_ADMIN. */
  resolveEmployeesForPerformanceReview: Array<EmployeeIdentifierResolutionResult>;
  /** Convert Google's authorization code to JWT to logging into MED. */
  signInCallback: SignInCallback;
  /** The current caller's accessible Countries for Team Name Governance, or null if the caller is unrestricted. Resolves to null for SUPER_ADMIN (unrestricted - the frontend does not filter its Country-selection list) and to the concrete list of Country ids derived from the caller's employee_permission_company Companies for ADMIN_PRIVATE - possibly empty, a valid state. Every other role (unreachable via the frontend route guard) resolves to an empty list, not null - they are never unrestricted. Purely additive; does not modify listCountries, which stays fully shared/unscoped. This field is a UI-discoverability convenience only, NOT the enforced security boundary - the actual access check happens on every call to teamValueClusters/teamJobHistories/mergeTeamValues/renameTeamValue regardless of what this field returns. */
  teamAccessibleCountryIds?: Maybe<Array<Scalars['CountryCode']['output']>>;
  /** Every employee job history record (current and historical) whose Team value is in teamValues - not EMPLOYEE_CURRENT_JOB-scoped, unlike Employee List's own team filter, so this includes historical Team usage Employee List cannot show. teamValues is the clicked Team value's whole Likely-duplicates cluster, not just the one value clicked - a single-element list for a value with no likely duplicate. Server-paginated via pageNumber/pageSize. filter is required and narrows by Business Unit/Department/Job/status in addition to its required Country, applied server-side - an omitted or all-empty optional field applies no filter for that field. Gated by the same permission role set as teamValueClusters. */
  teamJobHistories: TeamJobHistoryList;
  /** All distinct Team values currently in use within `country`, grouped into likely-duplicate clusters. Gated by the same permission role set as comparable employee-data-management screens. `country` is required - derived from the same row-accurate employee_job_history.location_id -> location.country_id source teamJobHistories' own filter.countryId already uses. `blankVisibility` is required and governs only the literal blank/empty-string TeamValue's inclusion/recordCount - HIDE excludes it entirely; HIDE_PAST excludes only its Past-classified records from its recordCount, omitting it once none remain; SHOW_ALL applies no filtering. A value that merely normalizes to empty via the optional "Team"/"チーム" suffix-stripping is unaffected in every mode. */
  teamValueClusters: Array<TeamValueCluster>;
  /** The flat list of distinct Team values currently in use, with no grouping or counts - backing the autocomplete suggestions on the employee Job History Team field. Available to any user who can view/edit employee job history (no additional gate beyond that). */
  teamValueSuggestions: Array<Scalars['String']['output']>;
  /** Verify if the current user has an access token to call Google services. */
  verifyGoogleOfflineToken: Scalars['Boolean']['output'];
  /** Verifies an uploaded PDF against this system's signing certificates and generation history (FR-014). Requires sign-in only - no IDP-specific permission check, since the result never exposes IDP content or the target employee's name. */
  verifyIdpPdf: IdpPdfVerificationResult;
};

export type QueryActiveAiAssistantConfigurationArgs = {
  usage: AiAssistantUsage;
};

export type QueryAiAssistantConfigurationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAiAssistantEnabledArgs = {
  usage: AiAssistantUsage;
};

export type QueryAiChatSessionArgs = {
  sessionId: Scalars['ID']['input'];
};

export type QueryAiChatSessionsArgs = {
  usage: AiAssistantUsage;
};

export type QueryBusinessUnitArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCheckCompanyEmailAvailabilityArgs = {
  account: Scalars['String']['input'];
  domain: Scalars['String']['input'];
};

export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCompanyEmailDomainArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCountryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCurrencyArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDepartmentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDivisionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEmployeeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEmployeeIdpArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEmployeeIdpListArgs = {
  filter?: InputMaybe<EmployeeIdpListFilterInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type QueryEmployeeListCustomFilterArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEmployeeManagerialAccountingArgs = {
  employeeId: Scalars['ID']['input'];
  period: ManagerialAccountingPeriodInput;
};

export type QueryEmployeeManagerialAccountingSuggestionArgs = {
  employeeId: Scalars['ID']['input'];
  period: ManagerialAccountingPeriodInput;
};

export type QueryEmployeeManagerialAccountingSuggestionListArgs = {
  backfill: Scalars['Boolean']['input'];
  employeeId: Scalars['ID']['input'];
};

export type QueryEpmMasterAllocationKeyArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEpmMasterFunctionalityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEpmMasterRoleTypeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEpmMasterVddArgs = {
  id: Scalars['ID']['input'];
};

export type QueryExportHistoryListEmployeeArgs = {
  onlyMyTask: Scalars['Boolean']['input'];
};

export type QueryExportHistoryListExternalAccountArgs = {
  onlyMyTask: Scalars['Boolean']['input'];
};

export type QueryExportHistoryListNumberOfEmployeeArgs = {
  onlyMyTask: Scalars['Boolean']['input'];
};

export type QueryExportHistoryListPerformanceReviewArgs = {
  onlyMyTask: Scalars['Boolean']['input'];
  types: Array<PerformanceReviewExportType>;
};

export type QueryExportHistoryListProbationReviewArgs = {
  onlyMyTask: Scalars['Boolean']['input'];
};

export type QueryGenerateGoogleOfflineOAuthUrlArgs = {
  redirectUri: Scalars['Url']['input'];
  state: Scalars['String']['input'];
};

export type QueryGenerateSignInOAuthUrlArgs = {
  codeChallenge?: InputMaybe<Scalars['String']['input']>;
  loginHint?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['Url']['input']>;
  state: Scalars['String']['input'];
};

export type QueryGoogleOfflineOAuthCallbackArgs = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['Url']['input'];
};

export type QueryHubspotPipelineArgs = {
  id: Scalars['ID']['input'];
};

export type QueryIdpPdfGenerationDownloadUrlArgs = {
  generationId: Scalars['ID']['input'];
};

export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};

export type QueryListAiAssistantModelsArgs = {
  currentModel?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListAllPdfGenerationsArgs = {
  idpId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type QueryListBusinessUnitsArgs = {
  filter: ListBusinessUnitsFilterInput;
};

export type QueryListCompaniesArgs = {
  filter: ListCompaniesFilterInput;
};

export type QueryListCompanyEmailDomainsArgs = {
  filter: ListCompanyEmailDomainsFilterInput;
};

export type QueryListCountriesArgs = {
  filter: ListCountriesFilterInput;
};

export type QueryListCurrenciesArgs = {
  filter: ListCurrenciesFilterInput;
};

export type QueryListCurrenciesForPerformanceReviewArgs = {
  performanceReviewId: Scalars['ID']['input'];
};

export type QueryListDepartmentsArgs = {
  filter: ListDepartmentsFilterInput;
};

export type QueryListDirectReportsArgs = {
  filter?: InputMaybe<ListDirectReportsFilterInput>;
  id: Scalars['ID']['input'];
};

export type QueryListDirectReportsPerformanceReviewsArgs = {
  isRecentOnly: Scalars['Boolean']['input'];
  stages: Array<PerformanceReviewStage>;
};

export type QueryListDivisionsArgs = {
  filter: ListDivisionsFilterInput;
};

export type QueryListEmployeeAlertsByEmployeeArgs = {
  filter?: InputMaybe<ListEmployeeAlertFilterInput>;
};

export type QueryListEmployeeManagerialAccountingsArgs = {
  employeeId: Scalars['ID']['input'];
  periodEnd?: InputMaybe<ManagerialAccountingPeriodInput>;
  periodStart?: InputMaybe<ManagerialAccountingPeriodInput>;
};

export type QueryListEmployeesArgs = {
  filter?: InputMaybe<ListEmployeesFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<Array<ListEmployeesSortInput>>;
};

export type QueryListEpmMasterAllocationKeysArgs = {
  filter: ListEpmMasterAllocationKeyFilterInput;
};

export type QueryListEpmMasterFunctionalitiesArgs = {
  filter: ListEpmMasterFunctionalityFilterInput;
};

export type QueryListEpmMasterRoleTypesArgs = {
  filter: ListEpmMasterRoleTypeFilterInput;
};

export type QueryListEpmMasterVddsArgs = {
  filter: ListEpmMasterVddFilterInput;
};

export type QueryListExternalAccountsActiveSummaryArgs = {
  filter: ListExternalAccountsFilterInput;
};

export type QueryListHubspotPipelinesArgs = {
  filter: ListHubspotPipelinesFilterInput;
};

export type QueryListImportHistoriesArgs = {
  onlyMyTask: Scalars['Boolean']['input'];
};

export type QueryListJobsArgs = {
  filter: ListJobsFilterInput;
};

export type QueryListLanguagesArgs = {
  filter: ListLanguagesFilterInput;
};

export type QueryListLocationsArgs = {
  filter: ListLocationsFilterInput;
};

export type QueryListMcpConnectionsArgs = {
  filter?: InputMaybe<ListMcpConnectionsFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type QueryListOrgChartEmployeesArgs = {
  filter?: InputMaybe<OrgChartFilterInput>;
};

export type QueryListOrgHierarchyRelationsArgs = {
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListPerformanceReviewCompanyStageArgs = {
  period: PerformanceReviewPeriodInput;
};

export type QueryListPerformanceReviewResultsArgs = {
  filter: PerformanceReviewResultFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<ListPerformanceReviewsSortInput>;
};

export type QueryListPerformanceReviewsArgs = {
  filter: ListPerformanceReviewFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<ListPerformanceReviewsSortInput>;
};

export type QueryListProbationReviewsArgs = {
  filter?: InputMaybe<ListProbationReviewFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type QueryListReasonForLeavingsArgs = {
  filter: ListReasonForLeavingsFilterInput;
};

export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryManagerChangeReservationsArgs = {
  filter?: InputMaybe<ManagerChangeReservationsFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type QueryMyMcpConnectionsArgs = {
  statuses?: InputMaybe<Array<McpConnectionStatus>>;
};

export type QueryNotificationSettingArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryPendingManagerChangeReservationArgs = {
  employeeId: Scalars['ID']['input'];
};

export type QueryPerformanceReviewArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPerformanceReviewExclusionChoicesArgs = {
  employeeId: Scalars['ID']['input'];
  lastWorkingDate?: InputMaybe<Scalars['Date']['input']>;
};

export type QueryPerformanceReviewReportArgs = {
  filter?: InputMaybe<PerformanceReviewReportFilterInput>;
  period: PerformanceReviewPeriodInput;
};

export type QueryPerformanceReviewTabulationSettingArgs = {
  period: PerformanceReviewPeriodInput;
};

export type QueryPerformanceReviewTargetArgs = {
  id: Scalars['ID']['input'];
};

export type QueryProbationReviewArgs = {
  id: Scalars['ID']['input'];
};

export type QueryProbationReviewAuditLogsArgs = {
  filter?: InputMaybe<ProbationReviewAuditLogFilterInput>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type QueryQuickAccessSearchArgs = {
  keyword: Scalars['String']['input'];
};

export type QueryReasonForLeavingArgs = {
  id: Scalars['ID']['input'];
};

export type QueryReportDemographicArgs = {
  filter?: InputMaybe<ReportDemographicFilterInput>;
  yearMonth: Scalars['YearMonth']['input'];
};

export type QueryReportNumberOfEmployeeAllArgs = {
  filter: ReportNumberOfEmployeeAllFilterInput;
};

export type QueryReportNumberOfEmployeeBusinessUnitArgs = {
  filter: ReportNumberOfEmployeeBusinessUnitFilterInput;
};

export type QueryReportNumberOfEmployeeCompanyArgs = {
  filter: ReportNumberOfEmployeeCompanyFilterInput;
};

export type QueryReportNumberOfEmployeeCompanyBusinessUnitDepartmentArgs = {
  filter: ReportNumberOfEmployeeCompanyBusinessUnitDepartmentFilterInput;
};

export type QueryReportNumberOfEmployeeCompanyBusinessUnitJobArgs = {
  filter: ReportNumberOfEmployeeCompanyBusinessUnitJobFilterInput;
};

export type QueryReportNumberOfEmployeeJobArgs = {
  filter: ReportNumberOfEmployeeJobFilterInput;
};

export type QueryReportNumberOfEmployeeLocationArgs = {
  filter: ReportNumberOfEmployeeLocationFilterInput;
};

export type QueryReportNumberOfEmployeeNationalityArgs = {
  filter: ReportNumberOfEmployeeNationalityFilterInput;
};

export type QueryReportNumberOfEmployeeTurnoverArgs = {
  filter: ReportNumberOfEmployeeTurnoverFilterInput;
};

export type QueryReportNumberOfEmployeeVddArgs = {
  filter: ReportNumberOfEmployeeVdFilterInput;
};

export type QueryReportNumberOfEmployeeVddVdpCompositeArgs = {
  filter: ReportNumberOfEmployeeVdFilterInput;
};

export type QueryReportNumberOfEmployeeVdpArgs = {
  filter: ReportNumberOfEmployeeVdFilterInput;
};

export type QueryReportNumberOfEmployeesByAllocationKeyArgs = {
  filter: ReportNumberOfEmployeeVdFilterInput;
};

export type QueryReportNumberOfEmployeesByFunctionalityArgs = {
  filter: ReportNumberOfEmployeeVdFilterInput;
};

export type QueryReportNumberOfEmployeesByRoleTypeArgs = {
  filter: ReportNumberOfEmployeeVdFilterInput;
};

export type QueryResolveEmployeesForPerformanceReviewArgs = {
  identifiers: Array<Scalars['String']['input']>;
  period: PerformanceReviewPeriodInput;
};

export type QuerySignInCallbackArgs = {
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['Url']['input']>;
};

export type QueryTeamJobHistoriesArgs = {
  filter: TeamJobHistoryFilterInput;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  teamValues: Array<Scalars['String']['input']>;
};

export type QueryTeamValueClustersArgs = {
  blankVisibility: BlankTeamValueVisibility;
  country: Scalars['CountryCode']['input'];
};

export type QueryVerifyIdpPdfArgs = {
  input: VerifyIdpPdfInput;
};

export enum QuickAccessCategory {
  Employee = 'EMPLOYEE',
  Page = 'PAGE',
  PerformanceReview = 'PERFORMANCE_REVIEW',
  ProbationReview = 'PROBATION_REVIEW',
}

export type QuickAccessSearchResult = {
  category: QuickAccessCategory;
  uri: Scalars['String']['output'];
};

export type QuickAccessSearchResultEmployee = QuickAccessSearchResult & {
  __typename?: 'QuickAccessSearchResultEmployee';
  category: QuickAccessCategory;
  employee: Employee;
  id: Scalars['ID']['output'];
  uri: Scalars['String']['output'];
};

export type QuickAccessSearchResultPage = QuickAccessSearchResult & {
  __typename?: 'QuickAccessSearchResultPage';
  category: QuickAccessCategory;
  name: Scalars['String']['output'];
  pageCategory?: Maybe<Scalars['String']['output']>;
  uri: Scalars['String']['output'];
};

export type QuickAccessSearchResultPerformanceReview = QuickAccessSearchResult & {
  __typename?: 'QuickAccessSearchResultPerformanceReview';
  category: QuickAccessCategory;
  id: Scalars['ID']['output'];
  performanceReview: PerformanceReview;
  uri: Scalars['String']['output'];
};

export type QuickAccessSearchResultProbationReview = QuickAccessSearchResult & {
  __typename?: 'QuickAccessSearchResultProbationReview';
  category: QuickAccessCategory;
  employee: Employee;
  id: Scalars['ID']['output'];
  uri: Scalars['String']['output'];
};

/** Off boarding - reason for leaving. */
export type ReasonForLeaving = ListItem & {
  __typename?: 'ReasonForLeaving';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Output type for an off boarding - reason for leaving. */
export type ReasonForLeavingOutput = {
  __typename?: 'ReasonForLeavingOutput';
  id: Scalars['ID']['output'];
  reasonForLeaving: ReasonForLeaving;
};

/** Record the final IDP result. Locks the record permanently. */
export type RecordEmployeeIdpResultInput = {
  idpId: Scalars['ID']['input'];
  result: EmployeeIdpResult;
  resultComment: Scalars['String']['input'];
};

/** Input type for an HRBP to record the outcome of the probation. */
export type RecordProbationReviewOutcomeInput = {
  /** Shown in the export and in the audit log, not on the probation review screens. */
  comment?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  outcome: ProbationReviewOutcome;
};

/** Output type of Record Outcome: the outcome is recorded whenever this is returned. */
export type RecordProbationReviewOutcomeOutput = {
  __typename?: 'RecordProbationReviewOutcomeOutput';
  employee: Employee;
  id: Scalars['ID']['output'];
  /** True when the probation result notification could not be sent. The outcome is still recorded; resend the notification by hand. */
  notificationFailed: Scalars['Boolean']['output'];
};

export enum RehireConditionTag {
  DifferentRole = 'DIFFERENT_ROLE',
  DifferentTeam = 'DIFFERENT_TEAM',
  PerformanceConditions = 'PERFORMANCE_CONDITIONS',
  RequiresApproval = 'REQUIRES_APPROVAL',
}

export enum RehireRecommendation {
  Conditional = 'CONDITIONAL',
  NotRecommended = 'NOT_RECOMMENDED',
  StronglyRecommended = 'STRONGLY_RECOMMENDED',
}

export type RenameTeamValueInput = {
  /** Scopes the rename to rows within this Country only - derived from each row's own location (employee_job_history.location_id -> location.country_id). A same-spelled value in a DIFFERENT Country is left untouched. */
  countryId: Scalars['CountryCode']['input'];
  /** When true, every job history record (current and historical) referencing oldValue is updated. When false, only each affected employee's current job history record is updated; older records keep oldValue. */
  includeHistorical: Scalars['Boolean']['input'];
  /** The replacement text. May be a value that does not exist anywhere yet. Leading/trailing whitespace is trimmed before it is persisted. */
  newValue: Scalars['String']['input'];
  /** The single existing TeamValue.value being renamed. */
  oldValue: Scalars['String']['input'];
};

export enum ReplacementValue {
  Extreme = 'EXTREME',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum ReplacementValueBasisTag {
  BusinessContinuityRisk = 'BUSINESS_CONTINUITY_RISK',
  ClientRelationship = 'CLIENT_RELATIONSHIP',
  CrossRegionalImpact = 'CROSS_REGIONAL_IMPACT',
  CultureLeadership = 'CULTURE_LEADERSHIP',
  DomainExpertise = 'DOMAIN_EXPERTISE',
  MarketAvailable = 'MARKET_AVAILABLE',
  TechnicalExpertise = 'TECHNICAL_EXPERTISE',
  TrainableExternal = 'TRAINABLE_EXTERNAL',
}

/** Report - demographic. */
export type ReportDemographic = {
  __typename?: 'ReportDemographic';
  age: ReportDemographicAge;
  gender: ReportDemographicGender;
  total: Scalars['Int']['output'];
  yearMonth: Scalars['YearMonth']['output'];
};

export type ReportDemographicAge = {
  __typename?: 'ReportDemographicAge';
  average?: Maybe<Scalars['BigDecimal']['output']>;
  median?: Maybe<Scalars['BigDecimal']['output']>;
  oldest?: Maybe<Scalars['Int']['output']>;
  youngest?: Maybe<Scalars['Int']['output']>;
};

/** Report - demographic filter. */
export type ReportDemographicFilterInput = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  nationalityIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
};

export type ReportDemographicGender = {
  __typename?: 'ReportDemographicGender';
  female: ReportDemographicGenderCount;
  male: ReportDemographicGenderCount;
  other: ReportDemographicGenderCount;
};

export type ReportDemographicGenderCount = {
  __typename?: 'ReportDemographicGenderCount';
  count: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Turnover rate for a calendar half-year. */
export type ReportHalfYearTurnoverRate = {
  __typename?: 'ReportHalfYearTurnoverRate';
  half: HalfYear;
  turnOverRate?: Maybe<Scalars['BigDecimal']['output']>;
  year: Scalars['Int']['output'];
};

/** Report - number of employees. */
export type ReportNumberOfEmployee = {
  allIds: Array<Scalars['ID']['output']>;
  maxDepth: Scalars['Int']['output'];
  total: Array<ReportNumberOfEmployeeMonthMetric>;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - number of employees - all. */
export type ReportNumberOfEmployeeAll = ReportNumberOfEmployeeByKey & {
  __typename?: 'ReportNumberOfEmployeeAll';
  items: Array<ReportNumberOfEmployeeAllYearMonth>;
  subtotal: ReportNumberOfEmployeeAllSubtotal;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Filter for number-of-employee all report. */
export type ReportNumberOfEmployeeAllFilterInput = {
  contractTypes?: InputMaybe<Array<ContractType>>;
  endYearMonth: Scalars['YearMonth']['input'];
  startYearMonth: Scalars['YearMonth']['input'];
};

/** Report - number of employees - all - subtotal. */
export type ReportNumberOfEmployeeAllSubtotal = {
  __typename?: 'ReportNumberOfEmployeeAllSubtotal';
  halfYearRates: Array<ReportHalfYearTurnoverRate>;
  joined: Scalars['BigDecimal']['output'];
  left: Scalars['BigDecimal']['output'];
  total: Scalars['BigDecimal']['output'];
  turnOverRate?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Report - number of employees - all - by year/month. */
export type ReportNumberOfEmployeeAllYearMonth = {
  __typename?: 'ReportNumberOfEmployeeAllYearMonth';
  joined: Scalars['BigDecimal']['output'];
  left: Scalars['BigDecimal']['output'];
  total: Scalars['BigDecimal']['output'];
  turnOverRate?: Maybe<Scalars['BigDecimal']['output']>;
  yearMonth: Scalars['YearMonth']['output'];
};

/** Filter for number-of-employee business unit report. */
export type ReportNumberOfEmployeeBusinessUnitFilterInput = {
  contractTypes?: InputMaybe<Array<ContractType>>;
  endYearMonth: Scalars['YearMonth']['input'];
  startYearMonth: Scalars['YearMonth']['input'];
};

/** Report - number of employees - by business unit. */
export type ReportNumberOfEmployeeByBusinessUnit = ReportNumberOfEmployee & {
  __typename?: 'ReportNumberOfEmployeeByBusinessUnit';
  allIds: Array<Scalars['ID']['output']>;
  items: Array<ReportNumberOfEmployeeByBusinessUnitItem>;
  maxDepth: Scalars['Int']['output'];
  total: Array<ReportNumberOfEmployeeMonthMetric>;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - number of employees - by business unit - dimension. */
export type ReportNumberOfEmployeeByBusinessUnitDimension = {
  __typename?: 'ReportNumberOfEmployeeByBusinessUnitDimension';
  businessUnit: BusinessUnit;
  businessUnitId: Scalars['ID']['output'];
};

/** Report - number of employees - by business unit - item. */
export type ReportNumberOfEmployeeByBusinessUnitItem = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByBusinessUnitItem';
  dimension: ReportNumberOfEmployeeByBusinessUnitDimension;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by company. */
export type ReportNumberOfEmployeeByCompany = ReportNumberOfEmployee & {
  __typename?: 'ReportNumberOfEmployeeByCompany';
  allIds: Array<Scalars['ID']['output']>;
  items: Array<ReportNumberOfEmployeeByCompanyItem>;
  maxDepth: Scalars['Int']['output'];
  total: Array<ReportNumberOfEmployeeMonthMetric>;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - number of employees - by company, business unit and department. */
export type ReportNumberOfEmployeeByCompanyBusinessUnitDepartment = ReportNumberOfEmployee & {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitDepartment';
  allIds: Array<Scalars['ID']['output']>;
  items: Array<ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemCompany>;
  maxDepth: Scalars['Int']['output'];
  total: Array<ReportNumberOfEmployeeMonthMetric>;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - number of employees - by company, business unit and department - dimension (business unit). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentDimensionBusinessUnit = {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentDimensionBusinessUnit';
  businessUnit: BusinessUnit;
  businessUnitId: Scalars['ID']['output'];
};

/** Report - number of employees - by company, business unit and department - dimension (company). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentDimensionCompany = {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentDimensionCompany';
  company: Company;
  companyId: Scalars['ID']['output'];
};

/** Report - number of employees - by company, business unit and department - dimension (department). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentDimensionDepartment = {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentDimensionDepartment';
  department: Department;
  departmentId: Scalars['ID']['output'];
};

/** Report - number of employees - by company, business unit and department - item (business unit). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemBusinessUnit = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemBusinessUnit';
  children: Array<ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemDepartment>;
  dimension: ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentDimensionBusinessUnit;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by company, business unit and department - item (company). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemCompany = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemCompany';
  children: Array<ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemBusinessUnit>;
  dimension: ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentDimensionCompany;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by company, business unit and department - item (department). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemDepartment = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemDepartment';
  dimension: ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentDimensionDepartment;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by company, business unit and job. */
export type ReportNumberOfEmployeeByCompanyBusinessUnitJob = ReportNumberOfEmployee & {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitJob';
  allIds: Array<Scalars['ID']['output']>;
  items: Array<ReportNumberOfEmployeeByCompanyBusinessUnitJobItemCompany>;
  maxDepth: Scalars['Int']['output'];
  total: Array<ReportNumberOfEmployeeMonthMetric>;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - number of employees - by company, business unit and job - dimension (business unit). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitJobDimensionBusinessUnit = {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitJobDimensionBusinessUnit';
  businessUnit: BusinessUnit;
  businessUnitId: Scalars['ID']['output'];
};

/** Report - number of employees - by company, business unit and job - dimension (company). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitJobDimensionCompany = {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitJobDimensionCompany';
  company: Company;
  companyId: Scalars['ID']['output'];
};

/** Report - number of employees - by company, business unit and job - dimension (job). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitJobDimensionJob = {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitJobDimensionJob';
  job: Job;
  jobId: Scalars['ID']['output'];
};

/** Report - number of employees - by company, business unit and job - item (business unit). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitJobItemBusinessUnit = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitJobItemBusinessUnit';
  children: Array<ReportNumberOfEmployeeByCompanyBusinessUnitJobItemJob>;
  dimension: ReportNumberOfEmployeeByCompanyBusinessUnitJobDimensionBusinessUnit;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by company, business unit and job - item (company). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitJobItemCompany = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitJobItemCompany';
  children: Array<ReportNumberOfEmployeeByCompanyBusinessUnitJobItemBusinessUnit>;
  dimension: ReportNumberOfEmployeeByCompanyBusinessUnitJobDimensionCompany;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by company, business unit and job - item (job). */
export type ReportNumberOfEmployeeByCompanyBusinessUnitJobItemJob = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByCompanyBusinessUnitJobItemJob';
  dimension: ReportNumberOfEmployeeByCompanyBusinessUnitJobDimensionJob;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by company - dimension. */
export type ReportNumberOfEmployeeByCompanyDimension = {
  __typename?: 'ReportNumberOfEmployeeByCompanyDimension';
  company: Company;
  companyId: Scalars['ID']['output'];
};

/** Report - number of employees - by company - item. */
export type ReportNumberOfEmployeeByCompanyItem = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByCompanyItem';
  dimension: ReportNumberOfEmployeeByCompanyDimension;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by job. */
export type ReportNumberOfEmployeeByJob = ReportNumberOfEmployee & {
  __typename?: 'ReportNumberOfEmployeeByJob';
  allIds: Array<Scalars['ID']['output']>;
  items: Array<ReportNumberOfEmployeeByJobItem>;
  maxDepth: Scalars['Int']['output'];
  total: Array<ReportNumberOfEmployeeMonthMetric>;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - number of employees - by job - dimension. */
export type ReportNumberOfEmployeeByJobDimension = {
  __typename?: 'ReportNumberOfEmployeeByJobDimension';
  job: Job;
  jobId: Scalars['ID']['output'];
};

/** Report - number of employees - by job - item. */
export type ReportNumberOfEmployeeByJobItem = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByJobItem';
  dimension: ReportNumberOfEmployeeByJobDimension;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by key. */
export type ReportNumberOfEmployeeByKey = {
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - number of employees - by location. */
export type ReportNumberOfEmployeeByLocation = ReportNumberOfEmployee & {
  __typename?: 'ReportNumberOfEmployeeByLocation';
  allIds: Array<Scalars['ID']['output']>;
  items: Array<ReportNumberOfEmployeeByLocationItemCountry>;
  maxDepth: Scalars['Int']['output'];
  total: Array<ReportNumberOfEmployeeMonthMetric>;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - number of employees - by location - dimension (country). */
export type ReportNumberOfEmployeeByLocationDimensionCountry = {
  __typename?: 'ReportNumberOfEmployeeByLocationDimensionCountry';
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryCode']['output']>;
};

/** Report - number of employees - by location - dimension (location). */
export type ReportNumberOfEmployeeByLocationDimensionLocation = {
  __typename?: 'ReportNumberOfEmployeeByLocationDimensionLocation';
  location: Location;
  locationId: Scalars['ID']['output'];
};

/** Report - number of employees - by location - item (country). */
export type ReportNumberOfEmployeeByLocationItemCountry = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByLocationItemCountry';
  children: Array<ReportNumberOfEmployeeByLocationItemLocation>;
  dimension: ReportNumberOfEmployeeByLocationDimensionCountry;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by location - item (location). */
export type ReportNumberOfEmployeeByLocationItemLocation = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByLocationItemLocation';
  dimension: ReportNumberOfEmployeeByLocationDimensionLocation;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by nationality. */
export type ReportNumberOfEmployeeByNationality = ReportNumberOfEmployee & {
  __typename?: 'ReportNumberOfEmployeeByNationality';
  allIds: Array<Scalars['ID']['output']>;
  items: Array<ReportNumberOfEmployeeByNationalityItemCountry>;
  maxDepth: Scalars['Int']['output'];
  total: Array<ReportNumberOfEmployeeMonthMetric>;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - number of employees - by nationality - dimension (company). */
export type ReportNumberOfEmployeeByNationalityDimensionCompany = {
  __typename?: 'ReportNumberOfEmployeeByNationalityDimensionCompany';
  company: Company;
  companyId: Scalars['ID']['output'];
};

/** Report - number of employees - by nationality - dimension (country). */
export type ReportNumberOfEmployeeByNationalityDimensionCountry = {
  __typename?: 'ReportNumberOfEmployeeByNationalityDimensionCountry';
  country: Country;
  countryId: Scalars['CountryCode']['output'];
};

/** Report - number of employees - by nationality - dimension (nationality). */
export type ReportNumberOfEmployeeByNationalityDimensionNationality = {
  __typename?: 'ReportNumberOfEmployeeByNationalityDimensionNationality';
  nationality?: Maybe<Country>;
  nationalityId?: Maybe<Scalars['CountryCode']['output']>;
};

/** Report - number of employees - by nationality - item (company). */
export type ReportNumberOfEmployeeByNationalityItemCompany = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByNationalityItemCompany';
  children: Array<ReportNumberOfEmployeeByNationalityItemNationality>;
  dimension: ReportNumberOfEmployeeByNationalityDimensionCompany;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by nationality - item (country). */
export type ReportNumberOfEmployeeByNationalityItemCountry = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByNationalityItemCountry';
  children: Array<ReportNumberOfEmployeeByNationalityItemCompany>;
  dimension: ReportNumberOfEmployeeByNationalityDimensionCountry;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - by nationality - item (nationality). */
export type ReportNumberOfEmployeeByNationalityItemNationality = ReportNumberOfEmployeeItem & {
  __typename?: 'ReportNumberOfEmployeeByNationalityItemNationality';
  dimension: ReportNumberOfEmployeeByNationalityDimensionNationality;
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

export type ReportNumberOfEmployeeByYearHalf = {
  fteTotal: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
  periodList: Array<ManagerialAccountingPeriod>;
};

/** Filter for number-of-employee company/business-unit/department report. */
export type ReportNumberOfEmployeeCompanyBusinessUnitDepartmentFilterInput = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endYearMonth: Scalars['YearMonth']['input'];
  startYearMonth: Scalars['YearMonth']['input'];
};

/** Filter for number-of-employee company/business-unit/job report. */
export type ReportNumberOfEmployeeCompanyBusinessUnitJobFilterInput = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  endYearMonth: Scalars['YearMonth']['input'];
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startYearMonth: Scalars['YearMonth']['input'];
};

/** Filter for number-of-employee company report. */
export type ReportNumberOfEmployeeCompanyFilterInput = {
  contractTypes?: InputMaybe<Array<ContractType>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  endYearMonth: Scalars['YearMonth']['input'];
  startYearMonth: Scalars['YearMonth']['input'];
};

/** Report - number of employees - by Allocation Key - dimension. */
export type ReportNumberOfEmployeeDimensionAllocationKey = {
  __typename?: 'ReportNumberOfEmployeeDimensionAllocationKey';
  allocationKey: EpmMasterAllocationKey;
  allocationKeyId: Scalars['ID']['output'];
};

/** Report - number of employees - by Functionality - dimension. */
export type ReportNumberOfEmployeeDimensionFunctionality = {
  __typename?: 'ReportNumberOfEmployeeDimensionFunctionality';
  functionality: EpmMasterFunctionality;
  functionalityId: Scalars['ID']['output'];
};

/** Report - number of employees - by Role Type - dimension. */
export type ReportNumberOfEmployeeDimensionRoleType = {
  __typename?: 'ReportNumberOfEmployeeDimensionRoleType';
  roleType: EpmMasterRoleType;
  roleTypeId: Scalars['ID']['output'];
};

/** Report - number of employees - by VDP/VDD - dimension. */
export type ReportNumberOfEmployeeDimensionVdd = {
  __typename?: 'ReportNumberOfEmployeeDimensionVdd';
  valueDeliveredDepartment: EpmMasterVdd;
  valueDeliveredDepartmentId: Scalars['ID']['output'];
};

/** Report - number of employees - by VDP/VDD - dimension. */
export type ReportNumberOfEmployeeDimensionVdp = {
  __typename?: 'ReportNumberOfEmployeeDimensionVdp';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['ID']['output']>;
  sourceType: EpmVdpSourceType;
};

/** Report - number of employees - item. */
export type ReportNumberOfEmployeeItem = {
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
};

/** Report - number of employees - item (Year/Half). */
export type ReportNumberOfEmployeeItemByYearHalf = {
  id: Scalars['ID']['output'];
  metrics: Array<ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod>;
};

/** Filter for number-of-employee job report. */
export type ReportNumberOfEmployeeJobFilterInput = {
  contractTypes?: InputMaybe<Array<ContractType>>;
  endYearMonth: Scalars['YearMonth']['input'];
  startYearMonth: Scalars['YearMonth']['input'];
};

/** Filter for number-of-employee location report. */
export type ReportNumberOfEmployeeLocationFilterInput = {
  contractTypes?: InputMaybe<Array<ContractType>>;
  endYearMonth: Scalars['YearMonth']['input'];
  startYearMonth: Scalars['YearMonth']['input'];
};

/** A single period FTE value within a composite item. */
export type ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod = {
  __typename?: 'ReportNumberOfEmployeeMetricsByManagerialAccountingPeriod';
  period: ManagerialAccountingPeriod;
  total: Scalars['BigDecimal']['output'];
};

/** Report - number of employees - monthly metric. */
export type ReportNumberOfEmployeeMonthMetric = {
  __typename?: 'ReportNumberOfEmployeeMonthMetric';
  count: Scalars['BigDecimal']['output'];
  yearMonth: Scalars['YearMonth']['output'];
};

/** Filter for number-of-employee nationality report. */
export type ReportNumberOfEmployeeNationalityFilterInput = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  endYearMonth: Scalars['YearMonth']['input'];
  startYearMonth: Scalars['YearMonth']['input'];
};

/** Report - turnover. */
export type ReportNumberOfEmployeeTurnover = ReportNumberOfEmployeeByKey & {
  __typename?: 'ReportNumberOfEmployeeTurnover';
  items: Array<ReportNumberOfEmployeeTurnoverByCompany>;
  yearMonthList: Array<Scalars['YearMonth']['output']>;
};

/** Report - turnover - by company. */
export type ReportNumberOfEmployeeTurnoverByCompany = {
  __typename?: 'ReportNumberOfEmployeeTurnoverByCompany';
  byYearMonth: Array<ReportNumberOfEmployeeTurnoverByCompanyYearMonth>;
  company: Company;
  companyId: Scalars['ID']['output'];
  country: Country;
  countryId: Scalars['CountryCode']['output'];
  subtotal: ReportNumberOfEmployeeTurnoverByCompanySubtotal;
};

/** Report - turnover - subtotal. */
export type ReportNumberOfEmployeeTurnoverByCompanySubtotal = {
  __typename?: 'ReportNumberOfEmployeeTurnoverByCompanySubtotal';
  joined: Scalars['BigDecimal']['output'];
  left: Scalars['BigDecimal']['output'];
  total: Scalars['BigDecimal']['output'];
  turnOverRate?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Report - turnover - by year/month. */
export type ReportNumberOfEmployeeTurnoverByCompanyYearMonth = {
  __typename?: 'ReportNumberOfEmployeeTurnoverByCompanyYearMonth';
  joined: Scalars['BigDecimal']['output'];
  left: Scalars['BigDecimal']['output'];
  total: Scalars['BigDecimal']['output'];
  turnOverRate?: Maybe<Scalars['BigDecimal']['output']>;
  yearMonth: Scalars['YearMonth']['output'];
};

/** Filter for turnover report. */
export type ReportNumberOfEmployeeTurnoverFilterInput = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTypes?: InputMaybe<Array<ContractType>>;
  countryIds?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  endYearMonth: Scalars['YearMonth']['input'];
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reasonForLeavingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startYearMonth: Scalars['YearMonth']['input'];
};

/** Filter for VDP/VDD report. */
export type ReportNumberOfEmployeeVdFilterInput = {
  end: ManagerialAccountingPeriodInput;
  start: ManagerialAccountingPeriodInput;
};

/** Input to replace a period's tabulation settings for the countries listed on the screen. */
export type SavePerformanceReviewTabulationSettingInput = {
  countries: Array<TabulationCountryInput>;
  period: PerformanceReviewPeriodInput;
};

/** Input type to send invitation emails */
export type SendInvitationEmailsInput = {
  employeeIds: Array<Scalars['ID']['input']>;
};

export type SignInCallback = SignInCallbackError | SignInCallbackSuccess;

export type SignInCallbackError = {
  __typename?: 'SignInCallbackError';
  /** Why the sign-in failed, for choosing what to show the user. */
  errorCode: SignInCallbackErrorCode;
  /** Technical description of the failure, for logs and debugging; not meant to be shown to the user. */
  errorMessage: Scalars['String']['output'];
};

/** Reason a sign-in callback failed. */
export enum SignInCallbackErrorCode {
  /** Any other failure, such as an authentication or internal error. */
  Other = 'OTHER',
  /** The sign-in cannot be completed and must be started again from the sign-in page. */
  SignInRestartRequired = 'SIGN_IN_RESTART_REQUIRED',
  /** The Google account does not belong to a registered employee. */
  UserNotFound = 'USER_NOT_FOUND',
}

export type SignInCallbackSuccess = {
  __typename?: 'SignInCallbackSuccess';
  accessToken: Scalars['String']['output'];
};

/** Input type for the reviewer to submit one review (stage) of a probation review. */
export type SubmitProbationReviewStageInput = {
  assessments?: InputMaybe<Array<UpdateProbationReviewStageAssessmentInput>>;
  /** A new Due Date for the review; omitted keeps the stored one. */
  deadline?: InputMaybe<Scalars['Date']['input']>;
  employeeId: Scalars['ID']['input'];
  /** Required with the first submission; ignored afterwards. */
  expectation?: InputMaybe<Scalars['String']['input']>;
  /** 0-based index of the review to submit. */
  index: Scalars['Int']['input'];
  reviewerFeedback: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Stream live progress for all of the calling user's in-flight Employee export jobs. */
  exportProgressEmployee: Array<EmployeeExportProgress>;
  /** Stream live progress for all of the calling user's in-flight External Account export jobs. */
  exportProgressExternalAccount: Array<ExternalAccountExportProgress>;
  /** Stream live progress for all of the calling user's in-flight Number-of-Employee export jobs. */
  exportProgressNumberOfEmployee: Array<NumberOfEmployeeExportProgress>;
  /** Stream live progress for all of the calling user's in-flight Performance Review export jobs matching `types`. */
  exportProgressPerformanceReview: Array<PerformanceReviewExportProgress>;
  /** Stream live progress for all of the calling user's in-flight Probation Review export jobs. */
  exportProgressProbationReview: Array<ProbationReviewExportProgress>;
  /** Streams whether this IDP currently has a pending PDF generation, polling every 5 seconds. */
  idpPdfGenerationPending: Scalars['Boolean']['output'];
  /** Stream live progress for all of the calling user's in-flight import jobs (Employee and Managerial Accounting). */
  importProgress: Array<ExportImportProgress>;
  /** Stream a chat response from the AI assistant - Performance Review My Mission. */
  streamChatPerformanceReviewMyMission: AiChatChunk;
};

export type SubscriptionExportProgressPerformanceReviewArgs = {
  types: Array<PerformanceReviewExportType>;
};

export type SubscriptionIdpPdfGenerationPendingArgs = {
  idpId: Scalars['ID']['input'];
};

export type SubscriptionStreamChatPerformanceReviewMyMissionArgs = {
  message: Scalars['String']['input'];
  performanceReviewId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

/** A company-specific rule. Only companies whose switch is on are submitted. */
export type TabulationCompanyInput = {
  companyId: Scalars['ID']['input'];
  setting: TabulationRuleInput;
};

/** A company under a country. A null setting means the company has no company-specific rule. */
export type TabulationCompanySection = {
  __typename?: 'TabulationCompanySection';
  company: Company;
  companyId: Scalars['ID']['output'];
  setting?: Maybe<TabulationRule>;
};

/** A country's country-wide rule and its company-specific rules. */
export type TabulationCountryInput = {
  companies: Array<TabulationCompanyInput>;
  countryId: Scalars['CountryCode']['input'];
  setting: TabulationRuleInput;
};

/** A country with at least one employee active during the period. A null setting means the period has no country-wide rule for this country yet. */
export type TabulationCountrySection = {
  __typename?: 'TabulationCountrySection';
  companies: Array<TabulationCompanySection>;
  country: Country;
  countryId: Scalars['CountryCode']['output'];
  setting?: Maybe<TabulationRule>;
};

/** The latest hire date an employee may have to be counted in Performance Review tabulation. */
export type TabulationHiredDateLimit = {
  __typename?: 'TabulationHiredDateLimit';
  /** The resolved date. Set for relative and absolute limits, null when there is no limit. */
  date?: Maybe<Scalars['Date']['output']>;
  kind: HiredDateLimitKind;
  /** Number of months before the period start. Set only for a relative limit. */
  monthsBefore?: Maybe<Scalars['Int']['output']>;
};

/** The latest hire date an employee may have to be counted. RELATIVE needs monthsBefore of at least 0, ABSOLUTE needs date, NONE takes neither. */
export type TabulationHiredDateLimitInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  kind: HiredDateLimitKind;
  monthsBefore?: InputMaybe<Scalars['Int']['input']>;
};

/** Which employees are counted in Performance Review tabulation. */
export type TabulationRule = {
  __typename?: 'TabulationRule';
  contractTypes: Array<ContractType>;
  hiredDateLimit: TabulationHiredDateLimit;
};

/** Which employees are counted. An empty contract type list excludes the country or company from tabulation. */
export type TabulationRuleInput = {
  contractTypes: Array<ContractType>;
  hiredDateLimit: TabulationHiredDateLimitInput;
};

/** An absolute hire date limit that is unchanged from the previous period. */
export type TabulationStaleAbsoluteDate = {
  __typename?: 'TabulationStaleAbsoluteDate';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['ID']['output']>;
  country: Country;
  countryId: Scalars['CountryCode']['output'];
};

/** One employee job history record matching a Team job history screen query - the literal Team value on this specific record may differ row-to-row within one screen's results, since the screen shows every value in a Likely-duplicates cluster together. */
export type TeamJobHistory = {
  __typename?: 'TeamJobHistory';
  businessUnit: BusinessUnit;
  department: Department;
  /** Renders as a checkmark icon when true, an empty cell when false. */
  departmentLead: Scalars['Boolean']['output'];
  effectiveDate: Scalars['Date']['output'];
  effectiveDateUntil?: Maybe<Scalars['Date']['output']>;
  employee: Employee;
  job: Job;
  /** employee_job_history's own primary key - used by the frontend as the row-selection key for Merge, so a checked row stays selected across this screen's server-side pagination. */
  jobHistoryId: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  level: JobHistoryLevel;
  location: Location;
  /** Renders as a checkmark icon when true, an empty cell when false. */
  regionalRole: Scalars['Boolean']['output'];
  /** Computed from effectiveDate/effectiveDateUntil vs. today - NOT a stored value. FUTURE when effectiveDate is after today; CURRENT when effectiveDate is on or before today AND (effectiveDateUntil is unset or on or after today); PAST when effectiveDateUntil is before today. */
  status: JobHistoryStatus;
  team: Scalars['String']['output'];
};

/** Server-side filter for teamJobHistories. countryId is required - this screen always has exactly one fixed Country. Every other field is optional; an omitted or empty list applies no filter for that field. Multiple selected values within one field are OR'd together; different fields combine with AND. */
export type TeamJobHistoryFilterInput = {
  /** Required - same three-value semantics as teamValueClusters' blankVisibility argument: HIDE excludes the blank Team value entirely; HIDE_PAST excludes only its Past-classified records; SHOW_ALL applies no filtering. */
  blankVisibility: BlankTeamValueVisibility;
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Derived from each record's own location (employee_job_history.location_id -> location.country_id), NOT the employee's present-day location/company - row-accurate for historical and future-dated records alike. Required - this screen has no unscoped/global state. */
  countryId: Scalars['CountryCode']['input'];
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Matches TeamJobHistory.status. */
  statuses?: InputMaybe<Array<JobHistoryStatus>>;
};

/** Paginated result wrapper for teamJobHistories. */
export type TeamJobHistoryList = {
  __typename?: 'TeamJobHistoryList';
  items: Array<TeamJobHistory>;
  totalCount: Scalars['Int']['output'];
};

/** One distinct literal value currently found in an employee's job history Team field, and how many employee job history records (current and historical) carry it - a row count, not deduplicated by employee. */
export type TeamValue = {
  __typename?: 'TeamValue';
  recordCount: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

/** A cluster of TeamValues judged likely to represent the same real team - either exact once whitespace/width/case/an optional "Team"/"チーム" suffix are normalized away, or a likely misspelling of another member. Every TeamValue belongs to exactly one cluster; a value with no detected relatives is a cluster of size 1. Recomputed on every query - not a stored identity. */
export type TeamValueCluster = {
  __typename?: 'TeamValueCluster';
  values: Array<TeamValue>;
};

export type TeamWriteOutput = {
  __typename?: 'TeamWriteOutput';
  canonicalValue: Scalars['String']['output'];
  /** Total number of employee job history records whose Team value was changed by this operation. */
  updatedRecordCount: Scalars['Int']['output'];
};

export type UpdateAiAssistantConfigurationInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  systemInstruction: Scalars['String']['input'];
};

export type UpdateAiAssistantConfigurationOutput = {
  __typename?: 'UpdateAIAssistantConfigurationOutput';
  id: Scalars['ID']['output'];
};

/** Input type to update a business unit. */
export type UpdateBusinessUnitInput = {
  defaultEpmMasterRoleTypeId?: InputMaybe<Scalars['ID']['input']>;
  definitions?: InputMaybe<Array<DefinitionInput>>;
  divisionId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  vddId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input type to update a company domain email. */
export type UpdateCompanyEmailDomainInput = {
  disableExternalAccount: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

/** Input type to update a company. */
export type UpdateCompanyInput = {
  acquiredDate?: InputMaybe<Scalars['Date']['input']>;
  countryId: Scalars['CountryCode']['input'];
  createPerformanceReviewAutomatically: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  googleOrgUnitPath: Scalars['String']['input'];
  hrEmailAddress: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  jobTitleCanBeEmpty: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  parentCompanyId?: InputMaybe<Scalars['ID']['input']>;
  preferredLanguage: Scalars['String']['input'];
  probationReviewTerm: CompanyProbationReviewTermInput;
  probationReviewTimes: Scalars['Int']['input'];
  slackTeamId?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to update a department. */
export type UpdateDepartmentInput = {
  definitions?: InputMaybe<Array<DefinitionInput>>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Input type to update a division. */
export type UpdateDivisionInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Input type to update an employee contract */
export type UpdateEmployeeContractInput = {
  companyId: Scalars['ID']['input'];
  contractType: ContractType;
  effectiveDate: Scalars['Date']['input'];
  effectiveDateUntil?: InputMaybe<Scalars['Date']['input']>;
  employeeCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isMain: Scalars['Boolean']['input'];
  isPreAcquisition: Scalars['Boolean']['input'];
  onSecondment: Scalars['Boolean']['input'];
};

/** Input type to update an employee contract note */
export type UpdateEmployeeContractNoteInput = {
  employeeId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

/** Input type to update an employee current job position */
export type UpdateEmployeeCurrentJobPositionInput = {
  departmentLead: Scalars['Boolean']['input'];
  employeeId: Scalars['ID']['input'];
};

/** Input type to update an employee's personal information - dependent. */
export type UpdateEmployeeDependentInput = {
  dateOfBirth: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  relation: DependentRelation;
};

/** Input type to update an employee's personal information - emergency contact. */
export type UpdateEmployeeEmergencyContactInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phoneNumber: PhoneNumberInput;
  relation: EmergencyContactRelation;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to update an employee - general information. */
export type UpdateEmployeeGeneralInformationInput = {
  companyEmail?: InputMaybe<EmployeeCompanyEmailInput>;
  dottedLineManagerId?: InputMaybe<Scalars['ID']['input']>;
  employeeId: Scalars['ID']['input'];
  greenhouseLink?: InputMaybe<Scalars['Url']['input']>;
  hiredDate: Scalars['Date']['input'];
  hiringSource?: InputMaybe<EmployeeHiringSource>;
  isNewGraduate: Scalars['Boolean']['input'];
  japanesePhoneticName?: InputMaybe<Scalars['String']['input']>;
  legalFullName: Scalars['String']['input'];
  nameInLocalLanguage?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['CountryCode']['input']>;
  needsProbationReview: Scalars['Boolean']['input'];
  preferredFullName: Scalars['String']['input'];
  primaryManagerId: Scalars['ID']['input'];
  probationReviewEndDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Update auto-populated snapshot fields. Allowed only while the IDP is in DRAFT status. */
export type UpdateEmployeeIdpDraftFieldsInput = {
  companyId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  hrRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  idpId: Scalars['ID']['input'];
  jobTitle: Scalars['String']['input'];
  level: JobHistoryLevel;
  lineManagerId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};

/** Hide or unhide an IDP from its subject employee's own Dashboard widget and Employee Detail tab. */
export type UpdateEmployeeIdpHiddenFromEmployeeInput = {
  hidden: Scalars['Boolean']['input'];
  idpId: Scalars['ID']['input'];
};

/** Update the Line Manager, HR Representative, and Notes together. Line Manager and HR Representative are editable through any status up to COMPLETED_*. Notes is independently re-authorized on every call (the same check as the Notes query field): when the caller lacks Notes access for this record, the Notes value is silently ignored and the stored value is left unchanged, regardless of what is passed here. */
export type UpdateEmployeeIdpInput = {
  hrRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  idpId: Scalars['ID']['input'];
  lineManagerId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Key area update entry. Omit id to insert a new key area (upsert). */
export type UpdateEmployeeIdpKeyAreaInput = {
  additionalSupportNeeded: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  performanceRecoveryArea: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
  successCriteria: Scalars['String']['input'];
};

/** Update key area text fields. Blocked once the IDP is confirmed. */
export type UpdateEmployeeIdpKeyAreasInput = {
  idpId: Scalars['ID']['input'];
  keyAreas: Array<UpdateEmployeeIdpKeyAreaInput>;
};

/** Change an IDP's start date while it is unconfirmed. Recalculates end date and review deadline. */
export type UpdateEmployeeIdpStartDateInput = {
  idpId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};

/** Input type to update an employee job history */
export type UpdateEmployeeJobHistoryInput = {
  businessUnitId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
  departmentLead: Scalars['Boolean']['input'];
  effectiveDate: Scalars['Date']['input'];
  effectiveDateUntil?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  level: JobHistoryLevel;
  locationId: Scalars['ID']['input'];
  /** Note for extended leave. This is ignored when `type` is not for extended leave. */
  note?: InputMaybe<Scalars['String']['input']>;
  regionalRole: Scalars['Boolean']['input'];
  team?: InputMaybe<Scalars['String']['input']>;
  type: JobHistoryType;
};

/** Input type to update an employee job history note */
export type UpdateEmployeeJobHistoryNoteInput = {
  employeeId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

/** Input type to update an employee list custom filter. */
export type UpdateEmployeeListCustomFilterInput = {
  businessUnitIds: Array<Scalars['ID']['input']>;
  companyIds: Array<Scalars['ID']['input']>;
  contractTypes: Array<ContractType>;
  departmentIds: Array<Scalars['ID']['input']>;
  divisionIds: Array<Scalars['ID']['input']>;
  employmentEndDate?: InputMaybe<LocalDateRangeInput>;
  externalAccountEloomi: Array<EmployeeExternalAccountStatus>;
  externalAccountGithub?: InputMaybe<Array<EmployeeExternalAccountStatus>>;
  externalAccountGoogle: Array<EmployeeExternalAccountStatus>;
  externalAccountGreenhouse: Array<EmployeeExternalAccountStatus>;
  externalAccountHubspot: Array<EmployeeExternalAccountStatus>;
  externalAccountSlack: Array<EmployeeExternalAccountStatus>;
  hiredDate?: InputMaybe<LocalDateRangeInput>;
  id: Scalars['ID']['input'];
  isExactMatch: Scalars['Boolean']['input'];
  isLeave?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSecondment?: InputMaybe<Scalars['Boolean']['input']>;
  isOpenFilter: Scalars['Boolean']['input'];
  jobIds: Array<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  lastWorkingDate?: InputMaybe<LocalDateRangeInput>;
  levels: Array<JobHistoryLevel>;
  locationIds: Array<Scalars['ID']['input']>;
  managerIds: Array<Scalars['ID']['input']>;
  managerIncludesAllConnections: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  nationalityIds: Array<Scalars['CountryCode']['input']>;
  rehireRecommendations?: InputMaybe<Array<RehireRecommendation>>;
  replacementValues?: InputMaybe<Array<ReplacementValue>>;
  roles: Array<EmployeeRole>;
  statuses: Array<EmployeeStatus>;
  team?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to update an employee's off boarding - do not deactivate. */
export type UpdateEmployeeOffBoardingDoNotDeactivateInput = {
  eloomi: Scalars['Boolean']['input'];
  google: Scalars['Boolean']['input'];
  greenhouse: Scalars['Boolean']['input'];
};

/** Input type to update an employee's off boarding. */
export type UpdateEmployeeOffBoardingInput = {
  detailReasonForLeaving?: InputMaybe<Scalars['String']['input']>;
  directReportManagerChangeReservations?: InputMaybe<Array<DirectReportManagerChangeInput>>;
  doNotDeactivate: UpdateEmployeeOffBoardingDoNotDeactivateInput;
  employeeId: Scalars['ID']['input'];
  employmentEndDate?: InputMaybe<Scalars['Date']['input']>;
  lastWorkingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Performance Review period from which the employee is excluded. Omit (or send null) to keep the stored period, moved to follow a changed Last working date; send an object with a null period to clear it. */
  performanceReviewExclusion?: InputMaybe<PerformanceReviewExclusionChoiceInput>;
  reasonForLeavingId?: InputMaybe<Scalars['ID']['input']>;
  rehireConditionNote?: InputMaybe<Scalars['String']['input']>;
  rehireConditions?: InputMaybe<Array<RehireConditionTag>>;
  rehireRecommendation?: InputMaybe<RehireRecommendation>;
  replacementValue?: InputMaybe<ReplacementValue>;
  replacementValueBasis?: InputMaybe<Array<ReplacementValueBasisTag>>;
};

/** Input type to update an employee's permission. */
export type UpdateEmployeePermissionInput = {
  companyIds: Array<Scalars['ID']['input']>;
  employeeId: Scalars['ID']['input'];
  employeeIds: Array<Scalars['ID']['input']>;
  /** Whether this ADMIN_PRIVATE employee has unrestricted IDP visibility scope. Only meaningful when role == ADMIN_PRIVATE; silently ignored (coerced to false) for every other role. */
  idpFullAccess: Scalars['Boolean']['input'];
  role: EmployeeRole;
};

/** Input type to update an employee - personal information. */
export type UpdateEmployeePersonalInformationInput = {
  bank?: InputMaybe<EmployeeBankInput>;
  consultingFeeBank?: InputMaybe<EmployeeConsultingFeeBankInput>;
  currentAddress?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  employeeId: Scalars['ID']['input'];
  gender: EmployeeGender;
  idExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  idIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  idIssuedPlace?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<EmployeeIdType>;
  maritalStatus?: InputMaybe<EmployeeMaritalStatus>;
  nhiDependents?: InputMaybe<Scalars['Int']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  passportIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  passportIssuedPlace?: InputMaybe<Scalars['String']['input']>;
  passportName?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPlaceOfBirth?: InputMaybe<Scalars['String']['input']>;
  pensionVoluntaryContributionRate?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<Scalars['String']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  personalPhoneNumber?: InputMaybe<PhoneNumberInput>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  residentialCountryId: Scalars['CountryCode']['input'];
  socialInsuranceNotes?: InputMaybe<Scalars['String']['input']>;
  socialInsuranceNumber?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  taxWithholdingRate?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to update an employee's personal information - visa. */
export type UpdateEmployeeVisaInput = {
  id: Scalars['ID']['input'];
  visaExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  visaIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  visaIssuedPlace?: InputMaybe<Scalars['String']['input']>;
  visaNumber?: InputMaybe<Scalars['String']['input']>;
  visaType?: InputMaybe<Scalars['String']['input']>;
  workPermitExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  workPermitIssuedDate?: InputMaybe<Scalars['Date']['input']>;
  workPermitNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to update an EpmMasterAllocationKey entry. */
export type UpdateEpmMasterAllocationKeyInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Input type to update an EpmMasterFunctionality entry. */
export type UpdateEpmMasterFunctionalityInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Input type to update an EpmMasterRoleType entry. */
export type UpdateEpmMasterRoleTypeInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Input type to update an EpmMasterVdd entry. */
export type UpdateEpmMasterVddInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Input type to update a job. */
export type UpdateJobInput = {
  defaultEpmMasterFunctionalityId?: InputMaybe<Scalars['ID']['input']>;
  definitions: Array<DefinitionInput>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Input type to update a language. */
export type UpdateLanguageInput = {
  code: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
};

/** Input type to update a location. */
export type UpdateLocationInput = {
  countryId?: InputMaybe<Scalars['CountryCode']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Input type to update notification option (custom dates). */
export type UpdateNotificationOptionCustomDatesInput = {
  enabled: Scalars['Boolean']['input'];
  notifiedDates: Array<NotificationDate>;
  notifiedUsers: Array<NotificationUser>;
};

/** Input type to update notification option (static dates). */
export type UpdateNotificationOptionStaticDatesInput = {
  enabled: Scalars['Boolean']['input'];
  notifiedUsers: Array<NotificationUser>;
};

/** Input type to update a notification setting. */
export type UpdateNotificationSettingInput = {
  companyId: Scalars['ID']['input'];
  contractEndDate: UpdateNotificationOptionCustomDatesInput;
  employmentEndDate: UpdateNotificationOptionCustomDatesInput;
  idExpiryDate: UpdateNotificationOptionCustomDatesInput;
  lastWorkingDate: UpdateNotificationOptionCustomDatesInput;
  passportExpiryDate: UpdateNotificationOptionCustomDatesInput;
  probationReviewDeadlineForEach: UpdateNotificationOptionCustomDatesInput;
  probationReviewResult: UpdateNotificationOptionStaticDatesInput;
  probationReviewScheduledEndDate: UpdateNotificationOptionStaticDatesInput;
  returnFromExtendedLeave: UpdateNotificationOptionCustomDatesInput;
  /** only for Japan [countryId = "JP"] */
  sixMonthServiceCompletion?: InputMaybe<UpdateNotificationOptionStaticDatesInput>;
  visaExpiryDate: UpdateNotificationOptionCustomDatesInput;
  workPermitExpiryDate: UpdateNotificationOptionCustomDatesInput;
};

/** Input type to update performance review notification setting. */
export type UpdatePerformanceReviewCompanyNotificationInput = {
  companyId: Scalars['ID']['input'];
  isSlackNotificationEnabled: Scalars['Boolean']['input'];
};

/** Input type to update a performance review - My Development Plan V1 for Target Evaluation. */
export type UpdatePerformanceReviewMyDevelopmentPlanV1ForTargetEvaluationInput = {
  assessment?: InputMaybe<Scalars['Int']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** `PerformanceReview.id` */
  id: Scalars['ID']['input'];
};

/** Input type to update a performance review - My Development Plan V1 for Target Setting. */
export type UpdatePerformanceReviewMyDevelopmentPlanV1ForTargetSettingInput = {
  developmentPlan?: InputMaybe<Scalars['String']['input']>;
  /** `PerformanceReview.id` */
  id: Scalars['ID']['input'];
};

/** Input type to update a performance review - My Development Plan v2 for Target Evaluation. */
export type UpdatePerformanceReviewMyDevelopmentPlanV2ForTargetEvaluationInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** `PerformanceReview.id` */
  id: Scalars['ID']['input'];
};

/** Input type to update a performance review - My Development Plan v2 for Target Setting. */
export type UpdatePerformanceReviewMyDevelopmentPlanV2ForTargetSettingInput = {
  behavioralPractices?: InputMaybe<Scalars['String']['input']>;
  capabilityToDevelop?: InputMaybe<Scalars['String']['input']>;
  howMyDevelopmentSuccessLooks?: InputMaybe<Scalars['String']['input']>;
  /** `PerformanceReview.id` */
  id: Scalars['ID']['input'];
  managerOrganizationalSupportNeeded?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to update a performance review - My Mission - Numeric sales - Approve edit actual amount request. */
export type UpdatePerformanceReviewMyMissionApproveEditActualAmountRequestInput = {
  approved: Scalars['Boolean']['input'];
  performanceReviewTargetId: Scalars['ID']['input'];
};

/** Input type to update a performance review - My Mission - Numeric sales type request. */
export type UpdatePerformanceReviewMyMissionNumericSalesTypeRequestInput = {
  /** `PerformanceReview.id` */
  id: Scalars['ID']['input'];
};

/** Input type to update a performance review - My Mission - Primary Manager General Feedback. */
export type UpdatePerformanceReviewMyMissionPrimaryManagerGeneralFeedbackInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** `PerformanceReview.id` */
  id: Scalars['ID']['input'];
};

/** Input type to update a performance review - Setting. */
export type UpdatePerformanceReviewSettingInput = {
  /** `PerformanceReview.id` */
  id: Scalars['ID']['input'];
  stage: PerformanceReviewStage;
  useMarkdown: Scalars['Boolean']['input'];
};

/** Input type to update a performance review target (Target Evaluation) - Target with Multiple Missions. */
export type UpdatePerformanceReviewTargetForTargetEvaluationMultipleMissionsInput = {
  assessment?: InputMaybe<Scalars['Int']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** `PerformanceReviewTarget.id` */
  id: Scalars['ID']['input'];
};

/** Input type to update a performance review target (Target Evaluation) - Numeric (Monthly). */
export type UpdatePerformanceReviewTargetForTargetEvaluationNumericMonthlyInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** `PerformanceReviewTarget.id` */
  id: Scalars['ID']['input'];
  targets: Array<UpdatePerformanceReviewTargetForTargetEvaluationNumericMonthlyItemInput>;
};

/** Input type to update a performance review target (Target Evaluation) - Numeric (Monthly) - Item. */
export type UpdatePerformanceReviewTargetForTargetEvaluationNumericMonthlyItemInput = {
  actual: Scalars['BigDecimal']['input'];
  yearMonth: Scalars['Date']['input'];
};

/** Input type to update a performance review target (Target Evaluation) - Numeric (Sales - Gross Profit / Revenue). */
export type UpdatePerformanceReviewTargetForTargetEvaluationNumericSalesInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** `PerformanceReviewTarget.id` */
  id: Scalars['ID']['input'];
  items: Array<UpdatePerformanceReviewTargetForTargetEvaluationNumericSalesItemInput>;
};

/** Input type to update a performance review target (Target Evaluation) - Numeric (Sales - Gross Profit / Revenue) - Item. */
export type UpdatePerformanceReviewTargetForTargetEvaluationNumericSalesItemInput = {
  actualOverriddenEvidence?: InputMaybe<Scalars['String']['input']>;
  /** ID of the existing performance review target numeric sales item. */
  id: Scalars['ID']['input'];
  targets: Array<UpdatePerformanceReviewTargetForTargetEvaluationNumericSalesItemTargetInput>;
};

/** Input type to update a performance review target (Target Evaluation) - Numeric (Sales - Gross Profit / Revenue) - Item - Target. */
export type UpdatePerformanceReviewTargetForTargetEvaluationNumericSalesItemTargetInput = {
  actual: PerformanceReviewTargetInput;
  rebate?: InputMaybe<Scalars['BigDecimal']['input']>;
  yearMonth: Scalars['Date']['input'];
};

/** Input type to update a performance review target (Target Evaluation) - Numeric (Total). */
export type UpdatePerformanceReviewTargetForTargetEvaluationNumericTotalInput = {
  actual: Scalars['BigDecimal']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** `PerformanceReviewTarget.id` */
  id: Scalars['ID']['input'];
};

/** Input type to update a performance review target (Target Setting) - Target with Multiple Missions. */
export type UpdatePerformanceReviewTargetForTargetSettingMultipleMissionsInput = {
  description: Scalars['String']['input'];
  /** `PerformanceReviewTarget.id` */
  id: Scalars['ID']['input'];
  myMissionObjective: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

/** Input type to update a performance review target (Target Setting) - Numeric (Monthly). */
export type UpdatePerformanceReviewTargetForTargetSettingNumericMonthlyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  direction: PerformanceReviewTargetDirection;
  /** `PerformanceReviewTarget.id` */
  id: Scalars['ID']['input'];
  myMission: Scalars['String']['input'];
  myMissionObjective?: InputMaybe<Scalars['String']['input']>;
  targets: Array<UpdatePerformanceReviewTargetForTargetSettingNumericMonthlyItemInput>;
  unit: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

/** Input type to update a performance review target (Target Setting) - Numeric (Monthly) - Item. */
export type UpdatePerformanceReviewTargetForTargetSettingNumericMonthlyItemInput = {
  target: Scalars['BigDecimal']['input'];
  yearMonth: Scalars['Date']['input'];
};

/** Input type to update a performance review target (Target Setting) - Numeric (Sales - Gross Profit / Revenue). */
export type UpdatePerformanceReviewTargetForTargetSettingNumericSalesInput = {
  /** `PerformanceReviewTarget.id` */
  id: Scalars['ID']['input'];
  items: Array<UpdatePerformanceReviewTargetForTargetSettingNumericSalesItemInput>;
  targetType: PerformanceReviewTargetNumericSalesType;
  weightGrossProfit: Scalars['Int']['input'];
  weightRevenue: Scalars['Int']['input'];
};

/** Input type to update a performance review target (Target Setting) - Numeric (Sales - Gross Profit / Revenue) - Item. */
export type UpdatePerformanceReviewTargetForTargetSettingNumericSalesItemInput = {
  currencyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hubspotPipelineId: Scalars['ID']['input'];
  /**
   * ID of the existing performance review target numeric sales item.
   * Pass `null` when creating a new item.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  targets: Array<UpdatePerformanceReviewTargetForTargetSettingNumericSalesItemTargetInput>;
};

/** Input type to update a performance review target (Target Setting) - Numeric (Sales - Gross Profit / Revenue) - Item - Target. */
export type UpdatePerformanceReviewTargetForTargetSettingNumericSalesItemTargetInput = {
  target: PerformanceReviewTargetInput;
  yearMonth: Scalars['Date']['input'];
};

/** Input type to update a performance review target (Target Setting) - Numeric (Total). */
export type UpdatePerformanceReviewTargetForTargetSettingNumericTotalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  direction: PerformanceReviewTargetDirection;
  /** `PerformanceReviewTarget.id` */
  id: Scalars['ID']['input'];
  myMission: Scalars['String']['input'];
  myMissionObjective?: InputMaybe<Scalars['String']['input']>;
  target: Scalars['BigDecimal']['input'];
  unit: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

/** Input type to update a performance review - Values. */
export type UpdatePerformanceReviewValuesInput = {
  /** `PerformanceReview.id` */
  id: Scalars['ID']['input'];
  values: Array<UpdatePerformanceReviewValuesValueInput>;
};

export type UpdatePerformanceReviewValuesValueInput = {
  assessment: Scalars['Int']['input'];
  type: AnyMindValueType;
};

export type UpdateProbationReviewStageAssessmentInput = {
  assessment?: InputMaybe<Scalars['Int']['input']>;
  type: AnyMindValueType;
};

/** Input type to update an off boarding - reason for leaving. */
export type UpdateReasonForLeavingInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Input for upserting VDP/VDD allocations for a given employee and half-year. Existing allocations for that period are replaced. */
export type UpsertEmployeeManagerialAccountingInput = {
  allocationKey: Array<EpmEmployeeAllocationKeyAllocationInput>;
  employeeId: Scalars['ID']['input'];
  functionality: Array<EpmEmployeeFunctionalityAllocationInput>;
  period: ManagerialAccountingPeriodInput;
  roleType: Array<EpmEmployeeRoleTypeAllocationInput>;
  vdd: Array<EpmEmployeeVddAllocationInput>;
  vdp: Array<EpmEmployeeVdpAllocationInput>;
};

/** Registers, replaces, or (with imageDataUrl: null) removes the caller's own signature. */
export type UpsertMyEmployeeSignatureInput = {
  /** Null removes the signature. Non-null must be a data URL, image/png or image/jpeg, <=1MB decoded, <=2000x1000px. */
  imageDataUrl?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<EmployeeSignatureSource>;
};

/** Input to upsert a Company / Business Unit / Department relation. */
export type UpsertOrgHierarchyRelationInput = {
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

/** Base64-encoded raw PDF bytes (no data-URL prefix), capped at 10MB decoded. */
export type VerifyIdpPdfInput = {
  pdfBase64: Scalars['String']['input'];
};
